import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  println2shhhgwwt4c61 as println,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  printStackTrace18lnx7a39cni as printStackTrace,
  getKClass1s3j9wy1cofik as getKClass,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  first58ocm7j58k3q as first,
  CoroutineContext3n9ge8bnnq7z2 as CoroutineContext,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  Duration5ynfiptaqcrg as Duration,
  listOfvhqybd2zx248 as listOf,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  CancellationException3b36o9qz53rgr as CancellationException,
  captureStack1fzi4aczwc4hg as captureStack,
  lazy2hsh8ze7j6ikd as lazy,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  emptyList1g2z5xcrvp2zy as emptyList,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  toList383f556t1dixk as toList,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty02ce7r476m8633 as KProperty0,
  THROW_ISE25y4rao9gcv5s as THROW_ISE,
  getLocalDelegateReferencenlta2y7wt3po as getLocalDelegateReference,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  numberToDouble210hrknaofnhf as numberToDouble,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  returnIfSuspendednggonvg9333x as returnIfSuspended,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  compareTo3ankvs086tmwq as compareTo,
  Comparator2b3maoeh98xtg as Comparator,
  sortWith4fnm6b3vw03s as sortWith,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  KtList3hktaavzmj137 as KtList,
  coerceAtMost322komnqp70ag as coerceAtMost,
  contains1tccixv8iwdcq as contains,
  Duration__times_impl_sfuzvp1gzave8ckyu1a as Duration__times_impl_sfuzvp,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  HashMap1a0ld5kgwhmhv as HashMap,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  replace3le3ie7l9k8aq as replace,
  KtMap140uvy3s5zad8 as KtMap,
  get_lastIndex327lnwnipm748 as get_lastIndex,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  getOrNull1d60i0672n7ns as getOrNull,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_0,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  Companion_getInstancet6d3dkp9rzuf as Companion_getInstance_1,
  AsyncSignal3p186s2w7f15b as AsyncSignal,
  Signal3nnez3346azzf as Signal,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope1245ljoj2flcu as coroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  cancel2en0dn4yvpufo as cancel,
  Key_instance2expa55gr45sc as Key_instance,
  TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException,
  withTimeout2wixyx2dhn9kz as withTimeout,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
} from './kotlinx-coroutines-core.mjs';
import {
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  RGBA34obx2i62wcl3 as RGBA,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  readBitmapdk80pcjw6p8f as readBitmap,
  Bitmaps_instance27726euemn90u as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  RGBA__withAd_impl_cralao1ojb8pkalp2nb as RGBA__withAd_impl_cralao,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_2,
  RGBA__times_impl_wehs9n2bi9iz06j1oam as RGBA__times_impl_wehs9n,
  get_isLow1k7uocm2ojjr8 as get_isLow,
  readBitmapSlice2r7knpwifec2u as readBitmapSlice,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
  ColorTransformMul2rawiv5hyxh9p as ColorTransformMul,
  _RGBA___get_hexString__impl__kocngmis57bfwjkwav as _RGBA___get_hexString__impl__kocngm,
  _RGBA___get_rgb__impl__tijaqtysv8goadjy9q as _RGBA___get_rgb__impl__tijaqt,
  Direction_FORWARD_getInstance1t5ovwsbek0pm as Direction_FORWARD_getInstance,
  Companion_getInstance3ctl2vl10i40x as Companion_getInstance_3,
  TileMapData285v3okd3krdh as TileMapData,
  Direction_REVERSE_getInstance1vyfjipij2sd as Direction_REVERSE_getInstance,
  Direction_ONCE_REVERSE_getInstance23nmrkk0oltbk as Direction_ONCE_REVERSE_getInstance,
  TileMapRepeat_NONE_getInstance3oqt3h9ign48 as TileMapRepeat_NONE_getInstance,
  _Tile___get_isInvalid__impl__yfg9ed6fzn22khx1pq as _Tile___get_isInvalid__impl__yfg9ed,
  _Tile___get_tile__impl__nfq1aw1gqd94vgk0ayk as _Tile___get_tile__impl__nfq1aw,
  _Tile___get_flipX__impl__jobqpf1knv3g6l37hhc as _Tile___get_flipX__impl__jobqpf,
  _Tile___get_flipY__impl__95aqcs3eosz51c5luh5 as _Tile___get_flipY__impl__95aqcs,
  _Tile___get_rotate__impl__5kjdv930g6fje0up0rl as _Tile___get_rotate__impl__5kjdv9,
  _Tile___get_offsetX__impl__qwhdsd1rggj0on9yzfy as _Tile___get_offsetX__impl__qwhdsd,
  _Tile___get_offsetY__impl__1x539u1dbavim42f9wo as _Tile___get_offsetY__impl__1x539u,
  get_bmpevghw2zw2fa7 as get_bmp,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  Companion_instance3gshkh79a96f7 as Companion_instance_0,
  Companion_instance293l0r179rei7 as Companion_instance_1,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_4,
  DateTime2gld4ho36azq9 as DateTime,
  TimeProvider2j6wl2le6n0p3 as TimeProvider,
  get_DURATION_NIL2lkiawowwp1us as get_DURATION_NIL,
  get_fast37cu8s8qwnuyi as get_fast,
  FastDuration__times_impl_h6amcp3u6kv4tju4mnx as FastDuration__times_impl_h6amcp,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  FastDuration__div_impl_rlslck3eqcfgtjve915 as FastDuration__div_impl_rlslck,
  FastDuration__compareTo_impl_4fhnj73optjj2wg605h as FastDuration__compareTo_impl_4fhnj7,
  _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c as _FastDuration___get_nanoseconds__impl__pxizcb,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  get_slowaqovrrnrezzv as get_slow,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds_0,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7_0,
  FastDuration3d3pupg2e5ora as FastDuration,
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  div1s6t4x2ts64sh as div,
  get_fastMicroseconds16wth98xujxdo as get_fastMicroseconds_0,
  _FastDuration___get_fastMicroseconds__impl__e641g11wrcl3xo4cr7g as _FastDuration___get_fastMicroseconds__impl__e641g1,
  FastDuration__div_impl_rlslck2moqkr2wlhp55 as FastDuration__div_impl_rlslck_0,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8,
  toDuration15w5sljvx2ut2 as toDuration_0,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
  _FastDuration___get_milliseconds__impl__ffr17unfwkaxi4cy42 as _FastDuration___get_milliseconds__impl__ffr17u,
  get_milliseconds20vru1dkca6bq as get_milliseconds,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Injectorxjyp19tp5mfu as Injector,
  InjectorContextps0ngmjb9onz as InjectorContext,
  InjectorDependency2f8dsqe1kn3nn as InjectorDependency,
  injectorznx5rgygah7n as injector,
} from './korlibs-inject-root-korlibs-inject.mjs';
import {
  Companion_getInstance1dp345vz250gb as Companion_getInstance_5,
  DefaultViewport_getInstance3ta8638tkh0q1 as DefaultViewport_getInstance,
  Quality_PERFORMANCE_getInstance2edcjnp9auwx5 as Quality_PERFORMANCE_getInstance,
  GameWindowCreationConfigbzmga8g39et1 as GameWindowCreationConfig,
  configure1a7py4k2lj4vi as configure,
  Input3ljaq07eyi73v as Input,
  Statslnkcsgem8jjl as Stats,
  AGPrint2do8iynklt71b as AGPrint,
  GameWindow35197f3hcbh1b as GameWindow,
  KorgeReload_getInstance1jsrcs9uzp4z9 as KorgeReload_getInstance,
  configureLoggerFromProperties2zy8apzr93pqp as configureLoggerFromProperties,
  CoroutineKey_getInstance2jikmq30sknr8 as CoroutineKey_getInstance,
  CreateDefaultGameWindow1l94icsbq4y8h as CreateDefaultGameWindow,
  Kind_MOUSE_getInstance104tc4m897tyy as Kind_MOUSE_getInstance,
  ResourcesRoot36ooexy6oq69y as ResourcesRoot,
  Type_START_getInstance27oonvh9zpi1o as Type_START_getInstance,
  Status_ADD_getInstance22apyg5ct4px7 as Status_ADD_getInstance,
  Type_END_getInstance3ekhp9k4xqwsb as Type_END_getInstance,
  Status_REMOVE_getInstance19drpw6lfvon8 as Status_REMOVE_getInstance,
  Type_MOVE_getInstanceavavmobr5nzz as Type_MOVE_getInstance,
  Status_KEEP_getInstance3tj4183qdgyi5 as Status_KEEP_getInstance,
  MouseButton_LEFT_getInstance2pxjdxrpl68c5 as MouseButton_LEFT_getInstance,
  Type_DRAG_getInstance1oyczma3u1sfi as Type_DRAG_getInstance,
  Type_UP_getInstance1azeslmnft6l5 as Type_UP_getInstance,
  Type_DOWN_getInstance1zas01g4tazis as Type_DOWN_getInstance,
  AG35f0xk1ko87rh as AG,
  TouchEvent37l81isz00qgj as TouchEvent,
  Companion_getInstancekjblelnta22u as Companion_getInstance_6,
  Companion_getInstance1wltq3fgn1avz as Companion_getInstance_7,
  Companion_getInstance2ckr5i14ndxro as Companion_getInstance_8,
  Companion_getInstance18y91gyxi2z7 as Companion_getInstance_9,
  Companion_instance3i2v9jzzqvdkl as Companion_instance_2,
  Companion_instance2ovjg7lp6gfg7 as Companion_instance_3,
  Companion_instancef7estul0zruo as Companion_instance_4,
  Companion_instance99w5lpdgjzr4 as Companion_instance_5,
  MouseEventmt8xebywpdp9 as MouseEvent,
  Companion_getInstance6ryfwvwg9trm as Companion_getInstance_10,
  Companion_getInstanceok0yphc67vv6 as Companion_getInstance_11,
  Companion_instancekcgdgz2aik3h as Companion_instance_6,
  Companion_instance12t49ingjwxzt as Companion_instance_7,
  ReshapeEvent3137ki3m95agm as ReshapeEvent,
  Companion_instance7uo85wjiqj61 as Companion_instance_8,
  Type_TYPE_getInstance3kl3gtiytkq1p as Type_TYPE_getInstance,
  Type_DOWN_getInstance3w3upujzs6x5 as Type_DOWN_getInstance_0,
  Type_UP_getInstance2onpl7vaj0n6f as Type_UP_getInstance_0,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  Cursor_DEFAULT_getInstancemdqrzfwu4c9e as Cursor_DEFAULT_getInstance,
  Companion_getInstance1ifu77pbb1si2 as Companion_getInstance_12,
  drawText2ld6eqw3mc9xd as drawText,
  V22su20mpwty0v0 as V2,
  _interpolateRatio2cj6ldbl0g6ae as _interpolateRatio,
  ProgramBuilderDefault3573mhybddt0b as ProgramBuilderDefault,
  get_BB_MAX_TEXTURES19x2awozztfc7 as get_BB_MAX_TEXTURES,
  SDFShaders_getInstance2aqc6fv2u457r as SDFShaders_getInstance,
  FragmentShader2u3ycaqbgbmdi as FragmentShader,
  Companion_instanceyamrbth4pjfq as Companion_instance_9,
  BaseEventListener6clplq3qhf9k as BaseEventListener,
  Companion_getInstance23l94gq35u9ye as Companion_getInstance_13,
  TextureBase31xvoisoo1pp7 as TextureBase,
  Texture39uvj3jju6ujd as Texture,
  AGScissor1lpa42gfyr1p2 as AGScissor,
  ProjViewUB_getInstance2c14wyrj73xek as ProjViewUB_getInstance,
  get_debugLineRenderContext3s3h9yq8a0rtj as get_debugLineRenderContext,
  Companion_getInstance2vwksse73neff as Companion_getInstance_14,
  get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz as get_TEXTURED_ARRAY_QUAD_INDICES,
  TexturedVertexArrayt1cf0uhgxqi1 as TexturedVertexArray,
  BoundsProvideri69utw6h2duh as BoundsProvider,
  debugBmpFont2i7i2ml66o1iy as debugBmpFont,
  Basef4lqzcfsxjhi as Base,
  UpdateEvent2wwv3f0im2cby as UpdateEvent,
  RenderContext3l27as458i66g as RenderContext,
  EventResult1qajuo9ssrvv5 as EventResult,
  Key_F12_getInstance20smmrbslhgku as Key_F12_getInstance,
  Key_F7_getInstance1fxfgbmldwoq6 as Key_F7_getInstance,
  StopPropagatingException3fryyzw9pc422 as StopPropagatingException,
  DeviceDimensionsProvider22igvmdnpe2w1 as DeviceDimensionsProvider,
  Eventnral6s6c3h27 as Event,
  Texture2obedkmljq67n as Texture_0,
  TEXTURED_ARRAY_quadIndices1vrv67jygypre as TEXTURED_ARRAY_quadIndices,
  ShrinkableTexturedVertexArray2dp7296cmttgp as ShrinkableTexturedVertexArray,
} from './korge-root-korge-core.mjs';
import {
  Companion_getInstance23o88a0u6ly94 as Companion_getInstance_15,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_16,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_17,
  Size2Dum5ayuyhhau7 as Size2D,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_18,
  Rectangle3q03woyn9k8x1 as Rectangle,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_19,
  Scale2cm697xlulcp5 as Scale,
  Companion_getInstance2yu48324co92b as Companion_getInstance_20,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_21,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_22,
  interpolatewhd2sgxffql5 as interpolate,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle as _Angle___get_absoluteValue__impl__4qoakv,
  SizeInte6w85oa6mz6v as SizeInt,
  toFloat3b315y36g90cd as toFloat,
  toIntp2twe4onfbic as toInt,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_23,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_24,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_25,
  Ratio136tf4z2t0p2d as Ratio,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clampdicp8njiht45 as clamp,
  clamp1qclpmpfxm7xb as clamp_0,
  toRatio1hooqit5gulhr as toRatio,
  toLongRound7crzegvo2qbo as toLongRound,
  clamp31lhm66c28ic8 as clamp_1,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  roundDecimalPlacespck2j5mpzhqn as roundDecimalPlaces,
  convertRange24n2xnngpze54 as convertRange,
  convertRange1a6ancvyn151r as convertRange_0,
  niceStr1ftz2qvn4gdyq as niceStr,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  umod164hvijxhfi8p as umod,
  toIntCeil3h286vm49zgwd as toIntCeil,
  insert2fz5125p2hdyd as insert,
  minhi4sj3tfj9ww as min,
  max329dnql9l08bp as max,
  get_nextPowerOfTwoselx3fye7kjp as get_nextPowerOfTwo,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get_immutablepxpdoj6e54ll as get_immutable,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  HitTestDirection_ANY_getInstance1hlnrhgqmsigf as HitTestDirection_ANY_getInstance,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_26,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  cancel1n0qjc93h2v6w as cancel_0,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_10,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  toFrequency3flbtmp5xney7 as toFrequency,
  _Frequency___get_hertz__impl__9m7k6x25q6mu7133pq1 as _Frequency___get_hertz__impl__9m7k6x,
  _Frequency___get_fastDuration__impl__87web01nqjqeilxp91g as _Frequency___get_fastDuration__impl__87web0,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediately11za8mkid9pxu as launchImmediately,
  Companion_instance20wy3vp7551rj as Companion_instance_11,
  get_workerImpl14jb6v5ie8q11 as get_workerImpl,
  get_DEBUG_WORKER2r7zp31jch3ip as get_DEBUG_WORKER,
  get_localCurrentDirVfs2lka1gsv26an5 as get_localCurrentDirVfs,
  Resources1ysf2j4wd5yk7 as Resources,
  launchImmediatelylnv8lnistpdy as launchImmediately_0,
  Once1q3lxlgflq3fq as Once,
  launchUnscopedAndWait1ibbocika451b as launchUnscopedAndWait,
  launchUnscopedpyoa01nqmf1z as launchUnscoped,
  launchUnscoped2lqe6wwpvfo83 as launchUnscoped_0,
  StandardPaths_instanceid246em8v040 as StandardPaths_instance,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  Companion_instance2nobhthyyb9yj as Companion_instance_12,
  Dyn__set_impl_2ozvx82bmztjcahblz8 as Dyn__set_impl_2ozvx8,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import { get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider } from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  getExtra307y0o9pd6mp3 as getExtra,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Resourceable38whwgli3ts8g as Resourceable,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  Ref2y4j4snnxo6gs as Ref,
  IntDeque2ebok66x2sofm as IntDeque,
  Pool1zbsw0zhvh8ca as Pool,
  toRef3av6zm8yavumw as toRef,
  Ref11k43t82thcp3 as Ref_0,
  getCyclicOrNull12fem85bj0m7u as getCyclicOrNull,
  FastStringMap1l1uzdhsfbatm as FastStringMap,
  get2pw1zlgv5zypd as get,
  set2vuztm9k7ubgo as set,
  FastIdentityCacheMap3fegd59qa1ixp as FastIdentityCacheMap,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  arrayfill2iqmyqqqfwuaf as arrayfill,
  arraycopy3uxsqjlixmnz3 as arraycopy,
  arrayequal25g4om83vd8w1 as arrayequal,
} from './korlibs-memory-root-korlibs-memory.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_13 = this;
    this.db2_1 = Companion_getInstance_0().g26('Korge');
    this.eb2_1 = 'korlibs.korge.unknown';
  }
}
class Korge$_init_$slambda_ys8r4w {
  fb2(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  le(p1, $completion) {
    return this.fb2(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$start$slambda {
  constructor(this$0, $entry) {
    this.rb0_1 = this$0;
    this.sb0_1 = $entry;
  }
  f2y($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withContext), $completion);
  }
  le(p1, $completion) {
    return this.f2y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Korge {
  constructor(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    Companion_getInstance_27();
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_27().eb2_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_5().e9t_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().s9q_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_28().h4z() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().z57_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? new GameWindowCreationConfig(multithreaded, VOID, VOID, VOID, VOID, VOID, fullscreen) : windowCreationConfig;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w_0();
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().y57_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
    unit = unit === VOID ? Unit_instance : unit;
    this.tb0_1 = args;
    this.ub0_1 = imageFormats;
    this.vb0_1 = gameWindow;
    this.wb0_1 = mainSceneClass;
    this.xb0_1 = timeProvider;
    this.yb0_1 = injector;
    this.zb0_1 = configInjector;
    this.ab1_1 = debug;
    this.bb1_1 = trace;
    this.cb1_1 = context;
    this.db1_1 = fullscreen;
    this.eb1_1 = blocking;
    this.fb1_1 = gameId;
    this.gb1_1 = settingsFolder;
    this.hb1_1 = batchMaxQuads;
    this.ib1_1 = windowSize;
    this.jb1_1 = virtualSize;
    this.kb1_1 = displayMode;
    this.lb1_1 = title;
    this.mb1_1 = backgroundColor;
    this.nb1_1 = quality;
    this.ob1_1 = icon;
    this.pb1_1 = multithreaded;
    this.qb1_1 = forceRenderEveryFrame;
    this.rb1_1 = windowCreationConfig;
    this.sb1_1 = main;
    this.tb1_1 = debugAg;
    this.ub1_1 = debugFontExtraScale;
    this.vb1_1 = debugFontColor;
    this.wb1_1 = stageBuilder;
    this.xb1_1 = targetFps;
    this.yb1_1 = preferSyncIo;
    this.zb1_1 = debugCoroutines;
    this.ab2_1 = unit;
  }
  ab5(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_start__v5y7pu.bind(VOID, this, entry), $completion);
  }
  bb5(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
  }
  bb2(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit, $super) {
    args = args === VOID ? this.tb0_1 : args;
    imageFormats = imageFormats === VOID ? this.ub0_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.vb0_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.wb0_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.xb0_1 : timeProvider;
    injector = injector === VOID ? this.yb0_1 : injector;
    configInjector = configInjector === VOID ? this.zb0_1 : configInjector;
    debug = debug === VOID ? this.ab1_1 : debug;
    trace = trace === VOID ? this.bb1_1 : trace;
    context = context === VOID ? this.cb1_1 : context;
    fullscreen = fullscreen === VOID ? this.db1_1 : fullscreen;
    blocking = blocking === VOID ? this.eb1_1 : blocking;
    gameId = gameId === VOID ? this.fb1_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.gb1_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.hb1_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.ib1_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.jb1_1 : virtualSize;
    displayMode = displayMode === VOID ? this.kb1_1 : displayMode;
    title = title === VOID ? this.lb1_1 : title;
    backgroundColor = backgroundColor === VOID ? this.mb1_1 : backgroundColor;
    quality = quality === VOID ? this.nb1_1 : quality;
    icon = icon === VOID ? this.ob1_1 : icon;
    multithreaded = multithreaded === VOID ? this.pb1_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.qb1_1 : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? this.rb1_1 : windowCreationConfig;
    main = main === VOID ? this.sb1_1 : main;
    debugAg = debugAg === VOID ? this.tb1_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.ub1_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.vb1_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.wb1_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.xb1_1 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? this.yb1_1 : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? this.zb1_1 : debugCoroutines;
    unit = unit === VOID ? this.ab2_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.bb5(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
    } else {
      var tmp_0 = $super.bb5;
      var tmp_1 = backgroundColor;
      var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, tmp_2, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, new RGBA(debugFontColor), stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.tb0_1);
    var tmp_0 = this.ub0_1.toString();
    var tmp_1 = toString_0(this.vb0_1);
    var tmp_2 = toString_0(this.wb0_1);
    var tmp_3 = toString(this.xb0_1);
    var tmp_4 = this.yb0_1.toString();
    var tmp_5 = toString(this.zb0_1);
    var tmp_6 = toString_0(this.cb1_1);
    var tmp_7 = this.ib1_1.toString();
    var tmp_8 = this.jb1_1.toString();
    var tmp_9 = this.kb1_1.toString();
    var tmp_10 = this.mb1_1;
    return 'Korge(args=' + tmp + ', imageFormats=' + tmp_0 + ', gameWindow=' + tmp_1 + ', mainSceneClass=' + tmp_2 + ', timeProvider=' + tmp_3 + ', injector=' + tmp_4 + ', configInjector=' + tmp_5 + ', debug=' + this.ab1_1 + ', trace=' + this.bb1_1 + ', context=' + tmp_6 + ', fullscreen=' + this.db1_1 + ', blocking=' + this.eb1_1 + ', gameId=' + this.fb1_1 + ', settingsFolder=' + this.gb1_1 + ', batchMaxQuads=' + this.hb1_1 + ', windowSize=' + tmp_7 + ', virtualSize=' + tmp_8 + ', displayMode=' + tmp_9 + ', title=' + this.lb1_1 + ', backgroundColor=' + toString_0(tmp_10 == null ? null : new RGBA(tmp_10)) + ', quality=' + toString(this.nb1_1) + ', icon=' + this.ob1_1 + ', multithreaded=' + this.pb1_1 + ', forceRenderEveryFrame=' + this.qb1_1 + ', windowCreationConfig=' + this.rb1_1.toString() + ', main=' + toString(this.sb1_1) + ', debugAg=' + this.tb1_1 + ', debugFontExtraScale=' + this.ub1_1 + ', debugFontColor=' + RGBA__toString_impl_4lw6dp(this.vb1_1) + ', stageBuilder=' + toString(this.wb1_1) + ', targetFps=' + this.xb1_1 + ', preferSyncIo=' + this.yb1_1 + ', debugCoroutines=' + this.zb1_1 + ', unit=' + this.ab2_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.tb0_1);
    result = imul(result, 31) + hashCode(this.ub0_1) | 0;
    result = imul(result, 31) + (this.vb0_1 == null ? 0 : hashCode(this.vb0_1)) | 0;
    result = imul(result, 31) + (this.wb0_1 == null ? 0 : this.wb0_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.xb0_1) | 0;
    result = imul(result, 31) + hashCode(this.yb0_1) | 0;
    result = imul(result, 31) + hashCode(this.zb0_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ab1_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.bb1_1) | 0;
    result = imul(result, 31) + (this.cb1_1 == null ? 0 : hashCode(this.cb1_1)) | 0;
    result = imul(result, 31) + (this.db1_1 == null ? 0 : getBooleanHashCode(this.db1_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.eb1_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fb1_1) | 0;
    result = imul(result, 31) + (this.gb1_1 == null ? 0 : getStringHashCode(this.gb1_1)) | 0;
    result = imul(result, 31) + this.hb1_1 | 0;
    result = imul(result, 31) + this.ib1_1.hashCode() | 0;
    result = imul(result, 31) + this.jb1_1.hashCode() | 0;
    result = imul(result, 31) + this.kb1_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.lb1_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.mb1_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.mb1_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.nb1_1.hashCode() | 0;
    result = imul(result, 31) + (this.ob1_1 == null ? 0 : getStringHashCode(this.ob1_1)) | 0;
    result = imul(result, 31) + (this.pb1_1 == null ? 0 : getBooleanHashCode(this.pb1_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.qb1_1) | 0;
    result = imul(result, 31) + this.rb1_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.sb1_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.tb1_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ub1_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.vb1_1) | 0;
    result = imul(result, 31) + hashCode(this.wb1_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.xb1_1) | 0;
    result = imul(result, 31) + (this.yb1_1 == null ? 0 : getBooleanHashCode(this.yb1_1)) | 0;
    result = imul(result, 31) + (this.zb1_1 == null ? 0 : getBooleanHashCode(this.zb1_1)) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_instance) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.tb0_1, tmp0_other_with_cast.tb0_1))
      return false;
    if (!equals(this.ub0_1, tmp0_other_with_cast.ub0_1))
      return false;
    if (!equals(this.vb0_1, tmp0_other_with_cast.vb0_1))
      return false;
    if (!equals(this.wb0_1, tmp0_other_with_cast.wb0_1))
      return false;
    if (!equals(this.xb0_1, tmp0_other_with_cast.xb0_1))
      return false;
    if (!equals(this.yb0_1, tmp0_other_with_cast.yb0_1))
      return false;
    if (!equals(this.zb0_1, tmp0_other_with_cast.zb0_1))
      return false;
    if (!(this.ab1_1 === tmp0_other_with_cast.ab1_1))
      return false;
    if (!(this.bb1_1 === tmp0_other_with_cast.bb1_1))
      return false;
    if (!equals(this.cb1_1, tmp0_other_with_cast.cb1_1))
      return false;
    if (!(this.db1_1 == tmp0_other_with_cast.db1_1))
      return false;
    if (!(this.eb1_1 === tmp0_other_with_cast.eb1_1))
      return false;
    if (!(this.fb1_1 === tmp0_other_with_cast.fb1_1))
      return false;
    if (!(this.gb1_1 == tmp0_other_with_cast.gb1_1))
      return false;
    if (!(this.hb1_1 === tmp0_other_with_cast.hb1_1))
      return false;
    if (!this.ib1_1.equals(tmp0_other_with_cast.ib1_1))
      return false;
    if (!this.jb1_1.equals(tmp0_other_with_cast.jb1_1))
      return false;
    if (!this.kb1_1.equals(tmp0_other_with_cast.kb1_1))
      return false;
    if (!(this.lb1_1 === tmp0_other_with_cast.lb1_1))
      return false;
    var tmp = this.mb1_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.mb1_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.nb1_1.equals(tmp0_other_with_cast.nb1_1))
      return false;
    if (!(this.ob1_1 == tmp0_other_with_cast.ob1_1))
      return false;
    if (!(this.pb1_1 == tmp0_other_with_cast.pb1_1))
      return false;
    if (!(this.qb1_1 === tmp0_other_with_cast.qb1_1))
      return false;
    if (!this.rb1_1.equals(tmp0_other_with_cast.rb1_1))
      return false;
    if (!equals(this.sb1_1, tmp0_other_with_cast.sb1_1))
      return false;
    if (!(this.tb1_1 === tmp0_other_with_cast.tb1_1))
      return false;
    if (!equals(this.ub1_1, tmp0_other_with_cast.ub1_1))
      return false;
    if (!(this.vb1_1 === tmp0_other_with_cast.vb1_1))
      return false;
    if (!equals(this.wb1_1, tmp0_other_with_cast.wb1_1))
      return false;
    if (!equals(this.xb1_1, tmp0_other_with_cast.xb1_1))
      return false;
    if (!(this.yb1_1 == tmp0_other_with_cast.yb1_1))
      return false;
    if (!(this.zb1_1 == tmp0_other_with_cast.zb1_1))
      return false;
    if (!equals(Unit_instance, Unit_instance))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_14 = this;
    this.wb4_1 = new KorgeDisplayMode(Companion_getInstance_15().k3s_1, Companion_getInstance_16().e3i(), true);
    this.xb4_1 = new KorgeDisplayMode(Companion_getInstance_15().k3s_1, Companion_getInstance_16().e3i(), false);
    this.yb4_1 = new KorgeDisplayMode(Companion_getInstance_15().k3s_1, Companion_getInstance_16().s3h_1, false);
    this.zb4_1 = new KorgeDisplayMode(Companion_getInstance_15().m3s_1, Companion_getInstance_16().s3h_1, false);
  }
  h4z() {
    return this.wb4_1;
  }
}
class KorgeDisplayMode {
  constructor(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_28();
    this.cb5_1 = scaleMode;
    this.db5_1 = scaleAnchor;
    this.eb5_1 = clipBorders;
  }
  toString() {
    return 'KorgeDisplayMode(scaleMode=' + this.cb5_1.toString() + ', scaleAnchor=' + this.db5_1.toString() + ', clipBorders=' + this.eb5_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.cb5_1);
    result = imul(result, 31) + this.db5_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.eb5_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.cb5_1, tmp0_other_with_cast.cb5_1))
      return false;
    if (!this.db5_1.equals(tmp0_other_with_cast.db5_1))
      return false;
    if (!(this.eb5_1 === tmp0_other_with_cast.eb5_1))
      return false;
    return true;
  }
}
class KorgeRunner$invoke$slambda$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.tb7_1 = $config;
    this.ub7_1 = $views;
    this.vb7_1 = $entry;
    this.wb7_1 = $gameWindow;
  }
  f2y($this$coroutineScope, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$coroutineScope), $completion);
  }
  le(p1, $completion) {
    return this.f2y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$invoke$slambda$slambda {
  constructor($config, $views, $entry, $gameWindow) {
    this.zbc_1 = $config;
    this.abd_1 = $views;
    this.bbd_1 = $entry;
    this.cbd_1 = $gameWindow;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class KorgeRunner$invoke$slambda {
  constructor($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
    this.dbd_1 = $realGameWindow;
    this.ebd_1 = $windowSize;
    this.fbd_1 = $config;
    this.gbd_1 = $iconPath;
    this.hbd_1 = $imageFormats;
    this.ibd_1 = $entry;
  }
  qbd($this$loop, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$loop), $completion);
  }
  le(p1, $completion) {
    return this.qbd(p1 instanceof GameWindow ? p1 : THROW_CCE(), $completion);
  }
}
class KorgeRunner$prepareViewsBase$lambda$slambda {
  constructor($views) {
    this.rbd_1 = $views;
  }
  ke($completion) {
    this.rbd_1.p6();
  }
}
class KorgeRunner {
  cb2(config, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, config), $completion);
  }
  mbd(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    var injector = views.mb5_1;
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    injector.e7s(getKClass(Views), views);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance = views.lb5_1;
    injector.e7s(getKClass(AG), instance);
    injector.e7s(getKClass(Resources), views.tbd());
    var tmp = getKClass(ResourcesRoot);
    injector.h7s(tmp, KorgeRunner$prepareViewsBase$lambda);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_0 = views.nb5_1;
    injector.e7s(getKClass(Input), instance_0);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_1 = views.pb5_1;
    injector.e7s(getKClass(Stats), instance_1);
    injector.e7s(getKClass(CoroutineContext), views.kb5_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.i7s(tmp_0, KorgeRunner$prepareViewsBase$lambda_0);
    injector.e7s(getKClass(TimeProvider), views.ob5_1);
    configInjector(injector);
    var input = views.nb5_1;
    var ag = views.lb5_1;
    var downPos = {_v: Companion_getInstance_18().t3i_1};
    var upPos = {_v: Companion_getInstance_18().t3i_1};
    var downTime = {_v: new DateTime(Companion_getInstance_4().i35_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_4().i35_1)};
    var upTime = Companion_getInstance_4().i35_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.ubd(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_6().b7x_1.slice();
    eventDispatcher.m7v(tmp_1, KorgeRunner$prepareViewsBase$lambda_1(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_7().n7w_1.slice();
    eventDispatcher.m7v(tmp_2, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_3 = Companion_getInstance_8().c7y_1.slice();
    eventDispatcher.m7v(tmp_3, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_4 = Companion_getInstance_9().j7y_1.slice();
    eventDispatcher.m7v(tmp_4, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_5 = Companion_instance_2;
    eventDispatcher.a7v(tmp_5, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_6 = Companion_instance_3;
    eventDispatcher.a7v(tmp_6, KorgeRunner$prepareViewsBase$lambda_6(views));
    var tmp_7 = Companion_instance_4;
    eventDispatcher.a7v(tmp_7, KorgeRunner$prepareViewsBase$lambda_7(views));
    var tmp_8 = Companion_instance_5;
    eventDispatcher.a7v(tmp_8, KorgeRunner$prepareViewsBase$lambda_8(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_10().c7z_1.slice();
    eventDispatcher.m7v(tmp_9, KorgeRunner$prepareViewsBase$lambda_9(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_11().h81_1.slice();
    eventDispatcher.m7v(tmp_10, KorgeRunner$prepareViewsBase$lambda_10(views));
    var tmp_11 = Companion_instance_6;
    eventDispatcher.a7v(tmp_11, KorgeRunner$prepareViewsBase$lambda_11(views, input));
    var tmp_12 = Companion_instance_7;
    eventDispatcher.a7v(tmp_12, KorgeRunner$prepareViewsBase$lambda_12(views, ag));
    eventDispatcher.l7v(new ReshapeEvent(0, 0, views.vbd(), views.wbd()));
    var tmp_13 = Companion_instance_8;
    eventDispatcher.a7v(tmp_13, KorgeRunner$prepareViewsBase$lambda_13(views));
    var renderShown = {_v: false};
    views.kb6_1 = clearEachFrame;
    views.lb6_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.qb5_1.ba5(KorgeRunner$prepareViewsBase$lambda_14(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  }
}
class Korge$slambda {
  fb2(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  le(p1, $completion) {
    return this.fb2(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class Korge$slambda_0 {
  fb2(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  le(p1, $completion) {
    return this.fb2(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class KeysEvents$lambda$slambda {
  constructor(this$0, $event) {
    this.dbe_1 = this$0;
    this.ebe_1 = $event;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_0 {
  constructor(this$0, $event) {
    this.fbe_1 = this$0;
    this.gbe_1 = $event;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
  }
}
class KeysEvents$lambda$slambda_1 {
  constructor(this$0, $event) {
    this.hbe_1 = this$0;
    this.ibe_1 = $event;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
  }
}
class KeysEvents {
  constructor(view) {
    this.xbd_1 = view;
    this.zbd_1 = new AsyncSignal();
    this.abe_1 = new AsyncSignal();
    this.bbe_1 = new AsyncSignal();
    this.cbe_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.xbd_1.a7v(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance_0();
    this.xbd_1.a7v(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance_0();
    this.xbd_1.a7v(tmp_1, KeysEvents$lambda_1(this));
  }
  jbe() {
    var tmp = this.ybd_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  lbe(_this__u8e3s4, key, keys, dt, type) {
    _this__u8e3s4.q7w_1 = type;
    _this__u8e3s4.s7w_1 = key;
    _this__u8e3s4.t7w_1 = key.p3_1;
    _this__u8e3s4.v7w_1 = keys.y9o_1;
    _this__u8e3s4.w7w_1 = keys.z9o_1;
    _this__u8e3s4.x7w_1 = keys.a9p_1;
    _this__u8e3s4.y7w_1 = keys.b9p_1;
    _this__u8e3s4.a7x_1 = dt;
    return _this__u8e3s4;
  }
  kbe(_this__u8e3s4, key, keys, dt, type, $super) {
    type = type === VOID ? Type_DOWN_getInstance_0() : type;
    return $super === VOID ? this.lbe(_this__u8e3s4, key, keys, dt, type) : $super.lbe.call(this, _this__u8e3s4, key, keys, new Duration(dt), type);
  }
  mbe(keys, dt, callback) {
    var ke = new KeyEvent();
    return addOptFixedUpdater(this.xbd_1, dt, KeysEvents$downFrame$lambda(this, keys, callback, ke));
  }
  nbe(key, dt, callback) {
    return this.mbe(listOf(key), dt, callback);
  }
  obe(keys, callback) {
    var ke = new KeyEvent();
    return addUpdaterWithViews(this.xbd_1, KeysEvents$justDown$lambda(keys, callback, this, ke));
  }
  pbe(key, callback) {
    return this.obe(listOf(key), callback);
  }
  p6() {
    this.cbe_1.p6();
  }
}
class Companion_1 {
  mbg(views) {
    // Inline function 'korlibs.io.util.Once.invoke' call
    var this_0 = get_mouseDebugHandlerOnce(views);
    if (!this_0.c4i_1) {
      this_0.c4i_1 = true;
      // Inline function 'korlibs.korge.input.Companion.installDebugExtensionOnce.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = views.cb7_1;
      var element = MouseEvents$Companion$installDebugExtensionOnce$lambda(views);
      this_1.h(element);
    }
  }
}
class MouseEventsUpdate {
  constructor($outer, view) {
    this.pbg_1 = $outer;
    this.nbg_1 = new Mixin();
    this.obg_1 = view;
    addUpdaterWithViews(this.obg_1, MouseEvents$MouseEventsUpdate$lambda(this.pbg_1));
  }
  c28(value) {
    this.nbg_1.c28(value);
  }
  d28() {
    return this.nbg_1.d28();
  }
}
class MouseEvents {
  constructor(view) {
    this.wbe_1 = new Mixin();
    this.xbe_1 = view;
    this.xbe_1.tbg(true);
    this.zbe_1 = new Signal();
    this.abf_1 = new Signal();
    this.bbf_1 = new Signal();
    this.cbf_1 = new Signal();
    this.dbf_1 = new Signal();
    this.ebf_1 = new Signal();
    this.fbf_1 = new Signal();
    this.gbf_1 = new Signal();
    this.hbf_1 = new Signal();
    this.ibf_1 = new Signal();
    this.jbf_1 = new Signal();
    this.kbf_1 = new Signal();
    this.lbf_1 = new Signal();
    this.mbf_1 = new Signal();
    this.nbf_1 = new Signal();
    this.obf_1 = new Signal();
    this.pbf_1 = new Signal();
    this.qbf_1 = new Signal();
    this.rbf_1 = new Signal();
    this.sbf_1 = null;
    this.tbf_1 = false;
    this.ubf_1 = false;
    this.vbf_1 = false;
    this.wbf_1 = PerformanceCounter_getInstance().z7s();
    this.xbf_1 = PerformanceCounter_getInstance().z7s();
    this.ybf_1 = Vector2D.i3l();
    this.zbf_1 = Vector2D.i3l();
    this.abg_1 = Vector2D.i3l();
    this.bbg_1 = Vector2D.i3l();
    this.cbg_1 = Vector2D.i3l();
    this.dbg_1 = 0;
    this.ebg_1 = false;
    this.fbg_1 = null;
    this.gbg_1 = new MouseEvent();
    this.hbg_1 = false;
    this.ibg_1 = new MouseEvent();
    var tmp = this;
    var tmp_0 = Companion_getInstance_6().b7x_1.slice();
    tmp.jbg_1 = this.xbe_1.m7v(tmp_0, MouseEvents$closeable$lambda(this));
    this.kbg_1 = new MouseEventsUpdate(this, this.xbe_1);
  }
  rbg() {
    var tmp = this.ybe_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  ubg() {
    return this.xbe_1.vbg(this.cbg_1);
  }
  sbg() {
    var tmp0_safe_receiver = this.sbf_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, this.xbe_1);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  wbg() {
    return !(this.rbg().nb5_1.s9p_1 === 0);
  }
  toString() {
    return this.gbg_1.toString();
  }
  lbg(views, dt) {
    if (!this.xbe_1.qbg())
      return Unit_instance;
    this.ybe_1 = views;
    Companion_instance_15.mbg(views);
    this.sbf_1 = mouseHitTest(Companion_instance_15, views);
    var over = this.sbg();
    var inside = views.nb5_1.u9p_1;
    if (over) {
      set_mouseHitResultUsed(views.nb5_1, this.xbe_1);
    }
    var overChanged = !(this.tbf_1 === over);
    var insideChanged = !(this.ubf_1 === inside);
    var pressingChanged = !(this.wbg() === this.vbf_1);
    this.cbg_1 = views.nb5_1.i9q();
    if (!overChanged && over && !this.cbg_1.equals(this.bbg_1)) {
      this.lbf_1.r38(this);
    }
    if (!overChanged && !over && !this.cbg_1.equals(this.bbg_1)) {
      this.nbf_1.r38(this);
    }
    if (!this.cbg_1.equals(this.bbg_1)) {
      this.mbf_1.r38(this);
    }
    if (overChanged && over) {
      this.bbf_1.r38(this);
    }
    if (overChanged && !over) {
      this.cbf_1.r38(this);
    }
    if (pressingChanged && this.wbg()) {
      this.abg_1 = this.cbg_1;
      if (over) {
        this.dbf_1.r38(this);
      }
      if (!over) {
        this.ebf_1.r38(this);
      }
    }
    if (overChanged && this.wbg()) {
      this.fbf_1.r38(this);
    }
    if (pressingChanged && !this.wbg()) {
      var tmp = this.ibg_1;
      temporalLastEvent(this, tmp, MouseEvents$update$lambda(over, this));
    }
    over && this.dbg_1 > 0;
    if (insideChanged && !inside) {
      this.nbf_1.r38(this);
      this.cbf_1.r38(this);
      this.ibf_1.r38(this);
      this.jbf_1.r38(this);
      this.obf_1.r38(this);
    }
    this.tbf_1 = over;
    this.ubf_1 = inside;
    this.vbf_1 = this.wbg();
    this.bbg_1 = this.cbg_1;
    this.dbg_1 = 0;
  }
  p6() {
    this.jbg_1.p6();
  }
  c28(value) {
    this.wbe_1.c28(value);
  }
  d28() {
    return this.wbe_1.d28();
  }
}
class SceneCancellationException extends CancellationException {
  static dbh(scene) {
    var $this = this.ce('Scene.sceneAfterDestroyInternal:' + toString(scene));
    captureStack($this, $this.cbh_1);
    $this.bbh_1 = scene;
    return $this;
  }
}
class Scene {
  constructor() {
    this.ebh_1 = new Mixin();
    this.jbh_1 = Container.bbk();
    this.kbh_1 = new CancellableGroup();
    var tmp = this;
    tmp.lbh_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.mbh_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.nbh_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  pbh() {
    var tmp = this.fbh_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  }
  cbk(_set____db54di) {
    this.gbh_1 = _set____db54di;
  }
  rbg() {
    var tmp = this.gbh_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  qbh() {
    var tmp = this.hbh_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  }
  z2e() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.lbh_1;
    coroutineContext$factory();
    return this_0.w1();
  }
  dbk() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.mbh_1;
    sceneView$factory();
    return this_0.w1();
  }
  rbh(size) {
    return SContainer.pbm(size);
  }
  p7s(injector) {
    this.fbh_1 = injector;
    // Inline function 'korlibs.inject.Injector.get' call
    var tmp$ret$0 = injector.n7s(getKClass(Views));
    this.cbk(tmp$ret$0);
    var tmp = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp.hbh_1 = injector.n7s(getKClass(SceneContainer));
    var tmp_0 = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp_0.ibh_1 = injector.n7s(getKClass(ResourcesRoot));
  }
  qbm(_this__u8e3s4, $completion) {
  }
  rbm(_this__u8e3s4, $completion) {
  }
  sbm($completion) {
  }
  tbm($completion) {
  }
  ubm($completion) {
  }
  vbm() {
    cancel_0(this.kbh_1);
    this.pbh().q7s();
  }
  obh($completion) {
  }
  wbm($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneAfterDestroyInternal__rup219.bind(VOID, this), $completion);
  }
  c28(value) {
    this.ebh_1.c28(value);
  }
  d28() {
    return this.ebh_1.d28();
  }
}
class EmptyScene extends Scene {
  rbm(_this__u8e3s4, $completion) {
  }
}
class VisitEntry {
  constructor(clazz, injects) {
    this.nbq_1 = clazz;
    this.obq_1 = injects;
  }
  toString() {
    return 'VisitEntry(clazz=' + toString(this.nbq_1) + ', injects=' + toString(this.obq_1) + ')';
  }
  hashCode() {
    var result = this.nbq_1.hashCode();
    result = imul(result, 31) + hashCode(this.obq_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.nbq_1.equals(tmp0_other_with_cast.nbq_1))
      return false;
    if (!equals(this.obq_1, tmp0_other_with_cast.obq_1))
      return false;
    return true;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_16 = this;
    this.rbn_1 = Companion_getInstance_0().g26('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.sbn_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
}
class SceneContainer$lambda$slambda {
  constructor(this$0, $event) {
    this.hbn_1 = this$0;
    this.ibn_1 = $event;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda {
  constructor($newScene) {
    this.ubn_1 = $newScene;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_0 {
  constructor($newScene) {
    this.vbn_1 = $newScene;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_1 {
  constructor($oldScene) {
    this.wbn_1 = $oldScene;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_2 {
  constructor($oldScene) {
    this.xbn_1 = $oldScene;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_3 {
  constructor($oldScene) {
    this.ybn_1 = $oldScene;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
  }
}
class SceneContainer$_changeTo$slambda_4 {
  constructor($newScene) {
    this.zbn_1 = $newScene;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
  }
}
class BaseView extends BaseEventListener {
  static mc4() {
    return this.y7u();
  }
  ibw() {
  }
}
class View extends BaseView {
  static gc7(isContainer) {
    var $this = this.mc4();
    $this.bb8_1 = isContainer;
    var tmp = $this;
    tmp.cb8_1 = lazy(View$bviewAll$delegate$lambda($this));
    $this.db8_1 = true;
    $this.eb8_1 = null;
    $this.fb8_1 = null;
    $this.gb8_1 = null;
    $this.hb8_1 = 0;
    $this.ib8_1 = null;
    $this.jb8_1 = 1.0;
    $this.kb8_1 = null;
    $this.lb8_1 = null;
    $this.mb8_1 = null;
    $this.nb8_1 = Companion_getInstance_12().i9l_1;
    $this.ob8_1 = 0.0;
    $this.pb8_1 = 0.0;
    $this.qb8_1 = 1.0;
    $this.rb8_1 = 1.0;
    $this.sb8_1 = Companion_getInstance_22().i3i_1;
    $this.tb8_1 = Companion_getInstance_22().i3i_1;
    $this.ub8_1 = Companion_getInstance_22().i3i_1;
    $this.vb8_1 = 0.0;
    $this.wb8_1 = scale$factory($this);
    $this.xb8_1 = false;
    $this.yb8_1 = true;
    $this.zb8_1 = true;
    $this.ab9_1 = true;
    $this.bb9_1 = true;
    $this.cb9_1 = Companion_getInstance_21().z3l_1;
    $this.db9_1 = Companion_getInstance_21().z3l_1;
    $this.eb9_1 = -1;
    $this.fb9_1 = Companion_getInstance_21().z3l_1;
    $this.gb9_1 = -1;
    $this.hb9_1 = new ColorTransformMul();
    $this.ib9_1 = new ColorTransformMul();
    $this.jb9_1 = -1;
    $this.kb9_1 = Companion_getInstance_12().i9l_1;
    $this.lb9_1 = -1;
    $this.mb9_1 = true;
    $this.nb9_1 = 0;
    $this.ob9_1 = 0;
    $this.pb9_1 = false;
    $this.qb9_1 = false;
    $this.rb9_1 = null;
    $this.sb9_1 = false;
    $this.tb9_1 = null;
    $this.ub9_1 = 0;
    $this.vb9_1 = true;
    $this.wb9_1 = null;
    return $this;
  }
  dbx() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.cb8_1;
    bviewAll$factory();
    return this_0.w1();
  }
  static sc9() {
    return this.gc7(false);
  }
  ebx() {
    return 0.0;
  }
  fbx() {
    return 0.0;
  }
  lbw() {
    return null;
  }
  zch(_set____db54di) {
    this.fb8_1 = _set____db54di;
  }
  gbx() {
    return this.fb8_1;
  }
  hbx() {
    return this.gb8_1;
  }
  ibx(value) {
    this.hb8_1 = value;
  }
  s81() {
    return this.hb8_1;
  }
  jbx(value) {
    if (this.kb8_1 === value)
      return Unit_instance;
    this.kb8_1 = value;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.lbw();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.g1()) {
        // Inline function 'korlibs.korge.view.View.<set-_stage>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.h1(_unary__edvuaz).jbx(value);
      }
      tmp = Unit_instance;
    }
    this.kbx();
  }
  kbx() {
  }
  lbx(value) {
    if (this.lb8_1 === value)
      return Unit_instance;
    this.lb8_1 = value;
    var parent = this.jbw();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.lbw();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.g1()) {
        // Inline function 'korlibs.korge.view.View.<set-_invalidateNotifier>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.h1(_unary__edvuaz).lbx(parent);
      }
      tmp = Unit_instance;
    }
  }
  jbw() {
    return this.lb8_1;
  }
  mbx() {
    var tmp0_safe_receiver = this.ib8_1;
    this.lbx(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.jbw());
  }
  nbx(value) {
    if (this.ib8_1 === value)
      return Unit_instance;
    this.ib8_1 = value;
    var tmp0_safe_receiver = this.ib8_1;
    this.jbx(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kb8_1);
    this.mbx();
    this.wby();
    this.z7u(value);
  }
  z3g() {
    return this.ib8_1;
  }
  obx() {
    return !(this.z3g() == null) ? ensureNotNull(this.z3g()).obx() * this.jb8_1 : this.jb8_1;
  }
  pbx(x, y) {
    this.lby();
    if (!(this.ob8_1 === x) || !(this.pb8_1 === y)) {
      this.ob8_1 = x;
      this.pb8_1 = y;
      this.uby();
    }
  }
  z6w(value) {
    return this.pbx(value.r3i_1, value.s3i_1);
  }
  qbx(v) {
    this.pbx(v, this.c6h());
  }
  b6h() {
    this.lby();
    return this.ob8_1;
  }
  rbx(v) {
    this.pbx(this.b6h(), v);
  }
  c6h() {
    this.lby();
    return this.pb8_1;
  }
  sbx() {
    return this.vb8_1;
  }
  tbx(v) {
    this.zbx(Scale.g3q(v, v));
  }
  ubx() {
    return this.aby().g3o();
  }
  vbx(v) {
    this.lby();
    if (!(this.qb8_1 === v)) {
      this.qb8_1 = v;
      this.uby();
    }
  }
  wbx() {
    this.lby();
    return this.qb8_1;
  }
  xbx(v) {
    this.lby();
    if (!(this.rb8_1 === v)) {
      this.rb8_1 = v;
      this.uby();
    }
  }
  ybx() {
    this.lby();
    return this.rb8_1;
  }
  zbx(value) {
    this.vbx(value.e3q_1);
    this.xbx(value.f3q_1);
  }
  aby() {
    return Scale.g3q(this.wbx(), this.ybx());
  }
  bby() {
    this.lby();
    return this.sb8_1;
  }
  cby() {
    this.lby();
    return this.tb8_1;
  }
  dby() {
    this.lby();
    return this.ub8_1;
  }
  eby() {
    var tmp0_safe_receiver = this.z3g();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cbz(Vector2D.y3k(this.b6h(), this.c6h()));
    return tmp1_elvis_lhs == null ? Vector2D.y3k(this.b6h(), this.c6h()) : tmp1_elvis_lhs;
  }
  g1() {
    return this.nbt();
  }
  nbt() {
    return this.sbe().g1();
  }
  fby() {
    return this.nbt().u3j_1;
  }
  gby() {
    return this.nbt().v3j_1;
  }
  hby() {
    return this.fby() * this.wbx();
  }
  iby() {
    return this.gby() * this.ybx();
  }
  f3u() {
    return this.fby();
  }
  g3u() {
    return this.gby();
  }
  h5p() {
    return this.hb9_1.h5p();
  }
  jby(v) {
    if (!(this.hb9_1.g5p() === v)) {
      this.hb9_1.f5p(v);
      this.nbw();
    }
  }
  kby() {
    return this.hb9_1.g5p();
  }
  lby() {
    if (this.ab9_1)
      return Unit_instance;
    this.ab9_1 = true;
    var t = this.cb9_1.i3n();
    this.ob8_1 = t.u3n_1;
    this.pb8_1 = t.v3n_1;
    this.qb8_1 = t.w3n_1;
    this.rb8_1 = t.x3n_1;
    this.sb8_1 = t.y3n_1;
    this.tb8_1 = t.z3n_1;
    this.ub8_1 = t.a3o_1;
  }
  o3g() {
    var tmp0_safe_receiver = this.z3g();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o3g();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  }
  mby() {
    return this.kb8_1;
  }
  tbg(_set____db54di) {
    this.xb8_1 = _set____db54di;
  }
  qbg() {
    return this.xb8_1;
  }
  nby() {
    return this.yb8_1;
  }
  oby() {
    return this.zb8_1;
  }
  pby() {
    if (!this.bb9_1) {
      this.bb9_1 = true;
      this.pb9_1 = true;
      this.cb9_1 = Companion_getInstance_21().l3m(this.b6h(), this.c6h(), this.dby(), this.wbx(), this.ybx(), this.bby(), this.cby(), 0.0, 0.0);
    }
    return this.cb9_1;
  }
  ube() {
    if (!(this.eb9_1 === this.nb9_1)) {
      this.eb9_1 = this.nb9_1;
      this.pb9_1 = true;
      this.db9_1 = !(this.z3g() == null) ? this.pby().n3m(ensureNotNull(this.z3g()).ube()) : this.pby();
    }
    return this.db9_1;
  }
  qby() {
    if (!(this.gb9_1 === this.nb9_1)) {
      this.gb9_1 = this.nb9_1;
      this.pb9_1 = true;
      this.fb9_1 = this.ube().h3n();
    }
    return this.fb9_1;
  }
  rby() {
    updateRenderColorTransformIfRequired(this);
    return this.ib9_1;
  }
  sby() {
    updateRenderBlendModeIfRequired(this);
    return this.kb9_1;
  }
  tby() {
    updateRenderColorTransformIfRequired(this);
    return this.ib9_1.h5p();
  }
  jc7(views) {
    return this.vbg(views.nb5_1.i9q());
  }
  uby() {
    this.bb9_1 = false;
    this.mbw();
  }
  mbw() {
    this.nb9_1 = this.nb9_1 + 1 | 0;
    this.pb9_1 = false;
    this.mb9_1 = true;
    this.ibw();
  }
  vby() {
    if (!(this.rb9_1 == null)) {
      this.rb9_1 = null;
      var tmp0_safe_receiver = this.z3g();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.vby();
      }
    }
  }
  wby() {
    this.qbt();
  }
  xby() {
    this.qbt();
  }
  qbt() {
  }
  ibw() {
    var tmp0_safe_receiver = this.lb8_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.kbw(this);
    }
    this.vby();
  }
  nbw() {
    this.ob9_1 = this.ob9_1 + 1 | 0;
    this.qb9_1 = false;
    this.mb9_1 = true;
    this.ibw();
  }
  obt(ctx) {
    if (!this.oby())
      return Unit_instance;
    var tmp0_safe_receiver = this.tb9_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = tmp0_safe_receiver.s28_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].hci(this, ctx);
      }
    }
    try {
      this.yby(ctx);
    }finally {
      var tmp1_safe_receiver = this.tb9_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp1_safe_receiver.s28_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.korge.view.View.render.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array_0[(tmp1_safe_receiver.g1() - n_0 | 0) - 1 | 0].ici(this, ctx);
          n_0 = n_0 + 1 | 0;
        }
      }
    }
  }
  yby(ctx) {
    var oldPhase = this.ub9_1;
    try {
      this.ub9_1 = 0;
      this.zby(ctx);
    }finally {
      this.ub9_1 = oldPhase;
    }
  }
  zby(ctx) {
    var stages = this.tb9_1;
    if (!(stages == null) && this.ub9_1 < stages.g1()) {
      var _unary__edvuaz = this.ub9_1;
      this.ub9_1 = _unary__edvuaz + 1 | 0;
      stages.h1(_unary__edvuaz).jci(this, ctx);
    } else {
      var tmp = this.ub9_1;
      var tmp1_elvis_lhs = stages == null ? null : stages.g1();
      if (equals(tmp, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) {
        this.sbt(ctx);
        this.ub9_1 = this.ub9_1 + 1 | 0;
      }
    }
  }
  wbw(ctx) {
    if (this.sb9_1 || this === get_debugAnnotateView(ctx)) {
      this.abz(ctx);
    }
  }
  abz(ctx) {
    var local = this.sbe();
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    var this_1 = this_0.a9w_1;
    if (!(this_1.e9n_1 === this_0)) {
      this_1.e9n_1 = this_0;
      this_1.o9o();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory_0(this_2);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(null == null))
          this_2.m9w_1 = null;
        // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_12().r9l_1;
          var doUpdate = !(this_0.l9w_1 === blending);
          var old = this_0.l9w_1;
          try {
            if (doUpdate) {
              this_0.a9w_1.o9o();
              this_0.l9w_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
            var color = Colors_getInstance().a58_1;
            var m = this_0.m9w_1;
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var oldColor = this_0.d9w_1;
            this_0.d9w_1 = color;
            try {
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              // Inline function 'kotlin.apply' call
              var this_3 = new VectorPath();
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>.<anonymous>' call
              this_3.x4y(this.nbz());
              this_0.s9w(this_3, m);
            }finally {
              this_0.d9w_1 = oldColor;
            }
            break $l$block;
          }finally {
            if (doUpdate) {
              this_0.a9w_1.o9o();
            }
            this_0.l9w_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_0 = Colors_getInstance().a58_1;
        var m_0 = this_0.m9w_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = this_0.d9w_1;
        this_0.d9w_1 = color_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_4 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          this_4.k4p(this.cbz(Vector2D.y3k(local.i3j(), local.d3q())));
          this_4.x4p(this.cbz(Vector2D.y3k(local.j3j(), local.d3q())));
          this_4.x4p(this.cbz(Vector2D.y3k(local.j3j(), local.c3q())));
          this_4.x4p(this.cbz(Vector2D.y3k(local.i3j(), local.c3q())));
          this_4.p6();
          this_0.s9w(this_4, m_0);
        }finally {
          this_0.d9w_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_1 = Colors_getInstance().o5d_1;
        var m_1 = this_0.m9w_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = this_0.d9w_1;
        this_0.d9w_1 = color_1;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_5 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var anchorSize = 6.0 * ensureNotNull(get_views(ctx)).u9v();
          this_5.d4z(this.cbz(local.y3j()), anchorSize);
          this_5.d4z(this.cbz(local.w3q()), anchorSize);
          this_5.d4z(this.cbz(local.a3k()), anchorSize);
          this_5.d4z(this.cbz(local.x3q()), anchorSize);
          this_5.d4z(this.cbz(interpolate(Companion_getInstance_25().r27_1, local.y3j(), local.w3q())), anchorSize);
          this_5.d4z(this.cbz(interpolate(Companion_getInstance_25().r27_1, local.w3q(), local.a3k())), anchorSize);
          this_5.d4z(this.cbz(interpolate(Companion_getInstance_25().r27_1, local.a3k(), local.x3q())), anchorSize);
          this_5.d4z(this.cbz(interpolate(Companion_getInstance_25().r27_1, local.x3q(), local.y3j())), anchorSize);
          this_0.s9w(this_5, m_1);
        }finally {
          this_0.d9w_1 = oldColor_1;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_2 = Colors_getInstance().c58_1;
        var m_2 = this_0.m9w_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_2 = this_0.d9w_1;
        this_0.d9w_1 = color_2;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_6 = new VectorPath();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.View.renderDebugAnnotationsInternal.<anonymous>.<anonymous>' call
          var center = this.eby();
          this_6.w4y(Vector2D.y3k(center.r3i_1, center.s3i_1 - 5), Vector2D.y3k(center.r3i_1, center.s3i_1 + 5));
          this_6.w4y(Vector2D.y3k(center.r3i_1 - 5, center.s3i_1), Vector2D.y3k(center.r3i_1 + 5, center.s3i_1));
          this_0.s9w(this_6, m_2);
        }finally {
          this_0.d9w_1 = oldColor_2;
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
  }
  toString() {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.b6h() === 0.0) || !(this.c6h() === 0.0))
      out = out + (':pos=(' + this.bbz(this.b6h()) + ',' + this.bbz(this.c6h()) + ')');
    if (!(this.wbx() === 1.0) || !(this.ybx() === 1.0))
      out = out + (':scale=(' + this.bbz(this.wbx()) + ',' + this.bbz(this.ybx()) + ')');
    if (!equals(this.bby(), Companion_getInstance_22().i3i_1) || !equals(this.cby(), Companion_getInstance_22().i3i_1))
      out = out + (':skew=(' + this.bbz(_Angle___get_degrees__impl__qg56vw(this.bby())) + ',' + this.bbz(_Angle___get_degrees__impl__qg56vw(this.cby())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.dby()), Companion_getInstance_22().i3i_1))
      out = out + (':rotation=(' + this.bbz(_Angle___get_degrees__impl__qg56vw(this.dby())) + '\xBA)');
    if (!(this.mb8_1 == null))
      out = out + (':name=(' + this.mb8_1 + ')');
    if (!this.nb8_1.equals(Companion_getInstance_12().i9l_1))
      out = out + (':blendMode=(' + this.nb8_1.toString() + ')');
    if (!this.oby())
      out = out + (':visible=' + this.oby());
    if (!(this.kby() === 1.0))
      out = out + (':alpha=' + niceStr(this.kby(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.h5p()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().y57_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.h5p()));
    return out;
  }
  bbz(_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  }
  vbg(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.qby();
      if (this_0.g3j()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.y3k(this_0.r3m(p.r3i_1, p.s3i_1), this_0.u3m(p.r3i_1, p.s3i_1));
    }
    return tmp$ret$0;
  }
  cbz(p) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.ube();
      if (this_0.g3j()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.y3k(this_0.r3m(p.r3i_1, p.s3i_1), this_0.u3m(p.r3i_1, p.s3i_1));
    }
    return tmp$ret$0;
  }
  rbe(p) {
    if (!this.vb9_1)
      return null;
    if (!this.oby())
      return null;
    if (this.nby()) {
      var tmp0_safe_receiver = this.lbw();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
        var n = 0;
        while (n < tmp0_safe_receiver.g1()) {
          // Inline function 'korlibs.korge.view.View.mouseHitTest.<anonymous>' call
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.h1((tmp0_safe_receiver.g1() - n | 0) - 1 | 0).rbe(p);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            return tmp0_safe_receiver_0;
          }
          n = n + 1 | 0;
        }
      }
    }
    if (!this.qbg())
      return null;
    var tmp1_safe_receiver = this.fbz(p);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var area = this.dbz();
      if (!area.g3j() && !area.v3k(p))
        return null;
      return tmp1_safe_receiver;
    }
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  dbz() {
    var out = Companion_getInstance_19().m3j_1;
    var count = 0;
    // Inline function 'korlibs.korge.view.forEachAscendant' call
    var view = this;
    if (!true) {
      var tmp0_safe_receiver = view;
      view = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z3g();
    }
    while (!(view == null)) {
      // Inline function 'korlibs.korge.view.View.getClippingAreaInternal.<anonymous>' call
      var it = view;
      var tmp;
      var tmp_0;
      if (!(it instanceof Stage)) {
        tmp_0 = it instanceof FixedSizeContainer;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = it.p74();
      } else {
        tmp = false;
      }
      if (tmp) {
        var _localBounds = it.pbz();
        if (count === 0) {
          out = _localBounds;
        } else {
          out = out.e3r(_localBounds);
        }
        count = count + 1 | 0;
      }
      view = view.z3g();
    }
    return count === 0 ? Companion_getInstance_19().o3j() : out;
  }
  ebz(p, direction) {
    if (!this.vb9_1)
      return null;
    var ll = this.vbg(p);
    var bounds = this.sbe();
    if (!bounds.v3k(ll)) {
      return null;
    }
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.m3q(this.ebx(), this.fbx());
    var l = Vector2D.y3k(ll.r3i_1 + that.r3i_1, ll.s3i_1 + that.s3i_1);
    if (this.wb9_1 === false)
      return this;
    var hitShape = this.gbx();
    var hitShapes = this.hbx();
    if (this.wb9_1 == null && (!(hitShape == null) || !(hitShapes == null))) {
      if (hitShapes == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < hitShapes.g1()) {
          // Inline function 'korlibs.korge.view.View.hitTestInternal.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          if (hitShapes.h1(_unary__edvuaz).k4z(l))
            return this;
        }
      }
      if (!(hitShape == null) && hitShape.k4z(l))
        return this;
      return null;
    } else {
      return this;
    }
  }
  fbz(p, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.ebz(p, direction) : $super.ebz.call(this, p, direction);
  }
  gbz() {
    var tmp0_safe_receiver = this.z3g();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.cbx(this);
  }
  hbz(target, inclusive) {
    var tmp;
    if (target === this.z3g()) {
      tmp = this.pby();
    } else if (target === this) {
      tmp = Companion_getInstance_21().z3l_1;
    } else {
      var commonAncestor = Companion_instance_20.gci(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.z3g() == null && inclusive) {
          return this.ube();
        }
        tmp_0 = this.ube().n3m(target.qby());
      } else {
        tmp_0 = Companion_getInstance_21().z3l_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = out.n3m(target.pby());
    }
    return out;
  }
  ibz() {
    var tmp0_elvis_lhs = this.jbz();
    return tmp0_elvis_lhs == null ? this.pbz() : tmp0_elvis_lhs;
  }
  jbz() {
    var stage = this.o3g();
    if (!(stage instanceof Stage))
      return null;
    return this.kbz(stage);
  }
  kbz(bp) {
    return this.pbz().m3r(bp.m9v());
  }
  lbz(ctx) {
    return ctx.a9x() ? this.kbz(ctx) : this.pbz();
  }
  mbz(ctx) {
    return this.lbz(ctx);
  }
  nbz() {
    return this.pbz();
  }
  obz(includeFilters) {
    return this.ubz(this.o3g(), VOID, true, includeFilters);
  }
  pbz(includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.obz(includeFilters) : $super.obz.call(this, includeFilters);
  }
  qbz(target, inclusive, includeFilters) {
    return this.tbz(target, false, inclusive, includeFilters);
  }
  rbz(target, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.qbz(target, inclusive, includeFilters) : $super.qbz.call(this, target, inclusive, includeFilters);
  }
  sbz(concat, doAnchoring, includeFilters) {
    var out = this.vbz(doAnchoring, includeFilters);
    if (concat.h3j() && !concat.o3m()) {
      var tmp = Companion_getInstance_20();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p = out.y3j();
        if (concat.g3j()) {
          tmp$ret$0 = p;
          break $l$block;
        }
        tmp$ret$0 = Vector2D.y3k(concat.r3m(p.r3i_1, p.s3i_1), concat.u3m(p.r3i_1, p.s3i_1));
      }
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_0 = out.w3q();
        if (concat.g3j()) {
          tmp$ret$1 = p_0;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.y3k(concat.r3m(p_0.r3i_1, p_0.s3i_1), concat.u3m(p_0.r3i_1, p_0.s3i_1));
      }
      var tmp_1 = tmp$ret$1;
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = out.a3k();
        if (concat.g3j()) {
          tmp$ret$2 = p_1;
          break $l$block_1;
        }
        tmp$ret$2 = Vector2D.y3k(concat.r3m(p_1.r3i_1, p_1.s3i_1), concat.u3m(p_1.r3i_1, p_1.s3i_1));
      }
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_2 = out.x3q();
        if (concat.g3j()) {
          tmp$ret$3 = p_2;
          break $l$block_2;
        }
        tmp$ret$3 = Vector2D.y3k(concat.r3m(p_2.r3i_1, p_2.s3i_1), concat.u3m(p_2.r3i_1, p_2.s3i_1));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.q3j(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  }
  tbz(target, doAnchoring, inclusive, includeFilters) {
    return this.sbz(this.hbz(target == null ? this : target, inclusive), doAnchoring, includeFilters);
  }
  ubz(target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.tbz(target, doAnchoring, inclusive, includeFilters) : $super.tbz.call(this, target, doAnchoring, inclusive, includeFilters);
  }
  vbz(doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.rb9_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.pbt();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.View.getLocalBounds.<anonymous>' call
      this.rb9_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = out.b3n(Vector2D.m3q(this.ebx(), this.fbx()));
    }
    if (includeFilters) {
      var tmp1_safe_receiver = get_filter(this);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        out = expandedBorderRectangle(tmp1_safe_receiver, out);
      }
    }
    return out;
  }
  sbe(doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.vbz(doAnchoring, includeFilters) : $super.vbz.call(this, doAnchoring, includeFilters);
  }
  pbt() {
    return Companion_getInstance_19().o3j();
  }
  h7v(type, event, result) {
    var tmp0_safe_receiver = this.z3g();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.o7v(type, event, result);
  }
}
class Container extends View {
  static bbk(cull) {
    cull = cull === VOID ? false : cull;
    var $this = this.gc7(true);
    $this.sbj_1 = cull;
    $this.tbj_1 = FastArrayList.u28();
    $this.ubj_1 = new ContainerCollection($this, $this.tbj_1);
    $this.vbj_1 = null;
    $this.wbj_1 = new MMatrix();
    $this.xbj_1 = false;
    $this.ybj_1 = false;
    $this.zbj_1 = FastArrayList.u28();
    return $this;
  }
  lbw() {
    return this.tbj_1;
  }
  mbw() {
    super.mbw();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ubj_1;
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidate.<anonymous>' call
      var child = this_0.h1(_unary__edvuaz);
      if (child.pb9_1) {
        child.mbw();
      }
    }
  }
  nbw() {
    super.nbw();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ubj_1;
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.invalidateColorTransform.<anonymous>' call
      var child = this_0.h1(_unary__edvuaz);
      if (child.qb9_1) {
        child.nbw();
      }
    }
  }
  obw() {
    return this.tbj_1.g1();
  }
  pbw(view) {
  }
  qbt() {
    super.qbt();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.lbw();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.g1()) {
        // Inline function 'korlibs.korge.view.Container.onAncestorChanged.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.h1(_unary__edvuaz).xby();
      }
      tmp = Unit_instance;
    }
  }
  qbw(index) {
    return this.tbj_1.h1(index);
  }
  rbw(index) {
    return this.sbw(index, 1) === 1;
  }
  sbw(index, count) {
    if (count <= 0 || index < 0)
      return 0;
    var from = index;
    // Inline function 'kotlin.comparisons.minOf' call
    var a = index + count | 0;
    var b = this.obw();
    var to = Math.min(a, b);
    var inductionVariable = from;
    if (inductionVariable < to)
      do {
        var removedIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var view = this.qbw(removedIndex);
        view.nbx(null);
        view.ibx(-1);
      }
       while (inductionVariable < to);
    this.tbj_1.p7(from, to);
    var inductionVariable_0 = index;
    var last = this.obw();
    if (inductionVariable_0 < last)
      do {
        var i = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.tbj_1.h1(i).ibx(i);
      }
       while (inductionVariable_0 < last);
    this.ybw();
    this.zbw();
    this.vby();
    return to - from | 0;
  }
  tbw() {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ubj_1;
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.removeChildren.<anonymous>' call
      var child = this_0.h1(_unary__edvuaz);
      child.nbx(null);
      child.ibx(-1);
    }
    this.tbj_1.h3();
    this.ybw();
  }
  ubw(view) {
    return this.bbx(view, this.obw());
  }
  abk(view) {
    this.bbx(view, this.obw());
  }
  h1(index) {
    return this.qbw(index);
  }
  sbt(ctx) {
    if (!this.oby())
      return Unit_instance;
    this.vbw(ctx);
  }
  vbw(ctx) {
    if (!this.sbj_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.xbj_1) {
        this.xbj_1 = true;
        this.zbj_1.h3();
        this.zbj_1.i1(this.ubj_1);
        if (this.xbw())
          this.ybj_1 = false;
      }
      if (!this.ybj_1) {
        this.ybj_1 = true;
        sortWith(this.zbj_1, ZIndexComparator_instance);
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.zbj_1.s28_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
        array[_unary__edvuaz].obt(ctx);
      }
      return Unit_instance;
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp1_elvis_lhs = clippingContainer == null ? null : clippingContainer.pbz();
    var bounds = tmp1_elvis_lhs == null ? Companion_getInstance_19().o3j() : tmp1_elvis_lhs;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.xbj_1) {
      this.xbj_1 = true;
      this.zbj_1.h3();
      this.zbj_1.i1(this.ubj_1);
      if (this.xbw())
        this.ybj_1 = false;
    }
    if (!this.ybj_1) {
      this.ybj_1 = true;
      sortWith(this.zbj_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.zbj_1.s28_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderChildrenInternal.<anonymous>' call
      var child = array_0[_unary__edvuaz_0];
      if (bounds.g3j() || bounds.b3r(child.obz(true))) {
        child.obt(ctx);
        renderedCount = renderedCount + 1 | 0;
      } else {
        culledCount = culledCount + 1 | 0;
      }
    }
  }
  wbw(ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.xbj_1) {
      this.xbj_1 = true;
      this.zbj_1.h3();
      this.zbj_1.i1(this.ubj_1);
      if (this.xbw())
        this.ybj_1 = false;
    }
    if (!this.ybj_1) {
      this.ybj_1 = true;
      sortWith(this.zbj_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.zbj_1.s28_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'korlibs.korge.view.Container.renderDebug.<anonymous>' call
      array[_unary__edvuaz].wbw(ctx);
    }
    super.wbw(ctx);
  }
  pbt() {
    var bb = Companion_getInstance_20().p3j();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.ubj_1;
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChild.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.korge.view.Container.getLocalBoundsInternal.<anonymous>' call
      var child = this_0.h1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, child.ubz(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  xbw() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.tbj_1.s28_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.view.Container.shouldSortChildren.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(array[_unary__edvuaz].sbx() === 0.0)) {
        return true;
      }
    }
    return false;
  }
  ybw() {
    this.xbj_1 = false;
    this.zbw();
  }
  zbw() {
    var tmp0_safe_receiver = this.mby();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rbg();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.kbw(this);
    }
  }
  abx(child) {
    var parent = this;
    if (parent === child) {
      invalidOp("Can't addChild to itself");
    }
    if (hasAncestor(parent, child)) {
      invalidOp("Can't addChild to an ancestor");
    }
  }
  bbx(view, index) {
    this.abx(view);
    var tmp0_safe_receiver = view.z3g();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ybw();
    }
    view.gbz();
    var aindex = clamp_1(index, 0, this.obw());
    var children = this.tbj_1;
    children.n7(aindex, view);
    var inductionVariable = aindex;
    var last = this.obw();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.h1(n).ibx(n);
      }
       while (inductionVariable < last);
    view.nbx(this);
    view.mbw();
    this.pbw(view);
    this.ybw();
    this.zbw();
    this.vby();
  }
  cbx(view) {
    if (!((view == null ? null : view.z3g()) === this))
      return false;
    return this.rbw(view.s81());
  }
  e7v(type, event, result) {
    if (this.vbj_1 == null)
      this.vbj_1 = FastArrayList.t28(this.ubj_1.g1());
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var this_0 = this.tbj_1;
    var temp = ensureNotNull(this.vbj_1);
    toFastList(this_0, temp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = temp.s28_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Container.dispatchChildren.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].n7v(type, event, result);
      }
    }finally {
      temp.h3();
    }
  }
}
class CachedContainer extends Container {
  static nc4(cache, renderQuality) {
    cache = cache === VOID ? true : cache;
    renderQuality = renderQuality === VOID ? null : renderQuality;
    var $this = this.bbk();
    $this.bbw_1 = cache;
    $this.cbw_1 = renderQuality;
    $this.dbw_1 = null;
    $this.ebw_1 = true;
    $this.fbw_1 = -1.0;
    $this.gbw_1 = Companion_getInstance_19().c3m();
    $this.hbw_1 = Scale.e3s(1);
    return $this;
  }
  ibw() {
    super.ibw();
    this.ebw_1 = true;
  }
  sbt(ctx) {
    if (!this.oby())
      return Unit_instance;
    if (!this.bbw_1) {
      return super.sbt(ctx);
    }
    if (this.dbw_1 == null) {
      this.dbw_1 = new CacheTexture(this, ctx);
      this.ebw_1 = true;
    }
    var cache = ensureNotNull(this.dbw_1);
    ctx.f9x(cache);
    var renderScale = ctx.u9w().p3_1 === 0 ? 1.0 : ctx.n9x();
    var tmp1_elvis_lhs = this.cbw_1;
    var doExpensiveScaling = !get_isLow(tmp1_elvis_lhs == null ? ctx.u9w() : tmp1_elvis_lhs);
    if (this.ebw_1 || !(this.fbw_1 === renderScale)) {
      this.fbw_1 = renderScale;
      this.gbw_1 = this.sbe(VOID, false);
      this.hbw_1 = doExpensiveScaling ? this.ibz().g1().g3s(this.gbw_1.g1()) : Scale.e3s(1);
      this.ebw_1 = false;
      var texWidth = coerceAtLeast(numberToInt(this.gbw_1.d3j_1 * renderScale * this.hbw_1.e3q_1), 1);
      var texHeight = coerceAtLeast(numberToInt(this.gbw_1.e3j_1 * renderScale * this.hbw_1.f3q_1), 1);
      cache.tc4(texWidth, texHeight);
      ctx.o9o();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var frameBuffer = cache.pc4_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.k9x(frameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.a9n_1;
        var this_1 = this_0.j9n_1;
        if (!(this_1.e9n_1 === this_0)) {
          this_1.e9n_1 = this_0;
          this_1.o9o();
        }
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var scissor = AGScissor.q8d(0, 0, frameBuffer.o83_1, frameBuffer.p83_1);
          var temp = this_0.h9o_1;
          this_0.o9u();
          this_0.h9o_1 = scissor;
          try {
            if (true) {
              ctx.c9x(Colors_getInstance().d58_1);
            }
            // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>' call
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
            var matrix = this.qby().d3n(-this.gbw_1.b3j_1, -this.gbw_1.c3j_1).x3m(renderScale * this.hbw_1.e3q_1, renderScale * this.hbw_1.f3q_1);
            ctx.o9o();
            var temp4 = ctx.p9m_1;
            var temp2d = ctx.q9m_1;
            ctx.q9m_1 = matrix;
            ctx.p9m_1 = toMatrix4(matrix);
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var this_2 = ctx.d8a(ProjViewUB_getInstance());
              var _unary__edvuaz = this_2.s8b();
              this_2.e8y(_unary__edvuaz + 1 | 0);
              this_2.f8y(this_2.s8b() + 1 | 0);
              var blockSize = this_2.w89_1;
              var index0 = imul(this_2.s8b() - 1 | 0, blockSize);
              var index1 = imul(this_2.s8b(), blockSize);
              var texBlockSize = this_2.t89_1.g8i().g1();
              var texIndex0 = imul(this_2.s8b() - 1 | 0, texBlockSize);
              var texIndex1 = imul(this_2.s8b(), texBlockSize);
              if (this_2.s8b() > 0) {
                arraycopy(this_2.y89_1, index0, this_2.y89_1, index1, blockSize);
              } else {
                arrayfill(this_2.y89_1, 0, 0, blockSize);
              }
              // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
              var $this$push = this_2.t89_1;
              this_2.z89_1.i8y($this$push.f8i(), ctx.p9m_1);
              if (true && this_2.s8b() >= 1) {
                var equals = arrayequal(this_2.y89_1, index0, this_2.y89_1, index1, blockSize);
                if (equals) {
                  var _unary__edvuaz_0 = this_2.s8b();
                  this_2.e8y(_unary__edvuaz_0 - 1 | 0);
                  break $l$block;
                }
              }
            }
            try {
              // Inline function 'korlibs.korge.view.CachedContainer.renderInternal.<anonymous>.<anonymous>' call
              super.sbt(ctx);
            }finally {
              ctx.o9o();
              ctx.p9m_1 = temp4;
              ctx.q9m_1 = temp2d;
              ctx.d8a(ProjViewUB_getInstance()).g8y();
            }
            break $l$block_0;
          }finally {
            this_0.o9u();
            this_0.h9o_1 = temp;
          }
        }
      }finally {
        ctx.l9x();
      }
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_3 = ctx.a9n_1;
    var this_4 = this_3.j9n_1;
    if (!(this_4.e9n_1 === this_3)) {
      this_4.e9n_1 = this_3;
      this_4.o9o();
    }
    this_3.q9o(cache.rc4_1, VOID, VOID, VOID, VOID, this.ube().f3n(this.gbw_1.b3j_1, this.gbw_1.c3j_1).z3m(1.0 / (renderScale * this.hbw_1.e3q_1), 1.0 / (renderScale * this.hbw_1.f3q_1)), VOID, this.tby(), this.nb8_1);
  }
  jbw() {
    return this;
  }
  kbw(view) {
    this.ebw_1 = true;
    var tmp0_safe_receiver = this.z3g();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lb8_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.kbw(view);
    }
  }
}
class FixedSizeCachedContainer extends CachedContainer {
  static lc4(size, cache, clip) {
    size = size === VOID ? Size2D.w3j(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    var $this = this.nc4(cache);
    $this.ic4_1 = clip;
    $this.jc4_1 = size;
    $this.kc4_1 = Ref(false);
    return $this;
  }
  nbt() {
    return this.jc4_1;
  }
  pbt() {
    return new Rectangle(0.0, 0.0, this.f3u(), this.g3u());
  }
  sbt(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.ic4_1;
      var renderingInternalRef = this.kc4_1;
      if (renderingInternalRef.w1()) {
        super.sbt(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.ube();
        var hasRotation = !(m.f3m_1 === 0.0) || !(m.g3m_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.w1();
          try {
            renderingInternalRef.j43(true);
            renderFiltered(this, ctx, Companion_getInstance_38());
          }finally {
            renderingInternalRef.j43(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.a9n_1;
        if (!(ctx.e9n_1 === batcher)) {
          ctx.e9n_1 = batcher;
          ctx.o9o();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.c9n_1;
        var bounds = this.mbz(ctx).m3r(ctx.q9m_1).n3r();
        var rect = c2d.r9x_1.y9t().x8d();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.b3r(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_13().t8d(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.r9x_1;
            var scissor_0 = c2d.b9y(scissor);
            var temp = this_0.h9o_1;
            this_0.o9u();
            this_0.h9o_1 = scissor_0;
            try {
              super.sbt(ctx);
              break $l$block_1;
            }finally {
              this_0.o9u();
              this_0.h9o_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
          super.sbt(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeCachedContainer.renderInternal.<anonymous>' call
        super.sbt(ctx);
      }
    }
  }
}
class UIView extends FixedSizeCachedContainer {
  static jbt(size, cache) {
    Companion_getInstance_31();
    size = size === VOID ? Companion_getInstance_31().sc1_1 : size;
    cache = cache === VOID ? false : cache;
    var $this = this.lc4(size, cache, false);
    $this.hbt_1 = size;
    $this.ibt_1 = false;
    return $this;
  }
  nbt() {
    return this.hbt_1;
  }
  pbt() {
    return new Rectangle(0.0, 0.0, this.f3u(), this.g3u());
  }
  qbt() {
    super.qbt();
    this.rbt();
  }
  rbt() {
    this.mbw();
  }
  sbt(ctx) {
    registerUISupportOnce(this);
    super.sbt(ctx);
  }
}
class SceneContainer extends UIView {
  static xbc(views, defaultTransition, name, size) {
    Companion_getInstance_30();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_24())) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.wb6_1.g1() : size;
    var $this = this.jbt(size);
    $this.rbc_1 = views;
    $this.sbc_1 = defaultTransition;
    $this.mb8_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = TransitionView.kbt();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.transitionView.<anonymous>' call
    $this.abk(this_0);
    tmp.tbc_1 = this_0;
    $this.ubc_1 = null;
    var tmp_0 = Companion_instance_8;
    $this.a7v(tmp_0, SceneContainer$lambda($this));
    $this.vbc_1 = arrayListOf([Companion_getInstance_30().sbn_1]);
    $this.wbc_1 = 0;
    return $this;
  }
  lbt(clazz, injects, time, transition, $completion) {
    this.mbt(new VisitEntry(clazz, toList(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $completion);
  }
  ybc(clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.sbc_1 : transition;
    return $super === VOID ? this.lbt(clazz, injects, time, transition, $completion) : $super.lbt.call(this, clazz, injects, new Duration(time), transition, $completion);
  }
  tbn(newScene, time, transition, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq_0.bind(VOID, this, newScene, time, transition), $completion);
  }
  mbt(entry) {
    while (this.vbc_1.g1() <= this.wbc_1) {
      this.vbc_1.h(Companion_getInstance_30().sbn_1);
    }
    this.vbc_1.i3(this.wbc_1, entry);
  }
  z2e() {
    return this.rbc_1.kb5_1;
  }
}
class TransitionProcess {}
function start(prev, next) {
  return Unit_instance;
}
function end(prev, next) {
  return Unit_instance;
}
function render(ctx, prev, next, ratio) {
  return Unit_instance;
}
class TransitionView extends Container {
  static kbt() {
    var $this = this.bbk();
    dummyView($this);
    dummyView($this);
    $this.ibq_1 = Companion_getInstance_25().p27_1;
    $this.jbq_1 = get_AlphaTransition();
    return $this;
  }
  l2s() {
    return this.h1(0);
  }
  i2s() {
    return this.h1(1);
  }
  lbq(next, transition) {
    this.jbq_1 = transition;
    this.ibq_1 = Companion_getInstance_25().p27_1;
    this.kbq_1 = transition.a1x();
    this.zbz(this.i2s(), next);
    _get_transitionProcess__5hlux5(this).wbz(this.l2s(), this.i2s());
  }
  toString() {
    return super.toString() + (':ratio=' + Ratio__toString_impl_mfgt3e(this.ibq_1) + ':transition=' + toString(this.jbq_1));
  }
  mbq() {
    this.ibq_1 = Companion_getInstance_25().s27_1;
    _get_transitionProcess__5hlux5(this).xbz(this.l2s(), this.i2s());
    this.zbz(dummyView(this), this.i2s());
  }
  zbz(prev, next) {
    this.tbw();
    this.ubw(prev);
    this.ubw(next);
  }
  sbt(ctx) {
    if (Ratio__compareTo_impl_z2ienc(this.ibq_1, Companion_getInstance_25().p27_1) <= 0) {
      this.l2s().obt(ctx);
    } else if (Ratio__compareTo_impl_z2ienc(this.ibq_1, Companion_getInstance_25().s27_1) >= 0) {
      this.i2s().obt(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).ybz(ctx, this.l2s(), this.i2s(), this.ibq_1);
    }
  }
}
class Transition$1 {
  constructor($render, $name) {
    this.ac0_1 = $render;
    this.bc0_1 = $name;
  }
  a1x() {
    return this;
  }
  ybz(ctx, prev, next, ratio) {
    return this.ac0_1(ctx, prev, next, new Ratio(ratio));
  }
  toString() {
    return this.bc0_1;
  }
}
class withEasing$1$create$1 {
  constructor($process, $easing) {
    this.cc0_1 = $process;
    this.dc0_1 = $easing;
  }
  wbz(prev, next) {
    return this.cc0_1.wbz(prev, next);
  }
  xbz(prev, next) {
    return this.cc0_1.xbz(prev, next);
  }
  ybz(ctx, prev, next, ratio) {
    return this.cc0_1.ybz(ctx, prev, next, this.dc0_1.k27(ratio));
  }
}
class withEasing$1 {
  constructor($this_withEasing, $easing) {
    this.ec0_1 = $this_withEasing;
    this.fc0_1 = $easing;
  }
  toString() {
    return toString(this.ec0_1) + '.withEasing';
  }
  a1x() {
    var process = this.ec0_1.a1x();
    return new withEasing$1$create$1(process, this.fc0_1);
  }
}
class MsdfRender {
  constructor() {
    MsdfRender_instance = this;
    this.gc0_1 = this.kc0(true, VOID, false);
    this.hc0_1 = this.kc0(true, VOID, true);
    this.ic0_1 = this.lc0(false, 'r', false);
    this.jc0_1 = this.lc0(false, 'a', false);
  }
  lc0(msdf, sdf, inverted) {
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var name = 'PROGRAM_msdf=' + msdf + ',sdf=' + sdf + ',inverted=' + inverted;
    var tmp1_$this = Companion_getInstance_5().l9t_1;
    var tmp2_name = name == null ? Companion_getInstance_5().l9t_1.p8a_1 : name;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.g8k();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Companion.buildShader.<anonymous>' call
    // Inline function 'korlibs.korge.text.MsdfRender.createProgram.<anonymous>' call
    var tmp = this_0.u8l();
    var tmp_0 = this_0.u8l();
    var tmp_1 = this_0.u8l();
    var tmp_2 = this_0.u8l();
    var median$delegate = this_0.m8l(tmp, tmp_0, tmp_1, VOID, tmp_2, MsdfRender$createProgram$lambda).o8i(null, getLocalDelegateReference('median', KProperty0, false, function () {
      return THROW_ISE();
    }));
    var tmp_3 = Companion_getInstance_5().i9t_1;
    var tmp_4 = get_BB_MAX_TEXTURES() - 1 | 0;
    this_0.r8l(tmp_3, 0, tmp_4, MsdfRender$createProgram$lambda_0(this_0));
    var d = this_0.w8l(this_0.z8k());
    var alpha = this_0.x8l(this_0.z8k());
    this_0.l8k(this_0.o8k(), this_0.y8l(this_0.o8k(), this_0.s8k([this_0.r8k(0.5)])));
    if (msdf) {
      this_0.l8k(d, this_0.p8l(createProgram$_anonymous_$lambda$0_hhid5m(median$delegate), this_0.u8k(this_0.o8k(), 'r'), this_0.u8k(this_0.o8k(), 'g'), this_0.u8k(this_0.o8k(), 'b')));
    } else {
      this_0.l8k(d, this_0.u8k(this_0.o8k(), sdf));
    }
    this_0.l8k(alpha, this_0.o8l(SDFShaders_getInstance().d9z(), d));
    if (inverted) {
      this_0.l8k(alpha, this_0.y8l(this_0.r8k(1.0), alpha));
    }
    this_0.l8k(this_0.o8k(), this_0.p8k(this_0.m8k(), alpha));
    var tmp3_fragment = FragmentShader(this_0.t8k());
    return tmp1_$this.u96(VOID, tmp3_fragment, tmp2_name);
  }
  kc0(msdf, sdf, inverted, $super) {
    sdf = sdf === VOID ? 'a' : sdf;
    inverted = inverted === VOID ? false : inverted;
    return $super === VOID ? this.lc0(msdf, sdf, inverted) : $super.lc0.call(this, msdf, sdf, inverted);
  }
}
class TweenComponent {
  constructor(view, vs, fastTime, easing, callback, c, fastWaitTime, autoInvalidate) {
    fastTime = fastTime === VOID ? Companion_instance_1.s35() : fastTime;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    fastWaitTime = fastWaitTime === VOID ? Companion_instance_1.s35() : fastWaitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.mc0_1 = view;
    this.nc0_1 = vs;
    this.oc0_1 = fastTime;
    this.pc0_1 = easing;
    this.qc0_1 = callback;
    this.rc0_1 = c;
    this.sc0_1 = fastWaitTime;
    this.tc0_1 = autoInvalidate;
    this.uc0_1 = Companion_instance_1.r35();
    var tmp = this;
    var tmp_0;
    if (!equals(this.oc0_1, Companion_instance_1.s35())) {
      tmp_0 = this.oc0_1;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.nc0_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.b1();
      while (tmp0_iterator.c1()) {
        var item = tmp0_iterator.d1();
        // Inline function 'korlibs.korge.tween.TweenComponent.hrtime.<anonymous>' call
        var tmp$ret$0 = _FastDuration___get_nanoseconds__impl__pxizcb(item.ua0_1);
        destination.h(tmp$ret$0);
      }
      var tmp0_elvis_lhs = maxOrNull(destination);
      tmp_0 = get_fastNanoseconds(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    tmp.vc0_1 = tmp_0;
    this.wc0_1 = false;
    this.xc0_1 = false;
    this.yc0_1 = false;
    var tmp_1 = this;
    var tmp_2 = Companion_instance_9;
    tmp_1.zc0_1 = this.mc0_1.a7v(tmp_2, TweenComponent$updater$lambda(this));
    var tmp0_safe_receiver = this.rc0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.y2h(TweenComponent$lambda(this));
    }
    _update(this, Companion_instance_1.r35());
  }
  gc1() {
    return get_slow(this.sc0_1);
  }
  hc1() {
    if (this.yc0_1)
      return Unit_instance;
    this.yc0_1 = true;
    var tmp0_safe_receiver = this.rc0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.jd(tmp$ret$0);
    }
  }
  fc1() {
    if (this.xc0_1)
      return Unit_instance;
    this.xc0_1 = true;
    var tmp0_safe_receiver = this.zc0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p6();
    }
    this.zc0_1 = null;
    this.hc1();
  }
  ac1(elapsed) {
    if (equals(elapsed, Companion_instance_1.r35())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.nc0_1;
      var n = 0;
      while (n < this_0.g1()) {
        // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.h1(_unary__edvuaz).b4j();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.nc0_1;
    var n_0 = 0;
    while (n_0 < this_1.g1()) {
      // Inline function 'korlibs.korge.tween.TweenComponent.setTo.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var v = this_1.h1(_unary__edvuaz_0);
      var durationInTween = equals(v.sa0_1, Companion_instance_1.s35()) ? FastDuration__minus_impl_evs237(this.vc0_1, v.ra0_1) : v.sa0_1;
      var elapsedInTween = get_fastMilliseconds_0(clamp_0(_FastDuration___get_fastMilliseconds__impl__pe68va(FastDuration__minus_impl_evs237(elapsed, v.ra0_1)), 0.0, _FastDuration___get_fastMilliseconds__impl__pe68va(durationInTween)));
      var ratioInTween = FastDuration__compareTo_impl_4fhnj7(durationInTween, Companion_getInstance().mk_1) <= 0 || FastDuration__compareTo_impl_4fhnj7_0(elapsedInTween, durationInTween) >= 0 ? 1.0 : FastDuration__div_impl_rlslck(elapsedInTween, durationInTween);
      var easedRatioInTween = this.pc0_1.j27(ratioInTween);
      v.wa0(toRatio(easedRatioInTween));
    }
  }
  toString() {
    return 'TweenComponent(' + toString(this.mc0_1) + ')';
  }
}
class tween$slambda {
  constructor($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
    this.ic1_1 = $this_tween;
    this.jc1_1 = $tc;
    this.kc1_1 = $vs;
    this.lc1_1 = $time;
    this.mc1_1 = $easing;
    this.nc1_1 = $callback;
    this.oc1_1 = $waitTime;
    this.pc1_1 = $autoInvalidate;
  }
  f2y($this$withTimeoutNullable, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this, $this$withTimeoutNullable), $completion);
  }
  le(p1, $completion) {
    return this.f2y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_17 = this;
    this.qc1_1 = 90.0;
    this.rc1_1 = 32.0;
    this.sc1_1 = Size2D.n3q(90.0, 32.0);
  }
}
class CacheTexture {
  constructor($outer, ctx) {
    this.sc4_1 = $outer;
    this.oc4_1 = ctx;
    this.pc4_1 = this.oc4_1.i9x(16, 16, VOID, VOID, VOID, false);
    this.qc4_1 = TextureBase.p9r(this.pc4_1.s87(), 16, 16);
    this.rc4_1 = Texture(this.qc4_1);
  }
  tc4(width, height) {
    this.pc4_1.u87(0, 0, width, height);
    this.qc4_1.q9r(width);
    this.qc4_1.r9r(height);
    this.rc4_1 = Texture(this.qc4_1);
  }
  p6() {
    this.sc4_1.dbw_1 = null;
    this.oc4_1.j9x(this.pc4_1);
  }
}
class ZIndexComparator {
  uc4(a, b) {
    return compareTo(a.sbx(), b.sbx());
  }
  compare(a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.uc4(tmp, b instanceof View ? b : THROW_CCE());
  }
}
class ContainerCollection$iterator$1 {
  constructor(this$0) {
    this.lc7_1 = this$0;
    this.kc7_1 = 0;
  }
  c1() {
    return this.kc7_1 < this.lc7_1.ic7_1.obw();
  }
  d1() {
    var _unary__edvuaz = this.kc7_1;
    this.kc7_1 = _unary__edvuaz + 1 | 0;
    return this.lc7_1.ic7_1.qbw(_unary__edvuaz);
  }
  t6() {
    this.kc7_1 = this.kc7_1 - 1 | 0;
    this.lc7_1.ic7_1.rbw(this.kc7_1);
  }
}
class ContainerCollection {
  constructor(container, children) {
    this.hc7_1 = children;
    this.ic7_1 = container;
  }
  g1() {
    return this.ic7_1.obw();
  }
  mc7(element) {
    return element.z3g() === this.ic7_1;
  }
  z2(element) {
    if (!(element instanceof View))
      return false;
    return this.mc7(element instanceof View ? element : THROW_CCE());
  }
  nc7(elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.j1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.korge.view.ContainerCollection.containsAll.<anonymous>' call
        if (!(element.z3g() === this.ic7_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  a3(elements) {
    return this.nc7(elements);
  }
  j1() {
    return this.ic7_1.obw() === 0;
  }
  oc7(element) {
    this.ic7_1.ubw(element);
    return true;
  }
  h(element) {
    return this.oc7(element instanceof View ? element : THROW_CCE());
  }
  pc7(elements) {
    if (elements.j1())
      return false;
    var _iterator__ex2g4s = elements.b1();
    while (_iterator__ex2g4s.c1()) {
      var element = _iterator__ex2g4s.d1();
      this.ic7_1.ubw(element);
    }
    return true;
  }
  i1(elements) {
    return this.pc7(elements);
  }
  b1() {
    return new ContainerCollection$iterator$1(this);
  }
  qc7(element) {
    return this.ic7_1.cbx(element);
  }
  g3(element) {
    if (!(element instanceof View))
      return false;
    return this.qc7(element instanceof View ? element : THROW_CCE());
  }
  h1(index) {
    return this.hc7_1.h1(index);
  }
  b3() {
    return this.hc7_1.b3();
  }
  k1(index) {
    return this.hc7_1.k1(index);
  }
  q1(fromIndex, toIndex) {
    return this.hc7_1.q1(fromIndex, toIndex);
  }
}
class DummyView extends View {
  static rc9() {
    return this.sc9();
  }
  sbt(ctx) {
    return Unit_instance;
  }
}
class Companion_4 {}
class FixedSizeContainer extends Container {
  static tc9(size, clip) {
    size = size === VOID ? Size2D.w3j(100, 100) : size;
    clip = clip === VOID ? false : clip;
    var $this = this.bbk();
    $this.dc7_1 = clip;
    $this.ec7_1 = size;
    $this.fc7_1 = Ref(false);
    return $this;
  }
  p74() {
    return this.dc7_1;
  }
  nbt() {
    return this.ec7_1;
  }
  pbt() {
    return new Rectangle(0.0, 0.0, this.f3u(), this.g3u());
  }
  toString() {
    var out = super.toString();
    out = out + (':size=(' + get_niceStr(this.f3u()) + 'x' + get_niceStr(this.g3u()) + ')');
    return out;
  }
  sbt(ctx) {
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      var clip = this.p74();
      var renderingInternalRef = this.fc7_1;
      if (renderingInternalRef.w1()) {
        super.sbt(ctx);
        break $l$block_0;
      }
      if (clip) {
        var m = this.ube();
        var hasRotation = !(m.f3m_1 === 0.0) || !(m.g3m_1 === 0.0);
        if (hasRotation) {
          var old = renderingInternalRef.w1();
          try {
            renderingInternalRef.j43(true);
            renderFiltered(this, ctx, Companion_getInstance_38());
          }finally {
            renderingInternalRef.j43(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.a9n_1;
        if (!(ctx.e9n_1 === batcher)) {
          ctx.e9n_1 = batcher;
          ctx.o9o();
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d.<anonymous>' call
        // Inline function 'korlibs.korge.view.Companion.renderClipped.<anonymous>' call
        var c2d = ctx.c9n_1;
        var bounds = this.mbz(ctx).m3r(ctx.q9m_1).n3r();
        var rect = c2d.r9x_1.y9t().x8d();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.b3r(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_13().t8d(bounds);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var this_0 = c2d.r9x_1;
            var scissor_0 = c2d.b9y(scissor);
            var temp = this_0.h9o_1;
            this_0.o9u();
            this_0.h9o_1 = scissor_0;
            try {
              super.sbt(ctx);
              break $l$block_1;
            }finally {
              this_0.o9u();
              this_0.h9o_1 = temp;
            }
          }
        } else {
          // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
          super.sbt(ctx);
        }
      } else {
        // Inline function 'korlibs.korge.view.FixedSizeContainer.renderInternal.<anonymous>' call
        super.sbt(ctx);
      }
    }
  }
}
class SContainer extends FixedSizeContainer {
  static pbm(size, clip) {
    size = size === VOID ? Size2D.w3j(100, 100) : size;
    clip = clip === VOID ? false : clip;
    return this.tc9(size, clip);
  }
}
class TimeSlidingWindow {
  constructor(capacity) {
    this.vc9_1 = capacity;
    this.wc9_1 = IntDeque.z3y(this.vc9_1);
    this.xc9_1 = 0;
  }
  g1() {
    return this.wc9_1.g1();
  }
  yc9() {
    return this.wc9_1.g1() === 0 ? get_fastSeconds(0) : get_fastMicroseconds(this.xc9_1 / this.wc9_1.g1());
  }
  zc9() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return div(tmp$ret$1, this.yc9());
  }
  aca(index) {
    return get_fastMicroseconds_0(this.wc9_1.h1(index));
  }
  bca(value) {
    var intValue = numberToInt(_FastDuration___get_fastMicroseconds__impl__e641g1(value));
    this.wc9_1.e3z(intValue);
    this.xc9_1 = this.xc9_1 + intValue | 0;
    if (this.wc9_1.g1() > this.vc9_1) {
      this.xc9_1 = this.xc9_1 - this.wc9_1.ql() | 0;
    }
  }
}
class RectBase extends View {
  static aci(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_16().s3h_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.sc9();
    $this.mch_1 = smoothing;
    $this.zch(hitShape);
    var tmp = $this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    tmp.nch_1 = get_Bitmaps_white();
    $this.och_1 = anchor;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_14();
    var tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.pch_1 = new TexturedVertexArray(4, tmp$ret$1);
    $this.qch_1 = null;
    $this.rch_1 = null;
    return $this;
  }
  sch(_set____db54di) {
    this.mch_1 = _set____db54di;
  }
  tch(v) {
    if (!(this.nch_1 === v)) {
      this.nch_1 = v;
      this.mb9_1 = true;
      this.ibw();
    }
  }
  uch() {
    return this.och_1;
  }
  icf() {
    return 0.0;
  }
  jcf() {
    return 0.0;
  }
  ebx() {
    return this.uch().b3i_1 * this.icf();
  }
  fbx() {
    return this.uch().c3i_1 * this.jcf();
  }
  vch() {
    return -this.ebx();
  }
  wch() {
    return -this.fbx();
  }
  sbt(ctx) {
    if (!this.oby())
      return Unit_instance;
    var tmp = this.nch_1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    if (tmp === get_Bitmaps_transparent())
      return Unit_instance;
    if (this.mb9_1) {
      this.mb9_1 = false;
      this.ych();
    }
    this.xch(ctx);
  }
  xch(ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.a9n_1;
    var this_1 = this_0.j9n_1;
    if (!(this_1.e9n_1 === this_0)) {
      this_1.e9n_1 = this_0;
      this_1.o9o();
    }
    var tmp0_safe_receiver = this.rch_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(ctx);
    var array = this.pch_1;
    var tex = ctx.d9x(this.nch_1).r4s();
    var smoothing = this.mch_1;
    var blendMode = this.sby();
    var program = this.qch_1;
    var vcount = array.i9u_1;
    var icount = array.j9u_1;
    var matrix = Companion_getInstance_21().a3m_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.m9r_1;
      this_0.b9u(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_5().l9t_1 : program;
      if (this_0.q9u(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this_0.t9t();
      if (!contains(this_0.z9n_1, tex_0)) {
        this_0.y9n_1 = 0;
        this_0.z9n_1[0] = tex_0;
      }
      this_0.a9o_1 = smoothing;
      this_0.b9o_1 = blendMode;
      this_0.c9o_1 = pprogram;
    }
    this_0.n9u(array, matrix, vcount, icount);
  }
  ych() {
    this.pch_1.p9z(0, this.vch(), this.wch(), this.icf(), this.jcf(), this.ube(), this.nch_1, this.tby());
  }
  pbt() {
    return Companion_getInstance_19().l3q(this.vch(), this.wch(), this.icf(), this.jcf());
  }
  toString() {
    var out = super.toString();
    if (!this.uch().equals(Companion_getInstance_16().s3h_1))
      out = out + (':anchor=(' + this.bbz(this.uch().b3i_1) + ', ' + this.bbz(this.uch().c3i_1) + ')');
    return out;
  }
}
class BaseImage extends RectBase {
  static zce(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_16().s3h_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.aci(anchor, hitShape, smoothing);
    $this.tce_1 = false;
    $this.uce_1 = bitmap;
    $this.hcf();
    return $this;
  }
  vce(value) {
    if (equals(this.nch_1, value))
      return Unit_instance;
    this.tce_1 = true;
    this.tch(value);
  }
  i6n() {
    return this.nch_1;
  }
  hcf() {
    if (this.tce_1)
      return Unit_instance;
    trySetSourceActually(this);
  }
  sbt(ctx) {
    this.hcf();
    super.sbt(ctx);
  }
  icf() {
    return this.nch_1.f3u();
  }
  jcf() {
    return this.nch_1.g3u();
  }
  k4t() {
    return this.nch_1.k4t();
  }
  l4t() {
    return this.nch_1.l4t();
  }
  u4s() {
    return this.nch_1.u4s();
  }
  v4s() {
    return this.nch_1.v4s();
  }
  kcf() {
    return this.uch().b3i_1 * this.u4s();
  }
  lcf() {
    return this.uch().c3i_1 * this.v4s();
  }
  ebx() {
    return this.kcf() - this.k4t();
  }
  fbx() {
    return this.lcf() - this.l4t();
  }
  pbt() {
    return Companion_getInstance_19().l3q(-this.kcf(), -this.lcf(), this.u4s(), this.v4s());
  }
  toString() {
    return super.toString() + (':bitmap=' + toString(this.i6n()));
  }
}
class ViewFileRef {}
function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
  currentVfs = currentVfs === VOID ? views.hb6_1 : currentVfs;
  sourceFile = sourceFile === VOID ? null : sourceFile;
  return $super === VOID ? this.ccf(views, currentVfs, sourceFile, $completion) : $super.ccf.call(this, views, currentVfs, sourceFile, $completion);
}
class SmoothedBmpSlice {}
class Image extends BaseImage {
  static yce(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_16().s3h_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.zce(bitmap, anchor, hitShape, smoothing);
    $this.kcc_1 = new Mixin_0();
    $this.lcc_1 = sourceFile$factory($this);
    return $this;
  }
  static acf(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_16().s3h_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.yce(Resourceable(bitmap), anchor, hitShape, smoothing);
  }
  sbt(ctx) {
    this.bcf(ctx, this);
    super.sbt(ctx);
  }
  ccf(views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_forceLoadSourceFile__yy5vos.bind(VOID, this, views, currentVfs, sourceFile), $completion);
  }
  ecf(_set____db54di) {
    this.kcc_1.wce_1 = _set____db54di;
  }
  fcf(_set____db54di) {
    this.kcc_1.fcf(_set____db54di);
  }
  gcf() {
    return this.kcc_1.xce_1;
  }
  mcc(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_baseForceLoadSourceFile__natc6b.bind(VOID, _this__u8e3s4, this, views, currentVfs, sourceFile), $completion);
  }
  bcf(ctx, view) {
    this.kcc_1.bcf(ctx, view);
  }
}
class Companion_5 {}
class Stage extends FixedSizeContainer {
  static vb4(views) {
    var $this = this.tc9();
    $this.rb4_1 = views.ub5_1;
    $this.sb4_1 = views;
    $this.tb4_1 = clipBorders$factory($this.rbg());
    $this.ub4_1 = virtualSizeDouble$factory($this.rbg());
    $this.jbx($this);
    $this.lbx($this);
    return $this;
  }
  rbg() {
    return this.sb4_1;
  }
  bci(_set____db54di) {
    var this_0 = this.tb4_1;
    clip$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  p74() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.tb4_1;
    clip$factory_0();
    return this_0.get();
  }
  cci(_set____db54di) {
    var this_0 = this.ub4_1;
    unscaledSize$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  nbt() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ub4_1;
    unscaledSize$factory_0();
    return this_0.get();
  }
  dci() {
    return this.rbg().qb5_1;
  }
  mby() {
    return this;
  }
  jbw() {
    return this;
  }
  i9q() {
    return this.jc7(this.rbg());
  }
  kbw(view) {
    this.rbg().kbw(view);
  }
  toString() {
    return 'Stage';
  }
  z2e() {
    return this.sb4_1.kb5_1;
  }
  v9v(pos) {
    return this.rb4_1.v9v(pos);
  }
  h9v(value) {
    this.rb4_1.h9v(value);
  }
  i9v() {
    return this.rb4_1.i9v();
  }
  j9v(value) {
    this.rb4_1.j9v(value);
  }
  k9v() {
    return this.rb4_1.k9v();
  }
  l9v(value) {
    this.rb4_1.l9v(value);
  }
  m9v() {
    return this.rb4_1.m9v();
  }
  n9v(value) {
    this.rb4_1.n9v(value);
  }
  o9v(value) {
    this.rb4_1.o9v(value);
  }
  p9v() {
    return this.rb4_1.p9v();
  }
  q9v() {
    return this.rb4_1.q9v();
  }
  r9v() {
    return this.rb4_1.r9v();
  }
  s9v() {
    return this.rb4_1.s9v();
  }
  t9v() {
    return this.rb4_1.t9v();
  }
  u9v() {
    return this.rb4_1.u9v();
  }
}
class ColorReference {}
class Companion_6 {
  gci(left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 || rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        lCount = lCount - 1 | 0;
        var tmp0_safe_receiver = l;
        l = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z3g();
      }
      if (rdec) {
        rCount = rCount - 1 | 0;
        var tmp1_safe_receiver = r;
        r = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.z3g();
      }
    }
    return null;
  }
}
class ViewRenderPhase {}
function render_0(view, ctx) {
  return view.zby(ctx);
}
function beforeRender(view, ctx) {
  return Unit_instance;
}
function afterRender(view, ctx) {
  return Unit_instance;
}
class ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda {
  constructor($view, $ctx, this$0) {
    this.pci_1 = $view;
    this.qci_1 = $ctx;
    this.rci_1 = this$0;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this), $completion);
  }
}
class Mixin_0 {
  constructor() {
    this.wce_1 = true;
    this.xce_1 = null;
  }
  ecf(_set____db54di) {
    this.wce_1 = _set____db54di;
  }
  fcf(value) {
    this.wce_1 = false;
    this.xce_1 = value;
  }
  mcc(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.fcf(sourceFile);
    _this__u8e3s4.ecf(true);
  }
  ccf(views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Must override this';
    throw NotImplementedError.je('An operation is not implemented: ' + reason);
  }
  bcf(ctx, view) {
    if (this.wce_1)
      return Unit_instance;
    this.sci(ctx, view);
  }
  sci(ctx, view) {
    if (!this.wce_1 && !(this.xce_1 == null)) {
      this.wce_1 = true;
      launchImmediately_0(ctx.g9m_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0(view, ctx, this));
    }
  }
}
class Views$close$slambda {
  constructor(this$0) {
    this.tci_1 = this$0;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
  }
}
class Views extends BaseEventListener {
  static jbd(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    injector = injector === VOID ? new Injector() : injector;
    input = input === VOID ? new Input() : input;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    stats = stats === VOID ? new Stats() : stats;
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_5().e9t_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    var $this = this.y7u();
    $this.jb5_1 = new Mixin();
    $this.kb5_1 = coroutineContext;
    $this.lb5_1 = ag;
    $this.mb5_1 = injector;
    $this.nb5_1 = input;
    $this.ob5_1 = timeProvider;
    $this.pb5_1 = stats;
    $this.qb5_1 = gameWindow;
    $this.rb5_1 = gameId;
    $this.sb5_1 = settingsFolder;
    $this.tb5_1 = batchMaxQuads;
    $this.ub5_1 = bp;
    $this.vb5_1 = stageBuilder;
    $this.wb5_1 = quality$factory($this.qb5_1);
    $this.xb5_1 = $this;
    $this.yb5_1 = false;
    $this.zb5_1 = continuousRenderMode$factory($this.qb5_1);
    $this.ab6_1 = new ReshapeEvent(0, 0);
    $this.bb6_1 = new UpdateEvent();
    $this.cb6_1 = new ViewsUpdateEvent($this);
    $this.db6_1 = new ViewsResizedEvent($this);
    var tmp_0 = $this;
    tmp_0.eb6_1 = lazy(Views$realSettingsFolder$delegate$lambda($this));
    $this.gb6_1 = null;
    $this.hb6_1 = get_resourcesVfs();
    $this.ib6_1 = get_RegisteredImageFormats();
    $this.jb6_1 = new RenderContext($this.lb5_1, $this, $this.qb5_1, $this.pb5_1, $this.kb5_1, $this.tb5_1, $this.qb5_1);
    $this.kb6_1 = true;
    $this.lb6_1 = Colors_getInstance().z57_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.mb6_1 = HashMap.a9();
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_2.nb6_1 = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
    $this.ob6_1 = new Resources($this.kb5_1, $this.hb6_1);
    $this.pb6_1 = false;
    $this.qb6_1 = 1280;
    $this.rb6_1 = 720;
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_3.sb6_1 = ArrayList.z();
    $this.tb6_1 = Companion_getInstance_15().k3s_1;
    $this.ub6_1 = Companion_getInstance_16().w3h_1;
    $this.vb6_1 = true;
    $this.wb6_1 = $this.vb5_1($this);
    $this.xb6_1 = $this.wb6_1;
    $this.yb6_1 = true;
    $this.zb6_1 = false;
    $this.ab7_1 = debugExtraFontScale$factory($this.jb6_1);
    $this.bb7_1 = debugExtraFontColor$factory($this.jb6_1);
    $this.cb7_1 = FastArrayList.u28();
    $this.db7_1 = $this.ob5_1.m35();
    var tmp_4 = $this;
    tmp_4.eb7_1 = Pool.d42(VOID, Views$tempViewsPool$lambda);
    $this.fb7_1 = SizeInt.y3s();
    $this.gb7_1 = SizeInt.y3s();
    $this.hb7_1 = SizeInt.y3s();
    $this.ib7_1 = new Signal();
    $this.jb7_1 = new Signal();
    $this.kb7_1 = -1.0;
    $this.mb5_1.e7s(getKClass(CoroutineContext), $this.kb5_1);
    $this.mb5_1.e7s(getKClass(AG), $this.lb5_1);
    $this.mb5_1.e7s(getKClass(Views), $this);
    $this.jb7_1.q38(Views$lambda($this));
    $this.ib7_1.q38(Views$lambda_0($this));
    installFpsDebugOverlay($this);
    $this.lb7_1 = Companion_instance_10.cj('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    $this.mb7_1 = new EventResult();
    $this.nb7_1 = new Signal();
    $this.ob7_1 = Companion_getInstance_0().g26('debugHightlightView');
    $this.pb7_1 = new Signal();
    $this.qb7_1 = new Signal();
    $this.rb7_1 = ArrayList.z();
    $this.sb7_1 = updatedSinceFrame$factory($this.qb5_1);
    return $this;
  }
  z2e() {
    return this.kb5_1;
  }
  rbg() {
    return this.xb5_1;
  }
  ubd(_set____db54di) {
    var this_0 = this.zb5_1;
    forceRenderEveryFrame$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  obd() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.zb5_1;
    forceRenderEveryFrame$factory_0();
    return this_0.get();
  }
  f3() {
    return this.nb5_1.w9p_1;
  }
  vci() {
    return replace(replace(replace(this.rb5_1, '\\', ''), '/', ''), '..', '');
  }
  vbe() {
    var tmp = this.fb6_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  }
  o3f($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_init__qn9atk.bind(VOID, this), $completion);
  }
  tbd() {
    return this.ob6_1;
  }
  vbd() {
    return this.lb5_1.v83().o83_1;
  }
  wbd() {
    return this.lb5_1.v83().p83_1;
  }
  wci(value) {
    this.qb6_1 = numberToInt(value);
  }
  xci() {
    return this.qb6_1;
  }
  yci(value) {
    this.rb6_1 = numberToInt(value);
  }
  zci() {
    return this.rb6_1;
  }
  fci(value) {
    this.wci(value.u3j_1);
    this.yci(value.v3j_1);
  }
  eci() {
    return Size2D.r3q(this.xci(), this.zci());
  }
  p6() {
    launchImmediately(this, Views$close$slambda_0(this));
  }
  uci($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_closeSuspend__agjafw.bind(VOID, this), $completion);
  }
  qbe() {
    return this.wb6_1.i9q();
  }
  kbd(_set____db54di) {
    var this_0 = this.ab7_1;
    debugFontExtraScale$factory();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  acj() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ab7_1;
    debugFontExtraScale$factory_0();
    return this_0.get();
  }
  lbd(_set____db54di) {
    var this_0 = this.bb7_1;
    debugFontColor$factory();
    var value = new RGBA(_set____db54di);
    this_0.set(value);
    return Unit_instance;
  }
  bcj() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.bb7_1;
    debugFontColor$factory_0();
    return this_0.get().o5p_1;
  }
  uc9(block) {
    this.cb7_1.h(block);
  }
  ccj(width, height) {
    this.qb6_1 = width;
    this.rb6_1 = height;
    this.dcj();
  }
  c7v(type, event, result, up, down) {
    event.v7v(false);
    var result_0 = super.c7v(type, event, result, up, down);
    var e = event;
    e.u7v(this.xb5_1);
    if (e instanceof KeyEvent) {
      this.nb5_1.p9q(e);
      this.nb5_1.w9p_1.g9p(e);
      if (e.q7w_1.equals(Type_UP_getInstance_0()) && this.yb6_1 && (e.s7w_1.equals(Key_F12_getInstance()) || e.s7w_1.equals(Key_F7_getInstance()))) {
        this.zb6_1 = !this.zb6_1;
        this.qb5_1.na5(this.zb6_1);
        this.kbw(this.wb6_1);
      }
    }
    try {
      return this.wb6_1.l7v(e);
    } catch ($p) {
      if ($p instanceof StopPropagatingException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
    return result_0;
  }
  ecj(frameBuffer) {
    this.jb6_1.f9n_1 = frameBuffer;
    if (this.kb6_1) {
      var tmp0_$this = this.jb6_1;
      var tmp1_color = this.lb6_1;
      tmp0_$this.c9x(tmp1_color, 1.0, 0, true, true, true);
    }
    this.ib7_1.r38(this.jb6_1);
    this.jb6_1.o9o();
    this.wb6_1.obt(this.jb6_1);
    this.jb6_1.o9o();
    this.wb6_1.wbw(this.jb6_1);
    if (this.zb6_1) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.cb7_1.s28_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.Views.renderNew.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz](this, this.jb6_1);
      }
    }
    this.jb7_1.r38(this.jb6_1);
    this.jb6_1.o9o();
  }
  fcj(frameBuffer, $super) {
    frameBuffer = frameBuffer === VOID ? this.lb5_1.v83() : frameBuffer;
    var tmp;
    if ($super === VOID) {
      this.ecj(frameBuffer);
      tmp = Unit_instance;
    } else {
      tmp = $super.ecj.call(this, frameBuffer);
    }
    return tmp;
  }
  gcj() {
    this.lb5_1.z83();
    this.fcj();
  }
  pbd(fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.ob5_1.m35();
    this.xb5_1.pb5_1.z83();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_27().db2_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.korge.view.Views.frameUpdateAndRender.<anonymous>' call
      var tmp$ret$0 = 'ag.onRender';
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var delta = DateTime__minus_impl_10njw8(currentTime, this.db7_1);
    var adelta = Duration__compareTo_impl_pchp0f(delta, this.xb5_1.nb6_1) > 0 ? this.xb5_1.nb6_1 : delta;
    this.db7_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, Companion_instance_1.s35())) {
        this.icj(fixedSizeStep);
      } else {
        this.hcj(adelta);
      }
    }
    var doRender2 = doRender && (forceRender || this.jcj() > 0);
    if (doRender2) {
      if (this.lb7_1) {
        println('Views.frameUpdateAndRender[' + Companion_getInstance_4().o35().toString() + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.jcj() + ']');
      }
      this.gcj();
      this.z83();
    }
  }
  hcj(elapsed) {
    return this.icj(get_fast(elapsed));
  }
  icj(elapsed) {
    this.nb5_1.n9q(elapsed);
    this.mb7_1.u1w();
    updateSingleViewWithViewsAll(this.wb6_1, this, elapsed);
    this.nb5_1.o9q(elapsed);
  }
  nbd() {
  }
  sbd(width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.gb7_1 = SizeInt.x3s(actualWidth, actualHeight);
    this.dcj();
  }
  dcj() {
    setBoundsInfo(this.ub5_1, Size2D.w3j(this.qb6_1, this.rb6_1), toFloat(this.gb7_1), this.tb6_1, this.ub6_1, toRef(virtualSize$factory(this)), toRef(targetSize$factory(this)));
    this.jb6_1.m9m_1 = this.ub5_1.m9v();
    this.jb6_1.n9m_1 = this.ub5_1.i9v();
    // Inline function 'kotlin.also' call
    var this_0 = this.ab6_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_0.k7w_1 = this.gb7_1.v3s_1;
    this_0.l7w_1 = this.gb7_1.w3s_1;
    this.l7v(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = this.db6_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.Views.resized.<anonymous>' call
    this_1.ncj_1 = this.fb7_1;
    this.l7v(this_1);
    this.wb6_1.mbw();
  }
  ocj(viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened && !this.qb5_1.oa5())
      return Unit_instance;
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = this.ob7_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.korge.view.Views.debugHightlightView.<anonymous>' call
      var tmp$ret$0 = 'debugHightlightView: ' + toString_0(viewToHightlight);
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.nb7_1.r38(viewToHightlight);
  }
  tbe(viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.ocj(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_instance;
    } else {
      tmp = $super.ocj.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  }
  pcj(_set____db54di) {
    var this_0 = this.sb7_1;
    updatedSinceFrame$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  jcj() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.sb7_1;
    updatedSinceFrame$factory_1();
    return this_0.get();
  }
  z83() {
    this.qb5_1.z83();
  }
  kbw(view) {
    this.qb5_1.ca6();
  }
  c28(value) {
    this.jb5_1.c28(value);
  }
  d28() {
    return this.jb5_1.d28();
  }
  v9v(pos) {
    return this.ub5_1.v9v(pos);
  }
  h9v(value) {
    this.ub5_1.h9v(value);
  }
  i9v() {
    return this.ub5_1.i9v();
  }
  j9v(value) {
    this.ub5_1.j9v(value);
  }
  k9v() {
    return this.ub5_1.k9v();
  }
  l9v(value) {
    this.ub5_1.l9v(value);
  }
  m9v() {
    return this.ub5_1.m9v();
  }
  n9v(value) {
    this.ub5_1.n9v(value);
  }
  o9v(value) {
    this.ub5_1.o9v(value);
  }
  p9v() {
    return this.ub5_1.p9v();
  }
  q9v() {
    return this.ub5_1.q9v();
  }
  r9v() {
    return this.ub5_1.r9v();
  }
  s9v() {
    return this.ub5_1.s9v();
  }
  t9v() {
    return this.ub5_1.t9v();
  }
  u9v() {
    return this.ub5_1.u9v();
  }
  n9x() {
    return this.qb5_1.n9x();
  }
  o9x() {
    return this.qb5_1.o9x();
  }
  p9x() {
    return this.qb5_1.p9x();
  }
  x9w() {
    return this.qb5_1.x9w();
  }
}
class Companion_7 {}
class ViewsUpdateEvent extends Event {
  constructor(views, fastDelta) {
    fastDelta = fastDelta === VOID ? Companion_instance_1.r35() : fastDelta;
    super();
    this.mci_1 = views;
    this.nci_1 = fastDelta;
  }
  oci() {
    return toDuration_0(this.nci_1);
  }
  p3m() {
    return Companion_instance_21;
  }
  toString() {
    return 'ViewsUpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.nci_1) + ')';
  }
}
class Companion_8 {}
class ViewsResizedEvent extends Event {
  constructor(views, size) {
    size = size === VOID ? SizeInt.x3s(0, 0) : size;
    super();
    this.mcj_1 = views;
    this.ncj_1 = size;
  }
  p3m() {
    return Companion_instance_22;
  }
  toString() {
    return 'ViewsResizedEvent(size=' + this.ncj_1.toString() + ')';
  }
}
class ImageAnimationView extends Container {
  static ocp(animation, direction, createImage) {
    animation = animation === VOID ? null : animation;
    direction = direction === VOID ? null : direction;
    var $this = this.bbk();
    $this.ycl_1 = createImage;
    $this.zcl_1 = 1;
    $this.acm_1 = null;
    $this.bcm_1 = null;
    $this.ccm_1 = null;
    $this.dcm_1 = animation;
    $this.ecm_1 = direction;
    var tmp = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.bbk(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp.fcm_1 = addTo(this_0, $this);
    $this.gcm_1 = fastArrayListOf([]);
    $this.hcm_1 = FastStringMap();
    $this.icm_1 = get_fastMilliseconds(0);
    $this.jcm_1 = 0;
    $this.kcm_1 = 1;
    $this.lcm_1 = Companion_getInstance_18().t3i_1;
    $this.mcm_1 = true;
    $this.ncm_1 = true;
    didSetAnimation($this);
    addFastUpdater_0($this, ImageAnimationView$lambda);
    return $this;
  }
  ncp() {
    return TileMap.pcp();
  }
  qcp(value) {
    if (!(this.dcm_1 === value)) {
      this.dcm_1 = value;
      didSetAnimation(this);
    }
  }
  ocm() {
    return this.gcm_1;
  }
  rcp(value) {
    this.lcm_1 = value;
    // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
    var tmp$ret$0 = Vector2D.y3k(-value.r3i_1, -value.s3i_1);
    this.fcm_1.z6w(tmp$ret$0);
  }
  scp() {
    return this.lcm_1;
  }
  tcp(value) {
    this.rcp(Vector2D.y3k(value.b3i_1 * this.f3u(), value.c3i_1 * this.g3u()));
  }
  uch() {
    return Anchor2D.f3i(this.scp().r3i_1 / this.f3u(), this.scp().s3i_1 / this.g3u());
  }
  sch(value) {
    if (!(this.mcm_1 === value)) {
      this.mcm_1 = value;
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.gcm_1.s28_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.korge.view.animation.ImageAnimationView.<set-smoothing>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var it = array[_unary__edvuaz];
        if (isInterface(it, SmoothedBmpSlice)) {
          it.sch(value);
        }
      }
    }
  }
  ucp() {
    this.ncm_1 = true;
  }
  i79() {
    this.ncm_1 = false;
  }
}
class ImageDataView extends Container {
  static kcs(data, animation, playing, smoothing) {
    data = data === VOID ? null : data;
    animation = animation === VOID ? null : animation;
    playing = playing === VOID ? false : playing;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.bbk();
    $this.dcs_1 = $this.lcs();
    $this.ecs_1 = anchorPixel$factory($this.jcs());
    $this.fcs_1 = anchor$factory($this.jcs());
    $this.gcs_1 = true;
    $this.hcs_1 = data;
    $this.ics_1 = animation;
    updatedDataAnimation($this);
    if (playing) {
      $this.ucp();
    } else {
      $this.i79();
    }
    $this.sch(smoothing);
    return $this;
  }
  lcs() {
    // Inline function 'korlibs.korge.view.animation.imageAnimationView' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = ImageAnimationView.ocp(null, null, ImageDataView$createAnimationView$lambda);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.animation.imageAnimationView.<anonymous>' call
    return addTo(this_0, this);
  }
  jcs() {
    return this.dcs_1;
  }
  sch(value) {
    if (!(this.gcs_1 === value)) {
      this.gcs_1 = value;
      this.jcs().sch(value);
    }
  }
  ucp() {
    this.jcs().ucp();
  }
  i79() {
    this.jcs().i79();
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_23 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.mcs_1 = new Float64Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
  }
  ncs(scale) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var this_0 = this.mcs_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var minElem = this_0[0];
      var lastIndex = get_lastIndex(this_0);
      if (lastIndex === 0) {
        tmp$ret$1 = minElem;
        break $l$block_0;
      }
      // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_1 = scale - minElem;
      var minValue = Math.abs(this_1);
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = this_0[i];
          // Inline function 'korlibs.korge.view.filter.Companion.discretizeFilterScale.<anonymous>' call
          // Inline function 'kotlin.math.absoluteValue' call
          var this_2 = scale - e;
          var v = Math.abs(this_2);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = minElem;
    }
    return ensureNotNull(tmp$ret$1);
  }
}
class Filter {}
function get_recommendedFilterScale() {
  return 1.0;
}
function computeBorder(texWidth, texHeight) {
  return Companion_getInstance_23().p3l_1;
}
class RenderToTextureResult {
  constructor() {
    this.rcs_1 = null;
    this.scs_1 = 0;
    this.tcs_1 = 0;
    this.ucs_1 = 0;
    this.vcs_1 = 0;
    this.wcs_1 = 1.0;
    this.xcs_1 = Companion_getInstance_21().z3l_1;
    this.ycs_1 = null;
    this.zcs_1 = null;
    this.act_1 = null;
    this.bct_1 = null;
  }
  k2i() {
    if (this.zcs_1 == null || this.bct_1 == null)
      return Unit_instance;
    var tmp0_safe_receiver = this.zcs_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.filter.RenderToTextureResult.dispose.<anonymous>' call
      var tmp0_safe_receiver_0 = this.bct_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.j9x(tmp0_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.rcs_1 = null;
    this.ycs_1 = null;
    this.zcs_1 = null;
    this.bct_1 = null;
    this.act_1 = null;
  }
}
class IdentityFilter {
  constructor(smoothing) {
    Companion_getInstance_38();
    this.cct_1 = smoothing;
  }
  qcs(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.a9n_1;
    var this_1 = this_0.j9n_1;
    if (!(this_1.e9n_1 === this_0)) {
      this_1.e9n_1 = this_0;
      this_1.o9o();
    }
    this_0.q9o(texture, VOID, VOID, VOID, VOID, matrix, this.cct_1, renderColorMul, blendMode, Companion_getInstance_5().l9t_1);
  }
}
class Companion_10 extends IdentityFilter {
  constructor() {
    Companion_instance_24 = null;
    super(true);
    Companion_instance_24 = this;
  }
}
class ViewRenderPhaseFilter {}
class Info {
  constructor(tex, vertices) {
    this.ect_1 = tex;
    this.fct_1 = vertices;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = FastArrayList.u28();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.tiles.Info.verticesList.<anonymous>' call
    this_0.h(this.fct_1);
    tmp.gct_1 = this_0;
  }
  hct(vertices) {
    vertices.u1w();
    this.fct_1 = vertices;
    this.gct_1.h(vertices);
  }
  u1w() {
    this.fct_1.t9z_1 = 0;
    this.fct_1.s9z_1 = 0;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_25 = this;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(8), null);
    while (tmp_0 < 8) {
      var tmp_2 = tmp_0;
      var tmp_3 = Companion_getInstance_39();
      // Inline function 'korlibs.memory.extract' call
      // Inline function 'korlibs.memory.extract1' call
      var tmp_4 = !(((tmp_2 >>> 0 | 0) & 1) === 0);
      // Inline function 'korlibs.memory.extract' call
      // Inline function 'korlibs.memory.extract1' call
      var tmp_5 = !(((tmp_2 >>> 1 | 0) & 1) === 0);
      // Inline function 'korlibs.memory.extract' call
      // Inline function 'korlibs.memory.extract1' call
      var tmp$ret$6 = !(((tmp_2 >>> 2 | 0) & 1) === 0);
      tmp_1[tmp_2] = computeIndices$default(tmp_3, tmp_4, tmp_5, tmp$ret$6);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.ict_1 = tmp_1;
  }
}
class TileMap extends View {
  static pcp(map, tileset, smoothing, tileSize) {
    Companion_getInstance_39();
    map = map === VOID ? TileMapData.n6y(1, 1) : map;
    tileset = tileset === VOID ? map.j6y_1 : tileset;
    smoothing = smoothing === VOID ? true : smoothing;
    tileSize = tileSize === VOID ? tileset.s6z() : tileSize;
    var $this = this.sc9();
    $this.pco_1 = map;
    $this.qco_1 = smoothing;
    $this.rco_1 = tileSize;
    $this.sco_1 = 0.0;
    $this.tco_1 = 0.0;
    $this.uco_1 = $this.pco_1.k6y_1;
    $this.vco_1 = $this.pco_1.l6y_1;
    $this.wco_1 = 0;
    $this.xco_1 = -1;
    $this.yco_1 = -1;
    $this.zco_1 = new FastIdentityCacheMap();
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.acp_1 = ArrayList.z();
    var tmp_0 = $this;
    var tmp_1 = TileMap$infosPool$lambda;
    tmp_0.bcp_1 = Pool.c42(tmp_1, VOID, TileMap$infosPool$lambda_0);
    $this.ccp_1 = Companion_getInstance_19().k3q(-1, -1, -1, -1);
    $this.dcp_1 = Companion_getInstance_19().k3q(-1, -1, -1, -1);
    $this.ecp_1 = new Float32Array(4);
    $this.fcp_1 = new Float32Array(4);
    $this.gcp_1 = 0;
    $this.hcp_1 = 0;
    var tmp_2 = $this;
    // Inline function 'kotlin.emptyArray' call
    tmp_2.icp_1 = [];
    $this.jcp_1 = new Int32Array(0);
    $this.kcp_1 = new Float64Array(0);
    $this.lcp_1 = tileset;
    updatedTileSet($this);
    addFastUpdater_0($this, TileMap$lambda(tileset));
    return $this;
  }
  sbt(ctx) {
    if (!this.oby())
      return Unit_instance;
    computeVertexIfRequired(this, ctx);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.a9n_1;
    var this_1 = this_0.j9n_1;
    if (!(this_1.e9n_1 === this_0)) {
      this_1.e9n_1 = this_0;
      this_1.o9o();
    }
    var this_2 = this.acp_1;
    var n = 0;
    while (n < this_2.g1()) {
      // Inline function 'korlibs.korge.view.tiles.TileMap.renderInternal.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var info = this_2.h1(_unary__edvuaz);
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = info.gct_1.s28_1;
      var n_0 = 0;
      while (n_0 < array.length) {
        // Inline function 'korlibs.korge.view.tiles.TileMap.renderInternal.<anonymous>.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var vertices = array[_unary__edvuaz_0];
        // Inline function 'korlibs.korge.render.BatchBuilder2D.drawVertices' call
        var array_0 = vertices.r9z_1;
        var tex = ctx.e9x(info.ect_1);
        var smoothing = this.qco_1;
        var blendMode = this.sby();
        var vcount = vertices.s9z_1;
        var icount = vertices.t9z_1;
        var matrix = Companion_getInstance_21().a3m_1;
        $l$block: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
          var tex_0 = tex.m9r_1;
          this_0.b9u(icount, vcount);
          var pprogram = null == null ? Companion_getInstance_5().l9t_1 : null;
          if (this_0.q9u(tex_0, smoothing, blendMode, pprogram)) {
            break $l$block;
          }
          this_0.t9t();
          if (!contains(this_0.z9n_1, tex_0)) {
            this_0.y9n_1 = 0;
            this_0.z9n_1[0] = tex_0;
          }
          this_0.a9o_1 = smoothing;
          this_0.b9o_1 = blendMode;
          this_0.c9o_1 = pprogram;
        }
        this_0.n9u(array_0, matrix, vcount, icount);
      }
    }
  }
  mcp(value) {
    if (this.lcp_1 === value)
      return Unit_instance;
    this.lcp_1 = value;
    updatedTileSet(this);
  }
  pbt() {
    return Companion_getInstance_19().l3q(0.0, 0.0, this.sco_1 * this.pco_1.f3u(), this.tco_1 * this.pco_1.g3u());
  }
}
//endregion
function *_generator_invoke__zhh2q8($this, $this$withContext, $completion) {
  var tmp = KorgeRunner_instance.cb2($this.rb0_1.bb2(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this.sb0_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance_13;
function Companion_getInstance_27() {
  if (Companion_instance_13 === VOID)
    new Companion();
  return Companion_instance_13;
}
function *_generator_start__v5y7pu($this, entry, $completion) {
  var tmp = Companion_getInstance_1().e38($this.yb1_1);
  var tmp_0 = withContext(tmp, Korge$start$slambda_0($this, entry), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function Korge$_init_$lambda_95dffl(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$_init_$slambda_ys8r4w_0() {
  var i = new Korge$_init_$slambda_ys8r4w();
  var l = function (_this__u8e3s4, $completion) {
    return i.fb2(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$_init_$lambda_95dffl_0(it) {
  return Stage.vb4(it);
}
function Korge$start$slambda_0(this$0, $entry) {
  var i = new Korge$start$slambda(this$0, $entry);
  var l = function ($this$withContext, $completion) {
    return i.f2y($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_14;
function Companion_getInstance_28() {
  if (Companion_instance_14 === VOID)
    new Companion_0();
  return Companion_instance_14;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  if (!($this.tb7_1.wb0_1 == null)) {
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var this_0 = $this.ub7_1.wb6_1;
    var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_24()));
    var name = 'sceneContainer';
    var size = Companion_getInstance_17().r3s_1;
    // Inline function 'korlibs.korge.scene.sceneContainer' call
    var tmp = views($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var views_0 = tmp;
    var width = size.em();
    var height = size.fm();
    var rwidth = width;
    var rheight = height;
    if (width === 0.0 && height === 0.0) {
      var tmp_0 = findFirstAscendant(this_0, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
      var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
      var tmp1_elvis_lhs = base == null ? null : base.f3u();
      rwidth = tmp1_elvis_lhs == null ? views_0.wb6_1.f3u() : tmp1_elvis_lhs;
      var tmp3_elvis_lhs = base == null ? null : base.g3u();
      rheight = tmp3_elvis_lhs == null ? views_0.wb6_1.g3u() : tmp3_elvis_lhs;
    }
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = SceneContainer.xbc(views_0, defaultTransition, name, Size2D.r3q(rwidth, rheight));
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
    var tmp_1 = addTo(this_1, this_0).ybc($this.tb7_1.wb0_1, [], VOID, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  var tmp_2 = $this.vb7_1($this.ub7_1.wb6_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  if ($this.tb7_1.eb1_1) {
    var tmp_3 = $this.wb7_1.ta5($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda_0($this.zbc_1, $this.abd_1, $this.bbd_1, $this.cbd_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($this$coroutineScope, $completion) {
    return i.f2y($this$coroutineScope, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$loop, $completion) {
  var gameWindow = $this$loop;
  if (Companion_getInstance_26().x23()) {
    println('Korui[0]');
  }
  $l$block: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name = 'configureGameWindow';
    var start = PerformanceCounter_getInstance().y7s();
    try {
      var tmp0_elvis_lhs = $this.fbd_1.mb1_1;
      var tmp;
      var tmp_0 = tmp0_elvis_lhs;
      if ((tmp_0 == null ? null : new RGBA(tmp_0)) == null) {
        tmp = Colors_getInstance().z57_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      configure($this.dbd_1, $this.ebd_1, $this.fbd_1.lb1_1, null, $this.fbd_1.db1_1, tmp);
      break $l$block;
    }finally {
      var end = PerformanceCounter_getInstance().y7s();
      // Inline function 'korlibs.time.microseconds' call
      var this_0 = end - start;
      var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.fa5(name, tmp$ret$1);
    }
  }
  $l$block_0: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var start_0 = PerformanceCounter_getInstance().y7s();
    try {
      try {
        if (!($this.gbd_1 == null)) {
          var tmp_1 = readBitmap(get_resourcesVfs().cj($this.gbd_1), $this.hbd_1, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
          $this$loop.ha5(tmp_1);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.error' call
          var this_1 = Companion_getInstance_27().db2_1;
          var level = Level_ERROR_getInstance();
          var tmp_2;
          if (this_1.q46(level)) {
            // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$2 = "Couldn't get the application icon";
            this_1.r46(level, tmp$ret$2);
            tmp_2 = Unit_instance;
          }
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      break $l$block_0;
    }finally {
      var end_0 = PerformanceCounter_getInstance().y7s();
      // Inline function 'korlibs.time.microseconds' call
      var this_2 = end_0 - start_0;
      var tmp$ret$5 = toDuration(this_2, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.fa5('setIcon', tmp$ret$5);
    }
  }
  $this$loop.ma5($this$loop.u9w());
  if (Companion_getInstance_26().x23()) {
    println('CanvasApplicationEx.IN[0]');
  }
  var input = new Input();
  var stats = new Stats();
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$6 = $completion.hd();
  var this_3 = Views.jbd(tmp$ret$6.eo(gameWindow.za4()).eo(new InjectorContext($this.fbd_1.yb0_1)).eo(SupervisorJob()).eo(CoroutineName.v2l('Views')), $this.fbd_1.tb1_1 ? AGPrint.k8w() : $this$loop.ya4(), $this.fbd_1.yb0_1, input, $this.fbd_1.xb0_1, stats, gameWindow, $this.fbd_1.fb1_1, $this.fbd_1.gb1_1, $this.fbd_1.hb1_1, VOID, $this.fbd_1.wb1_1);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>.<anonymous>.<anonymous>' call
  var tmp_3 = this_3.o3f($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  if (Companion_getInstance_26().c24()) {
    Dyn__set_impl_2ozvx8(Companion_instance_12.h4a(), 'views', this_3);
  }
  var views = this_3;
  $this.fbd_1.yb0_1.e7s(getKClass(GameWindow), gameWindow);
  $this.fbd_1.yb0_1.e7s(getKClass(Korge), $this.fbd_1);
  views.zb6_1 = $this$loop.oa5();
  views.kbd($this.fbd_1.ub1_1);
  views.lbd($this.fbd_1.vb1_1);
  views.qb6_1 = numberToInt($this.fbd_1.jb1_1.u3j_1);
  views.rb6_1 = numberToInt($this.fbd_1.jb1_1.v3j_1);
  views.ub6_1 = $this.fbd_1.kb1_1.db5_1;
  views.tb6_1 = $this.fbd_1.kb1_1.cb5_1;
  views.vb6_1 = $this.fbd_1.kb1_1.eb5_1;
  views.kb7_1 = $this.fbd_1.xb1_1;
  $l$block_1: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_0 = 'prepareViews';
    var start_1 = PerformanceCounter_getInstance().y7s();
    try {
      KorgeReload_getInstance().f9l(gameWindow);
      var tmp_4 = KorgeRunner_instance.mbd(views, gameWindow, true, $this$loop.la5(), Companion_instance_1.s35(), $this.fbd_1.qb1_1, $this.fbd_1.zb0_1).r2h($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      break $l$block_1;
    }finally {
      var end_1 = PerformanceCounter_getInstance().y7s();
      // Inline function 'korlibs.time.microseconds' call
      var this_4 = end_1 - start_1;
      var tmp$ret$9 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.fa5(name_0, tmp$ret$9);
    }
  }
  $l$block_2: {
    // Inline function 'korlibs.render.GameWindow.registerTime' call
    var name_1 = 'completeViews';
    var start_2 = PerformanceCounter_getInstance().y7s();
    try {
      completeViews(views);
      break $l$block_2;
    }finally {
      var end_2 = PerformanceCounter_getInstance().y7s();
      // Inline function 'korlibs.time.microseconds' call
      var this_5 = end_2 - start_2;
      var tmp$ret$11 = toDuration(this_5, DurationUnit_MICROSECONDS_getInstance());
      gameWindow.fa5(name_1, tmp$ret$11);
    }
  }
  launchImmediately(views, KorgeRunner$invoke$slambda$slambda_0($this.fbd_1, views, $this.ibd_1, gameWindow));
  if ($this.fbd_1.eb1_1) {
    var tmp_5 = gameWindow.ta5($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    gameWindow.ra5();
  }
  return Unit_instance;
}
function KorgeRunner$invoke$slambda$slambda_0($config, $views, $entry, $gameWindow) {
  var i = new KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, config, $completion) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
  beforeStartingKorge(config);
  if (null == null) {
    $l$block: {
      // Inline function 'korlibs.io.worker.Companion.init' call
      get_workerImpl().b4j();
      if (get_workerImpl().c4j()) {
        if (get_DEBUG_WORKER()) {
          println('INSIDE WORKER');
        }
        break $l$block;
      } else {
        if (get_DEBUG_WORKER()) {
          println('**NOT** INSIDE WORKER');
        }
      }
      // Inline function 'korlibs.korge.KorgeRunner.invoke.<anonymous>' call
      get_nativeSoundProvider();
      get_RegisteredImageFormats().b6p([config.ub0_1]);
      var iconPath = config.ob1_1;
      var imageFormats = config.ub0_1;
      var entry = config.sb1_1;
      var windowSize = config.ib1_1;
      if (!Companion_getInstance_26().c24()) {
        var tmp = configureLoggerFromProperties(get_localCurrentDirVfs().cj('klogger.properties'), $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
      }
      var tmp0_elvis_lhs = config.vb0_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.js.getCoroutineContext' call
        tmp_0 = $completion.hd().ud(CoroutineKey_getInstance());
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp1_elvis_lhs = tmp_0;
      var realGameWindow = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(config.rb1_1.va6(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, config.lb1_1)) : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = config.mb1_1;
      var tmp_1;
      var tmp_2 = tmp2_elvis_lhs;
      if ((tmp_2 == null ? null : new RGBA(tmp_2)) == null) {
        tmp_1 = Colors_getInstance().z57_1;
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      realGameWindow.ka5(tmp_1);
      var tmp_3 = realGameWindow.ua5(KorgeRunner$invoke$slambda_0(realGameWindow, windowSize, config, iconPath, imageFormats, entry), $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
    }
  }
  return Unit_instance;
}
function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
  return $views.v9v(Vector2D.y3k(x, y));
}
function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
  input.k9q(button, true);
  input.j9q(p, false);
  input.j9q(p, true);
  $views.nbd();
  downPos._v = input.i9q();
  downTime._v = new DateTime(Companion_getInstance_4().m35());
  input.u9p_1 = true;
}
function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
  input.k9q(button, false);
  input.j9q(p, false);
  $views.nbd();
  upPos._v = $views.nb5_1.i9q();
}
function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
  $views.nb5_1.j9q(p, false);
  $views.nb5_1.u9p_1 = inside;
  if (!inside) {
    moveMouseOutsideInNextFrame._v = true;
  }
  $views.nbd();
  moveTime._v = new DateTime(Companion_getInstance_4().m35());
}
function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
  $views.nb5_1.j9q(p, false);
  $views.nbd();
  moveTime._v = new DateTime(Companion_getInstance_4().m35());
}
function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
  mouseTouchEvent.h7z_1 = 0;
  mouseTouchEvent.k7z_1 = true;
  mouseTouchEvent.i7z_1 = Companion_getInstance_4().m35();
  mouseTouchEvent.j7z_1 = false;
  mouseTouchEvent.s7z(type);
  mouseTouchEvent.x7z(button.y82_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
  mouseTouchEvent.t7z();
  $views.l7v(mouseTouchEvent);
}
function prepareViewsBase$gamepadUpdated(input, e) {
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = e.s80_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.gamepadUpdated.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var gamepad = this_0[_unary__edvuaz];
    input.e9q_1[gamepad.t80_1].b81(gamepad);
  }
  input.l9q();
}
function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
  try {
    $views.pbd($fixedSizeStep, $views.obd(), event.z7v_1, event.a7w_1);
    $views.nb5_1.t9p_1 = false;
    if (moveMouseOutsideInNextFrame._v) {
      moveMouseOutsideInNextFrame._v = false;
      $views.nb5_1.t9p_1 = true;
      $views.nb5_1.u9p_1 = false;
      $views.nbd();
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = Companion_getInstance_27().db2_1;
      var level = Level_ERROR_getInstance();
      var tmp;
      if (this_0.q46(level)) {
        // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.renderBlock.<anonymous>' call
        var tmp$ret$0 = 'views.gameWindow.onRenderEvent:';
        this_0.r46(level, tmp$ret$0);
        tmp = Unit_instance;
      }
      printStackTrace(e);
      if ($views.yb5_1)
        throw e;
    } else {
      throw $p;
    }
  }
}
function KorgeRunner$invoke$slambda_0($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
  var i = new KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry);
  var l = function ($this$loop, $completion) {
    return i.qbd($this$loop, $completion);
  };
  l.$arity = 1;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda($this$mapSingleton) {
  return new ResourcesRoot();
}
function KorgeRunner$prepareViewsBase$lambda_0($this$mapPrototype) {
  return new EmptyScene();
}
function KorgeRunner$prepareViewsBase$lambda_1($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_27().db2_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<MouseEvent>:' + e.toString();
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    var p = prepareViewsBase$getRealXY($views, e.j7x_1, e.k7x_1, e.u7x_1);
    var tmp_0;
    switch (e.h7x_1.p3_1) {
      case 3:
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.l7x_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.l7x_1, Type_START_getInstance(), Status_ADD_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 2:
        prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.l7x_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.l7x_1, Type_END_getInstance(), Status_REMOVE_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 1:
        prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.l7x_1, Type_MOVE_getInstance(), Status_KEEP_getInstance());
        tmp_0 = Unit_instance;
        break;
      case 0:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
        tmp_0 = Unit_instance;
        break;
      case 4:
        tmp_0 = Unit_instance;
        break;
      case 5:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
        tmp_0 = Unit_instance;
        break;
      case 6:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
        tmp_0 = Unit_instance;
        break;
      case 7:
        tmp_0 = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $views.l7v(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_2($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_27().db2_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<KeyEvent>:' + e.toString();
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.l7v(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_3($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_27().db2_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GestureEvent>:' + e.toString();
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.l7v(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_4($views) {
  return function (e) {
    $views.l7v(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_5($views) {
  return function (e) {
    $views.l7v(e);
    get_nativeSoundProvider().l44(false);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_6($views) {
  return function (e) {
    $views.l7v(e);
    get_nativeSoundProvider().l44(true);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_7($views) {
  return function (e) {
    $views.l7v(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda$slambda_0($views) {
  var i = new KorgeRunner$prepareViewsBase$lambda$slambda($views);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function KorgeRunner$prepareViewsBase$lambda_8($views) {
  return function (e) {
    try {
      $views.l7v(e);
    }finally {
      launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda_0($views));
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_9($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_27().db2_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<TouchEvent>:' + e.toString();
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $input.h9q(e);
    var ee = $input.m9p_1;
    var _iterator__ex2g4s = ee.p7z().b1();
    while (_iterator__ex2g4s.c1()) {
      var t = _iterator__ex2g4s.d1();
      t.w7y_1 = prepareViewsBase$getRealXY($views, t.b6h(), t.c6h(), e.j7z_1);
    }
    $views.l7v(ee);
    var tmp_0;
    if (ee.q7z() === 1) {
      var start = ee.a80();
      var end = ee.b80();
      var t_0 = first(ee.p7z());
      var p = t_0.w7y_1;
      var x = t_0.b6h();
      var y = t_0.c6h();
      var button = MouseButton_LEFT_getInstance();
      if (start) {
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
      } else if (end) {
        prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
      } else {
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
      }
      // Inline function 'kotlin.also' call
      var this_1 = $touchMouseEvent;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      this_1.i7x_1 = 0;
      this_1.l7x_1 = button;
      this_1.m7x_1 = end ? 0 : 1 << button.y82_1;
      this_1.j7x_1 = numberToInt(x);
      this_1.k7x_1 = numberToInt(y);
      this_1.u7x_1 = false;
      this_1.v7x_1 = true;
      this_1.h7x_1 = start ? Type_DOWN_getInstance() : end ? Type_UP_getInstance() : Type_DRAG_getInstance();
      $views.l7v(this_1);
      var tmp_1;
      if (end) {
        $moveMouseOutsideInNextFrame._v = true;
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_10($views) {
  return function (e) {
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = Companion_getInstance_27().db2_1;
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q46(level)) {
      // Inline function 'korlibs.korge.KorgeRunner.prepareViewsBase.<anonymous>.<anonymous>' call
      var tmp$ret$0 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e.toString();
      this_0.r46(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    $views.l7v(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_11($views, $input) {
  return function (e) {
    prepareViewsBase$gamepadUpdated($input, e);
    $views.l7v(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_12($views, $ag) {
  return function (e) {
    $views.sbd($ag.v83().o83_1, $ag.v83().p83_1);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_13($views) {
  return function (it) {
    $views.l7v(it);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_14($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
  return function (event) {
    var tmp;
    if (!event.a7w_1) {
      prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
      tmp = Unit_instance;
    } else {
      var this_0 = $views.jb6_1;
      var frameBuffer = this_0.v83();
      this_0.j9m_1.u1w();
      this_0.c9m_1.z83();
      var tmp_0;
      try {
        this_0.k9x(frameBuffer);
        var tmp_1;
        try {
          if (!$renderShown._v) {
            $renderShown._v = true;
            $firstRenderDeferred.i2l(Unit_instance);
          }
          prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
          tmp_1 = Unit_instance;
        }finally {
          this_0.l9x();
        }
        tmp_0 = tmp_1;
      }finally {
        this_0.c9m_1.t7z();
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
var KorgeRunner_instance;
function KorgeRunner_getInstance() {
  return KorgeRunner_instance;
}
function Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, entry, $completion) {
  var tmp;
  if (args === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = args;
  }
  args = tmp;
  imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
  gameWindow = gameWindow === VOID ? null : gameWindow;
  mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  injector = injector === VOID ? new Injector() : injector;
  var tmp_0;
  if (configInjector === VOID) {
    tmp_0 = Korge$lambda;
  } else {
    tmp_0 = configInjector;
  }
  configInjector = tmp_0;
  debug = debug === VOID ? false : debug;
  trace = trace === VOID ? false : trace;
  context = context === VOID ? null : context;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  blocking = blocking === VOID ? true : blocking;
  gameId = gameId === VOID ? Companion_getInstance_27().eb2_1 : gameId;
  settingsFolder = settingsFolder === VOID ? null : settingsFolder;
  batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_5().e9t_1 : batchMaxQuads;
  windowWidth = windowWidth === VOID ? numberToInt(DefaultViewport_getInstance().s9q_1.u3j_1) : windowWidth;
  windowHeight = windowHeight === VOID ? numberToInt(DefaultViewport_getInstance().s9q_1.v3j_1) : windowHeight;
  windowSize = windowSize === VOID ? Size2D.w3j(windowWidth, windowHeight) : windowSize;
  virtualWidth = virtualWidth === VOID ? numberToInt(windowSize.u3j_1) : virtualWidth;
  virtualHeight = virtualHeight === VOID ? numberToInt(windowSize.v3j_1) : virtualHeight;
  virtualSize = virtualSize === VOID ? Size2D.w3j(virtualWidth, virtualHeight) : virtualSize;
  scaleMode = scaleMode === VOID ? Companion_getInstance_15().k3s_1 : scaleMode;
  scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_16().e3i() : scaleAnchor;
  clipBorders = clipBorders === VOID ? true : clipBorders;
  displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
  title = title === VOID ? 'Game' : title;
  bgcolor = bgcolor === VOID ? Colors_getInstance().z57_1 : bgcolor;
  backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
  quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
  icon = icon === VOID ? null : icon;
  multithreaded = multithreaded === VOID ? null : multithreaded;
  forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
  var tmp_1;
  if (main === VOID) {
    tmp_1 = Korge$slambda_1();
  } else {
    tmp_1 = main;
  }
  main = tmp_1;
  debugAg = debugAg === VOID ? false : debugAg;
  debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
  debugFontColor = debugFontColor === VOID ? Colors_getInstance().y57_1 : debugFontColor;
  var tmp_2;
  if (stageBuilder === VOID) {
    tmp_2 = Korge$lambda_0;
  } else {
    tmp_2 = stageBuilder;
  }
  stageBuilder = tmp_2;
  targetFps = targetFps === VOID ? 0.0 : targetFps;
  preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
  debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
  var tmp_3;
  if (entry === VOID) {
    tmp_3 = Korge$slambda_2();
  } else {
    tmp_3 = entry;
  }
  entry = tmp_3;
  return (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, VOID, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance)).ab5(entry, $completion);
}
function Korge$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$slambda_1() {
  var i = new Korge$slambda();
  var l = function (_this__u8e3s4, $completion) {
    return i.fb2(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function Korge$lambda_0(it) {
  return Stage.vb4(it);
}
function Korge$slambda_2() {
  var i = new Korge$slambda_0();
  var l = function (_this__u8e3s4, $completion) {
    return i.fb2(_this__u8e3s4, $completion);
  };
  l.$arity = 1;
  return l;
}
function get_keys(_this__u8e3s4) {
  _init_properties_KeysEvents_kt__ekyd0z();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = keys$delegate;
    var property = keys$factory();
    var tmp0_elvis_lhs = this_0.g28_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.h28_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.g28_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var keys$delegate;
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = $this.dbe_1.bbe_1.b39($this.ebe_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = $this.fbe_1.zbd_1.b39($this.gbe_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = $this.hbe_1.abe_1.b39($this.ibe_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function KeysEvents$downFrame$lambda(this$0, $keys, $callback, $ke) {
  return function ($this$addOptFixedUpdater, dt) {
    var tmp;
    if (!(this$0.ybd_1 == null)) {
      var vkeys = this$0.jbe().f3();
      var this_0 = $keys;
      var n = 0;
      while (n < this_0.g1()) {
        // Inline function 'korlibs.korge.input.KeysEvents.downFrame.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var key = this_0.h1(_unary__edvuaz);
        if (vkeys.c9p(key)) {
          $callback(this$0.kbe($ke, key, vkeys, dt.lk_1));
        }
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function KeysEvents$justDown$lambda($keys, $callback, this$0, $ke) {
  return function ($this$addUpdaterWithViews, views, dt) {
    var vkeys = views.f3();
    var this_0 = $keys;
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.korge.input.KeysEvents.justDown.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var key = this_0.h1(_unary__edvuaz);
      if (vkeys.e9p(key)) {
        $callback(this$0.kbe($ke, key, vkeys, dt.lk_1));
      }
    }
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_2(this$0, $event) {
  var i = new KeysEvents$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.s7v_1;
    tmp.ybd_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.jbe().kb5_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_2(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_3(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_0(this$0, $event);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_0(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.s7v_1;
    tmp.ybd_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.jbe().kb5_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_3(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_4(this$0, $event) {
  var i = new KeysEvents$lambda$slambda_1(this$0, $event);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function KeysEvents$lambda_1(this$0) {
  return function (event) {
    var tmp = this$0;
    var tmp_0 = event.s7v_1;
    tmp.ybd_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.jbe().kb5_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_4(this$0, event));
    return Unit_instance;
  };
}
function keys$delegate$lambda($this$PropertyThis) {
  _init_properties_KeysEvents_kt__ekyd0z();
  return new KeysEvents($this$PropertyThis);
}
function keys$factory() {
  return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
    return get_keys(receiver);
  }, null);
}
var properties_initialized_KeysEvents_kt_1mffin;
function _init_properties_KeysEvents_kt__ekyd0z() {
  if (!properties_initialized_KeysEvents_kt_1mffin) {
    properties_initialized_KeysEvents_kt_1mffin = true;
    keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
  }
}
function set_mouseHitSearch(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitSearch$delegate;
  var property = mouseHitSearch$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitSearch(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitSearch$delegate;
    var property = mouseHitSearch$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitSearch$delegate;
function set_mouseHitResult(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResult$delegate;
  var property = mouseHitResult$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResult(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResult$delegate;
    var property = mouseHitResult$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResult$delegate;
function set_mouseHitResultUsed(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseHitResultUsed$delegate;
  var property = mouseHitResultUsed$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResultUsed(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseHitResultUsed$delegate;
    var property = mouseHitResultUsed$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResultUsed$delegate;
function set_mouseDebugHandlerOnce(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugHandlerOnce$delegate;
  var property = mouseDebugHandlerOnce$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugHandlerOnce(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugHandlerOnce$delegate;
    var property = mouseDebugHandlerOnce$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugHandlerOnce$delegate;
function set_mouseDebugLastFrameClicked(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = mouseDebugLastFrameClicked$delegate;
  var property = mouseDebugLastFrameClicked$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugLastFrameClicked(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = mouseDebugLastFrameClicked$delegate;
    var property = mouseDebugLastFrameClicked$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugLastFrameClicked$delegate;
function get_mouse(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = mouse$delegate;
    var property = mouse$factory();
    var tmp0_elvis_lhs = this_0.g28_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.h28_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.g28_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouse$delegate;
function set_cursor(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var this_0 = cursor$delegate;
  var property = cursor$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_cursor(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = cursor$delegate;
    var property = cursor$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cursor$delegate;
function mouseHitTest($this, views) {
  if (!get_mouseHitSearch(views.nb5_1)) {
    set_mouseHitSearch(views.nb5_1, true);
    set_mouseHitResult(views.nb5_1, views.wb6_1.rbe(views.qbe()));
    var view = get_mouseHitResult(views.nb5_1);
    $l$loop: while (!(view == null) && get_cursor(view) == null) {
      view = view.z3g();
    }
    var tmp0_safe_receiver = view;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_cursor(tmp0_safe_receiver);
    var newCursor = tmp1_elvis_lhs == null ? Cursor_DEFAULT_getInstance() : tmp1_elvis_lhs;
    if (!equals(views.qb5_1.xa4(), newCursor)) {
      views.qb5_1.wa4(newCursor);
    }
  }
  return get_mouseHitResult(views.nb5_1);
}
function MouseEvents$Companion$installDebugExtensionOnce$lambda($views) {
  return function (_this__u8e3s4, ctx) {
    var scale = ctx.w9w();
    // Inline function 'kotlin.math.max' call
    var a = 1 * scale;
    var space = Math.max(a, 2.0);
    var matrix = $views.i9v();
    var yy = 60 * scale;
    var lineHeight = 8 * scale;
    var mouseHit = mouseHitTest(Companion_instance_15, $views);
    var tmp;
    if (!(mouseHit == null)) {
      var bounds = mouseHit.sbe();
      if (get_mouseDebugLastFrameClicked(_this__u8e3s4)) {
        $views.tbe(mouseHit);
      }
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = _this__u8e3s4.jb6_1.a9n_1;
      var this_1 = this_0.j9n_1;
      if (!(this_1.e9n_1 === this_0)) {
        this_1.e9n_1 = this_0;
        this_1.o9o();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$1 = get_Bitmaps_white();
      var tmp0_tex = ctx.p9o(tmp$ret$1);
      var tmp1_x = bounds.b3j_1;
      var tmp2_y = bounds.c3j_1;
      var tmp3_width = bounds.d3j_1;
      var tmp4_height = bounds.e3j_1;
      var tmp5_colorMul = RGBA__withAd_impl_cralao(Colors_getInstance().a58_1, 0.3);
      var tmp6_m = mouseHit.ube();
      this_0.q9o(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp6_m, VOID, tmp5_colorMul);
      var tmp7_$receiver = _this__u8e3s4.jb6_1;
      var tmp8_font = _this__u8e3s4.vbe();
      var tmp9_str = toString_0(mouseHit) + ' : ' + $views.qbe().r3i_1 + ',' + $views.qbe().s3i_1;
      var tmp10_y = numberToInt(yy);
      var tmp11_colMul = ctx.z9m_1;
      var tmp12_blendMode = Companion_getInstance_12().r9l_1;
      var tmp13_m = get_immutable(matrix);
      drawText(tmp7_$receiver, tmp8_font, lineHeight, tmp9_str, 0, tmp10_y, tmp13_m, tmp11_colMul, tmp12_blendMode, false);
      yy = yy + lineHeight;
      yy = yy + space;
      tmp = Unit_instance;
    }
    var mouseHitResultUsed = get_mouseHitResultUsed(_this__u8e3s4.nb5_1);
    var tmp_0;
    if (!(mouseHitResultUsed == null)) {
      var bounds_0 = mouseHitResultUsed.sbe();
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_2 = _this__u8e3s4.jb6_1.a9n_1;
      var this_3 = this_2.j9n_1;
      if (!(this_3.e9n_1 === this_2)) {
        this_3.e9n_1 = this_2;
        this_3.o9o();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$4 = get_Bitmaps_white();
      var tmp0_tex_0 = ctx.p9o(tmp$ret$4);
      var tmp1_x_0 = bounds_0.b3j_1;
      var tmp2_y_0 = bounds_0.c3j_1;
      var tmp3_width_0 = bounds_0.d3j_1;
      var tmp4_height_0 = bounds_0.e3j_1;
      var tmp5_colorMul_0 = Companion_getInstance_2().f5o(0, 0, 255, 63);
      var tmp6_m_0 = mouseHitResultUsed.ube();
      this_2.q9o(tmp0_tex_0, tmp1_x_0, tmp2_y_0, tmp3_width_0, tmp4_height_0, tmp6_m_0, VOID, tmp5_colorMul_0);
      var vview = mouseHitResultUsed;
      while (!(vview == null)) {
        var tmp7_$receiver_0 = _this__u8e3s4.jb6_1;
        var tmp8_font_0 = _this__u8e3s4.vbe();
        var tmp9_str_0 = vview.toString();
        var tmp10_y_0 = numberToInt(yy);
        var tmp11_colMul_0 = ctx.z9m_1;
        var tmp12_blendMode_0 = Companion_getInstance_12().r9l_1;
        var tmp13_m_0 = get_immutable(matrix);
        drawText(tmp7_$receiver_0, tmp8_font_0, lineHeight, tmp9_str_0, 0, tmp10_y_0, tmp13_m_0, tmp11_colMul_0, tmp12_blendMode_0, false);
        vview = vview.z3g();
        yy = yy + lineHeight;
        yy = yy + space;
      }
      tmp_0 = Unit_instance;
    }
    set_mouseDebugLastFrameClicked(_this__u8e3s4, false);
    return Unit_instance;
  };
}
function MouseEvents$MouseEventsUpdate$lambda(this$0) {
  return function ($this$addUpdaterWithViews, views, dt) {
    this$0.lbg(views, dt.lk_1);
    return Unit_instance;
  };
}
var Companion_instance_15;
function Companion_getInstance_29() {
  return Companion_instance_15;
}
function temporalLastEvent($this, lastEventNew, block) {
  var old = $this.gbg_1;
  var tmp = $this;
  tmp.gbg_1 = lastEventNew == null ? $this.gbg_1 : lastEventNew;
  try {
    return block();
  }finally {
    $this.gbg_1 = old;
  }
}
function MouseEvents$closeable$lambda(this$0) {
  return function (event) {
    var tmp;
    if (!this$0.xbe_1.qbg()) {
      return Unit_instance;
    }
    var tmp_0 = this$0;
    var tmp_1 = event.s7v_1;
    tmp_0.ybe_1 = tmp_1 instanceof Views ? tmp_1 : THROW_CCE();
    this$0.fbg_1 = event;
    this$0.gbg_1.z7x(event);
    this$0.hbg_1 = event.v7x_1;
    this$0.ebg_1 = true;
    var tmp_2;
    switch (event.h7x_1.p3_1) {
      case 2:
        this$0.ibg_1.z7x(event);
        this$0.zbf_1 = this$0.rbg().nb5_1.i9q();
        this$0.wbf_1 = PerformanceCounter_getInstance().z7s();
        var elapsedTime = Duration__minus_impl_q5cfm7(this$0.wbf_1, this$0.xbf_1);
        var tmp_3;
        if (this$0.zbf_1.g3t(this$0.ybf_1) < this$0.rbg().nb5_1.p9p_1 && Duration__compareTo_impl_pchp0f(elapsedTime, this$0.rbg().nb5_1.o9p_1) < 0) {
          var _unary__edvuaz = this$0.dbg_1;
          this$0.dbg_1 = _unary__edvuaz + 1 | 0;
          var tmp_4;
          if (this$0.sbg()) {
            this$0.abf_1.r38(this$0);
            var tmp_5;
            if (this$0.abf_1.v38() > 0) {
              event.b7y(this$0.xbe_1);
              tmp_5 = Unit_instance;
            }
            tmp_4 = tmp_5;
          }
          tmp_3 = tmp_4;
        }

        tmp_2 = tmp_3;
        break;
      case 3:
        if (!event.s7x_1) {
          set_mouseDebugLastFrameClicked(this$0.rbg(), true);
        }

        this$0.xbf_1 = PerformanceCounter_getInstance().z7s();
        this$0.ybf_1 = this$0.rbg().nb5_1.i9q();
        var tmp_6;
        if (this$0.zbe_1.w38()) {
          var tmp_7;
          if (this$0.sbg()) {
            this$0.zbe_1.r38(this$0);
            tmp_7 = Unit_instance;
          }
          tmp_6 = tmp_7;
        }

        tmp_2 = tmp_6;
        break;
      case 7:
        if (this$0.sbg()) {
          this$0.pbf_1.r38(this$0);
        } else {
          this$0.rbf_1.r38(this$0);
        }

        this$0.qbf_1.r38(this$0);
        tmp_2 = Unit_instance;
        break;
      default:
        tmp_2 = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
function MouseEvents$update$lambda($over, this$0) {
  return function () {
    var tmp;
    if ($over) {
      this$0.gbf_1.r38(this$0);
      tmp = Unit_instance;
    } else {
      this$0.hbf_1.r38(this$0);
      this$0.jbf_1.r38(this$0);
      tmp = Unit_instance;
    }
    this$0.kbf_1.r38(this$0);
    return Unit_instance;
  };
}
function mouseHitSearch$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouseHitResult$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitResultUsed$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseDebugHandlerOnce$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return new Once();
}
function mouseDebugLastFrameClicked$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function mouse$delegate$lambda($this$PropertyThis) {
  _init_properties_MouseEvents_kt__io5soc();
  return new MouseEvents($this$PropertyThis);
}
function cursor$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function mouseHitSearch$factory() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitSearch$factory_0() {
  return getPropertyCallableRef('mouseHitSearch', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitSearch(receiver);
  }, function (receiver, value) {
    return set_mouseHitSearch(receiver, value);
  });
}
function mouseHitResult$factory() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResult$factory_0() {
  return getPropertyCallableRef('mouseHitResult', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResult(receiver);
  }, function (receiver, value) {
    return set_mouseHitResult(receiver, value);
  });
}
function mouseHitResultUsed$factory() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseHitResultUsed$factory_0() {
  return getPropertyCallableRef('mouseHitResultUsed', 1, KMutableProperty1, function (receiver) {
    return get_mouseHitResultUsed(receiver);
  }, function (receiver, value) {
    return set_mouseHitResultUsed(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugHandlerOnce$factory_0() {
  return getPropertyCallableRef('mouseDebugHandlerOnce', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugHandlerOnce(receiver);
  }, function (receiver, value) {
    return set_mouseDebugHandlerOnce(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouseDebugLastFrameClicked$factory_0() {
  return getPropertyCallableRef('mouseDebugLastFrameClicked', 1, KMutableProperty1, function (receiver) {
    return get_mouseDebugLastFrameClicked(receiver);
  }, function (receiver, value) {
    return set_mouseDebugLastFrameClicked(receiver, value);
  });
}
function mouse$factory() {
  return getPropertyCallableRef('mouse', 1, KProperty1, function (receiver) {
    return get_mouse(receiver);
  }, null);
}
function cursor$factory() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
function cursor$factory_0() {
  return getPropertyCallableRef('cursor', 1, KMutableProperty1, function (receiver) {
    return get_cursor(receiver);
  }, function (receiver, value) {
    return set_cursor(receiver, value);
  });
}
var properties_initialized_MouseEvents_kt_t0zz8y;
function _init_properties_MouseEvents_kt__io5soc() {
  if (!properties_initialized_MouseEvents_kt_t0zz8y) {
    properties_initialized_MouseEvents_kt_t0zz8y = true;
    mouseHitSearch$delegate = new Property(VOID, mouseHitSearch$delegate$lambda);
    mouseHitResult$delegate = new Property(VOID, mouseHitResult$delegate$lambda);
    mouseHitResultUsed$delegate = new Property(VOID, mouseHitResultUsed$delegate$lambda);
    mouseDebugHandlerOnce$delegate = new Property(VOID, mouseDebugHandlerOnce$delegate$lambda);
    mouseDebugLastFrameClicked$delegate = new Property(VOID, mouseDebugLastFrameClicked$delegate$lambda);
    mouse$delegate = new PropertyThis(VOID, mouse$delegate$lambda);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = cursor$delegate$lambda;
    cursor$delegate = new Property(null, default_0);
  }
}
function drawText_0(_this__u8e3s4, text, font, textSize, pos, color, baseline, textRangeStart, textRangeEnd, filtering) {
  textSize = textSize === VOID ? 16.0 : textSize;
  pos = pos === VOID ? Companion_getInstance_18().t3i_1 : pos;
  color = color === VOID ? Colors_getInstance().y57_1 : color;
  baseline = baseline === VOID ? false : baseline;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  filtering = filtering === VOID ? _this__u8e3s4.y9x_1 : filtering;
  var scale = font.d5s(textSize);
  var sx = pos.r3i_1;
  var sy = pos.s3i_1 + (baseline ? -font.r4s() * scale : 0.0);
  var n = 0;
  var inductionVariable = 0;
  var last = text.length;
  while (inductionVariable < last) {
    var char = charSequenceGet(text, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    var glyph = font.f5s(char);
    if (textRangeStart <= n ? n < textRangeEnd : false) {
      _this__u8e3s4.a9y(new Rectangle(sx + glyph.q5q_1 * scale, sy + glyph.r5q_1 * scale, glyph.y5q() * scale, glyph.z5q() * scale), RGBA__times_impl_wehs9n(color, _this__u8e3s4.x9x_1), filtering, glyph.p5q_1, get_agProgram(font));
    }
    sx = sx + glyph.s5q_1 * scale;
    n = n + 1 | 0;
  }
}
function set__debugAnnotateView(_this__u8e3s4, _set____db54di) {
  _init_properties_RenderContextExt_kt__49d41k();
  var this_0 = _debugAnnotateView$delegate;
  var property = _debugAnnotateView$factory();
  var tmp0_elvis_lhs = this_0.e28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _debugAnnotateView$delegate;
    var property = _debugAnnotateView$factory_0();
    var tmp = _this__u8e3s4.d28();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.e28_1;
      tmp_0 = tmp0_safe_receiver.e3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.f28_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.e28_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.e28_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _debugAnnotateView$delegate;
function get_debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  return get__debugAnnotateView(_this__u8e3s4);
}
function get_views(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp = _this__u8e3s4.d9m_1;
  return tmp instanceof Views ? tmp : null;
}
function _debugAnnotateView$delegate$lambda() {
  _init_properties_RenderContextExt_kt__49d41k();
  return null;
}
function _debugAnnotateView$factory() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
function _debugAnnotateView$factory_0() {
  return getPropertyCallableRef('_debugAnnotateView', 1, KMutableProperty1, function (receiver) {
    return get__debugAnnotateView(receiver);
  }, function (receiver, value) {
    return set__debugAnnotateView(receiver, value);
  });
}
var properties_initialized_RenderContextExt_kt_9hx4ly;
function _init_properties_RenderContextExt_kt__49d41k() {
  if (!properties_initialized_RenderContextExt_kt_9hx4ly) {
    properties_initialized_RenderContextExt_kt_9hx4ly = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _debugAnnotateView$delegate$lambda;
    _debugAnnotateView$delegate = new Property(null, default_0);
  }
}
function *_generator_sceneAfterDestroyInternal__rup219($this, $completion) {
  var tmp = $this.obh($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    cancel($this.z2e(), SceneCancellationException.dbh($this));
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function Scene$coroutineContext$delegate$lambda(this$0) {
  return function () {
    return this$0.rbg().kb5_1.eo(new InjectorContext(this$0.pbh())).eo(SupervisorJob(this$0.rbg().kb5_1.ud(Key_instance))).eo(CoroutineName.v2l('Scene:' + toString(this$0)));
  };
}
function Scene$sceneView$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.apply' call
    var this_0 = this$0.rbh(this$0.qbh().g1());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.Scene.sceneView$delegate.<anonymous>.<anonymous>' call
    this$0.jbh_1.abk(this_0);
    return this_0;
  };
}
function Scene$resources$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.inject.Injector.getSync' call
    return this$0.pbh().n7s(getKClass(Resources));
  };
}
function coroutineContext$factory() {
  return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
    return receiver.z2e();
  }, null);
}
function sceneView$factory() {
  return getPropertyCallableRef('sceneView', 1, KProperty1, function (receiver) {
    return receiver.dbk();
  }, null);
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var scene = $this.hbn_1.ubc_1;
  if (!(scene == null)) {
    println('[ReloadEvent] Reloading ' + toString_0($this.hbn_1.ubc_1) + ' . doFullReload=' + $this.ibn_1.pbn());
    var tmp;
    if ($this.ibn_1.pbn()) {
      tmp = $this.ibn_1.qbn(getKClassFromExpression(scene), scene.pbh());
    } else {
      tmp = getKClassFromExpression(scene);
    }
    var tmp_0 = tmp;
    var sceneClass = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
    var this_0 = $this.hbn_1;
    var injects = [];
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var time = toDuration(0, DurationUnit_SECONDS_getInstance());
    var transition = this_0.sbc_1;
    var sceneInjector = this_0.rbc_1.mb5_1.g7s().e7s(getKClass(SceneContainer), this_0).e7s(getKClass(Resources), new Resources(this_0.z2e(), this_0.rbc_1.tbd().a4h_1, this_0.rbc_1.tbd()));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < injects.length) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var inject = injects[_unary__edvuaz];
      var tmp_1 = getKClassFromExpression(inject);
      sceneInjector.e7s(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
    }
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = sceneInjector.n7s(sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $this.ibn_1.z9k(scene, this_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    var newScene = this_1;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_30().rbn_1;
    var level = Level_INFO_getInstance();
    var tmp_2;
    if (this_2.q46(level)) {
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
      var tmp$ret$4 = 'Changing scene to... ' + toString(sceneClass) + ' ... ' + toString(newScene);
      this_2.r46(level, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
    if (false) {
      newScene.p7s(sceneInjector);
      var tmp_3 = getKClassFromExpression(newScene);
      var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
      this_0.rbc_1.mb5_1.i7s(tmp_4, SceneContainer$lambda$slambda$lambda(sceneInjector, sceneClass, $this.ibn_1, scene));
    }
    var tmp_5 = this_0.tbn(newScene, time, transition, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    var scene_0 = tmp_5;
    scene_0.rbg().tbe(scene_0.dbk());
  }
  return Unit_instance;
}
function SceneContainer$lambda$slambda$lambda($sceneInjector, $sceneClass, $event, $scene) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = $sceneInjector.n7s($sceneClass);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.scene.SceneContainer.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    try {
      $event.z9k($scene, this_0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    return this_0;
  };
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.ubn_1.dbk();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.ubn_1.qbm(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = $this.vbn_1.dbk();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>' call
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>.<anonymous>.<anonymous>' call
  var tmp = $this.vbn_1.rbm(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  var tmp = $this.wbn_1.tbm($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  var tmp = $this.xbn_1.ubm($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.xbn_1.vbm();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  var tmp = $this.ybn_1.wbm($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  var tmp = $this.zbn_1.sbm($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator__changeTo__ueovgq($this, clazz, injects, time, transition, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects_0 = injects.slice();
  var sceneInjector = $this.rbc_1.mb5_1.g7s().e7s(getKClass(SceneContainer), $this).e7s(getKClass(Resources), new Resources($this.z2e(), $this.rbc_1.tbd().a4h_1, $this.rbc_1.tbd()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.e7s(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
  var newScene = sceneInjector.n7s(clazz);
  // Inline function 'korlibs.logger.Logger.info' call
  var this_0 = Companion_getInstance_30().rbn_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_0.q46(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_0.r46(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (false) {
    newScene.p7s(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    $this.rbc_1.mb5_1.i7s(tmp_2, SceneContainer$_changeTo$lambda(sceneInjector, clazz));
  }
  var tmp_3 = $this.tbn(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return tmp_3;
}
function _changeTo($this, clazz, injects, time, transition, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__changeTo__ueovgq.bind(VOID, $this, clazz, injects, time, transition), $completion);
}
function *_generator__changeTo__ueovgq_0($this, newScene, time, transition, $completion) {
  var oldScene = $this.ubc_1;
  $this.ubc_1 = newScene;
  $this.tbc_1.lbq(newScene.jbh_1, transition);
  try {
    var tmp = newScene.z2e();
    var tmp_0 = launchUnscopedAndWait(tmp, SceneContainer$_changeTo$slambda_5(newScene), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (e instanceof CancellationException)
        throw e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  finally {
  }
  launchUnscoped(newScene, SceneContainer$_changeTo$slambda_6(newScene));
  if (!(oldScene == null)) {
    var tmp_1 = oldScene.z2e();
    var tmp_2 = launchUnscopedAndWait(tmp_1, SceneContainer$_changeTo$slambda_7(oldScene), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$3 = toDuration(0, DurationUnit_SECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f(time, tmp$ret$3) > 0) {
    // Inline function 'korlibs.korge.tween.get' call
    var this_0 = ratio$factory($this.tbc_1);
    var initial = Companion_getInstance_25().p27_1;
    var end = Companion_getInstance_25().s27_1;
    var tmp$ret$4 = new V2(this_0, new Ratio(initial), new Ratio(end), _interpolateRatio$ref(), true);
    var tmp_3 = tween($this.tbc_1, [tmp$ret$4], time, VOID, VOID, VOID, VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  } else {
    $this.tbc_1.ibq_1 = Companion_getInstance_25().s27_1;
  }
  $this.tbc_1.mbq();
  if (!(oldScene == null)) {
    var tmp_4 = oldScene.z2e();
    var tmp_5 = launchUnscopedAndWait(tmp_4, SceneContainer$_changeTo$slambda_8(oldScene), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    launchUnscoped(oldScene, SceneContainer$_changeTo$slambda_9(oldScene));
  }
  var tmp_6 = newScene.z2e();
  launchUnscoped_0(tmp_6, SceneContainer$_changeTo$slambda_10(newScene));
  return newScene;
}
var Companion_instance_16;
function Companion_getInstance_30() {
  if (Companion_instance_16 === VOID)
    new Companion_2();
  return Companion_instance_16;
}
function SceneContainer$lambda$lambda(this$0) {
  return function (it) {
    var tmp;
    if (it instanceof SceneContainer) {
      tmp = !equals(it, this$0);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function SceneContainer$lambda$slambda_0(this$0, $event) {
  var i = new SceneContainer$lambda$slambda(this$0, $event);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$lambda(this$0) {
  return function (event) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var hasChildScenes = !descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0)).j1();
    var tmp;
    if (hasChildScenes) {
      println('[ReloadEvent] Scene ' + toString_0(this$0.ubc_1) + ' not reloaded because has child scenes...');
      return Unit_instance;
    }
    launchImmediately(this$0, SceneContainer$lambda$slambda_0(this$0, event));
    return Unit_instance;
  };
}
function SceneContainer$_changeTo$lambda($sceneInjector, $clazz) {
  return function ($this$mapPrototype) {
    // Inline function 'korlibs.korge.scene.SceneContainer._changeTo.<anonymous>' call
    return $sceneInjector.n7s($clazz);
  };
}
function SceneContainer$_changeTo$slambda_5($newScene) {
  var i = new SceneContainer$_changeTo$slambda($newScene);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_6($newScene) {
  var i = new SceneContainer$_changeTo$slambda_0($newScene);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_7($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_1($oldScene);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function _interpolateRatio$ref() {
  var l = function (p0, p1, p2) {
    return new Ratio(_interpolateRatio(p0.o27_1, p1.o27_1, p2.o27_1));
  };
  l.callableName = '_interpolateRatio';
  return l;
}
function SceneContainer$_changeTo$slambda_8($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_2($oldScene);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_9($oldScene) {
  var i = new SceneContainer$_changeTo$slambda_3($oldScene);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function SceneContainer$_changeTo$slambda_10($newScene) {
  var i = new SceneContainer$_changeTo$slambda_4($newScene);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function ratio$factory($b0) {
  return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
    return new Ratio($b0.ibq_1);
  }, function (value) {
    $b0.ibq_1 = value.o27_1;
    return Unit_instance;
  });
}
function get_AlphaTransition() {
  _init_properties_Transition_kt__s6zoln();
  return AlphaTransition;
}
var AlphaTransition;
function Transition(name, render) {
  name = name === VOID ? 'Transition' : name;
  _init_properties_Transition_kt__s6zoln();
  return new Transition$1(render, name);
}
function withEasing(_this__u8e3s4, easing) {
  _init_properties_Transition_kt__s6zoln();
  return new withEasing$1(_this__u8e3s4, easing);
}
function _get_transitionProcess__5hlux5($this) {
  var tmp = $this.kbq_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('transitionProcess');
  }
}
function AlphaTransition$lambda(ctx, prev, next, ratio) {
  _init_properties_Transition_kt__s6zoln();
  var prevAlpha = prev.kby();
  var nextAlpha = next.kby();
  try {
    prev.jby(1.0 - Ratio__toFloat_impl_1ftup5(ratio.o27_1));
    next.jby(Ratio__toFloat_impl_1ftup5(ratio.o27_1));
    prev.obt(ctx);
    next.obt(ctx);
  }finally {
    prev.jby(prevAlpha);
    next.jby(nextAlpha);
  }
  return Unit_instance;
}
var properties_initialized_Transition_kt_wb2qvd;
function _init_properties_Transition_kt__s6zoln() {
  if (!properties_initialized_Transition_kt_wb2qvd) {
    properties_initialized_Transition_kt_wb2qvd = true;
    AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
  }
}
function createProgram$_anonymous_$lambda$0_hhid5m($median$delegate) {
  return $median$delegate.np(null, getLocalDelegateReference('median', KProperty0, false, function () {
    return THROW_ISE();
  }));
}
function MsdfRender$createProgram$lambda($this$FUNC, a, b, c) {
  $this$FUNC.t8l($this$FUNC.k95($this$FUNC.j95(a, b), $this$FUNC.j95($this$FUNC.k95(a, b), c)));
  return Unit_instance;
}
function MsdfRender$createProgram$lambda_0($$this$buildShader) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.l8k($this$IF_ELSE_BINARY_LOOKUP.o8k(), $this$IF_ELSE_BINARY_LOOKUP.w8k(Companion_getInstance_5().c9t_1[n], $this$IF_ELSE_BINARY_LOOKUP.u8k($$this$buildShader.h8k(), 'xy')));
    return Unit_instance;
  };
}
var MsdfRender_instance;
function MsdfRender_getInstance() {
  if (MsdfRender_instance === VOID)
    new MsdfRender();
  return MsdfRender_instance;
}
function get_DEFAULT_EASING() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_EASING;
}
var DEFAULT_EASING;
function get_DEFAULT_TIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_TIME;
}
var DEFAULT_TIME;
function get_DEFAULT_FTIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_FTIME;
}
var DEFAULT_FTIME;
function tween(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_TIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  var tmp;
  if (waitTime === VOID) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    tmp = waitTime;
  }
  waitTime = tmp;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp_0;
  if (callback === VOID) {
    tmp_0 = tween$lambda;
  } else {
    tmp_0 = callback;
  }
  callback = tmp_0;
  return tween_0(_this__u8e3s4, vs.slice(), get_fast(time), easing, get_fast(waitTime), timeout, autoInvalidate, callback, $completion);
}
function *_generator_tween__vopi21(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.s35() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  if (!(_this__u8e3s4 == null)) {
    var tc = {_v: null};
    try {
      var tmp_0;
      if (timeout) {
        // Inline function 'korlibs.time.FastDuration.times' call
        var tmp$ret$0 = FastDuration__times_impl_h6amcp(time, numberToDouble(2));
        tmp_0 = FastDuration__plus_impl_q1enab(tmp$ret$0, get_fastMilliseconds(300));
      } else {
        tmp_0 = Companion_instance_1.s35();
      }
      var tmp_1 = tmp_0;
      var tmp_2 = withTimeoutNullable(tmp_1, tween$slambda_0(_this__u8e3s4, tc, vs, time, easing, callback, waitTime, autoInvalidate), $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
    } catch ($p) {
      if ($p instanceof TimeoutCancellationException) {
        var e = $p;
        var tmp0_safe_receiver = tc._v;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.ac1(time);
        }
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function tween_0(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.s35() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_tween__vopi21.bind(VOID, _this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback), $completion);
}
function _update($this, dt) {
  if ($this.tc0_1) {
    $this.mc0_1.ibw();
  }
  if ($this.wc0_1) {
    return $this.fc1();
  }
  $this.uc0_1 = FastDuration__plus_impl_q1enab($this.uc0_1, dt);
  var ratio = clamp(FastDuration__div_impl_rlslck($this.uc0_1, $this.vc0_1), 0.0, 1.0);
  $this.ac1($this.uc0_1);
  $this.qc0_1($this.pc0_1.i27(ratio));
  var tmp;
  var tmp_0 = $this.gc1();
  // Inline function 'korlibs.time.NIL' call
  Companion_getInstance();
  var tmp$ret$0 = get_DURATION_NIL();
  if (!equals(tmp_0, tmp$ret$0)) {
    tmp = FastDuration__compareTo_impl_4fhnj7($this.uc0_1, $this.gc1()) >= 0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.hc1();
  }
  if (ratio >= 1.0) {
    return $this.fc1();
  }
}
function TweenComponent$updater$lambda(this$0) {
  return function (it) {
    _update(this$0, it.ka7_1);
    return Unit_instance;
  };
}
function TweenComponent$lambda(this$0) {
  return function (it) {
    this$0.wc0_1 = true;
    return Unit_instance;
  };
}
function *_generator_withTimeoutNullable__i31xu0(time, block, $completion) {
  var tmp;
  var tmp_0;
  var tmp_1 = time;
  if ((tmp_1 == null ? null : new FastDuration(tmp_1)) == null) {
    tmp_0 = true;
  } else {
    var tmp_2 = time;
    tmp_0 = equals(tmp_2 == null ? null : new FastDuration(tmp_2), new FastDuration(Companion_instance_1.s35()));
  }
  if (tmp_0) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.hd();
    var tmp_3 = block(CoroutineScope_0(tmp$ret$0), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  } else {
    var tmp_4 = withTimeout(toLongRound(_FastDuration___get_fastMilliseconds__impl__pe68va(time)), block, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp = tmp_4;
  }
  return tmp;
}
function withTimeoutNullable(time, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withTimeoutNullable__i31xu0.bind(VOID, time, block), $completion);
}
function tween$lambda(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function tween$lambda_0(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $this$withTimeoutNullable, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.q2j();
  // Inline function 'korlibs.korge.tween.tween.<anonymous>.<anonymous>' call
  var view = $this.ic1_1;
  $this.jc1_1._v = new TweenComponent(view, toList($this.kc1_1), $this.lc1_1, $this.mc1_1, $this.nc1_1, cancellable, $this.oc1_1, $this.pc1_1);
  var tmp$ret$0 = cancellable.c2h();
  var tmp = returnIfSuspended(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function tween$slambda_0($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
  var i = new tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate);
  var l = function ($this$withTimeoutNullable, $completion) {
    return i.f2y($this$withTimeoutNullable, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_tween_kt_p0n8nv;
function _init_properties_tween_kt__1g7sex() {
  if (!properties_initialized_tween_kt_p0n8nv) {
    properties_initialized_tween_kt_p0n8nv = true;
    DEFAULT_EASING = get_EASE_IN_OUT_QUAD(Companion_getInstance_24());
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_TIME = toDuration(1, DurationUnit_SECONDS_getInstance());
    DEFAULT_FTIME = get_fastSeconds(1);
  }
}
function registerUISupportOnce($this) {
  if ($this.ibt_1)
    return Unit_instance;
  var tmp0_elvis_lhs = $this.mby();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stage = tmp;
  $this.ibt_1 = true;
  if (equals(getExtra(stage, 'uiSupport'), true))
    return Unit_instance;
  setExtra(stage, 'uiSupport', true);
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.UIView.registerUISupportOnce.<anonymous>' call
  get_keys(stage);
}
var Companion_instance_17;
function Companion_getInstance_31() {
  if (Companion_instance_17 === VOID)
    new Companion_3();
  return Companion_instance_17;
}
var ZIndexComparator_instance;
function ZIndexComparator_getInstance() {
  return ZIndexComparator_instance;
}
function Container$renderChildrenInternal$lambda(it) {
  var tmp;
  if (it instanceof FixedSizeContainer) {
    tmp = it.p74();
  } else {
    tmp = false;
  }
  return tmp;
}
function addTo(_this__u8e3s4, parent) {
  parent.abk(_this__u8e3s4);
  return _this__u8e3s4;
}
function dummyView(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = DummyView.rc9();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.dummyView.<anonymous>' call
  _this__u8e3s4.ubw(this_0);
  return this_0;
}
var Companion_instance_18;
function Companion_getInstance_32() {
  return Companion_instance_18;
}
function installFpsDebugOverlay(_this__u8e3s4) {
  var longWindow = new TimeSlidingWindow(240);
  var shortWindow = new TimeSlidingWindow(10);
  var previousTime = {_v: new FastDuration(PerformanceCounter_getInstance().a7t())};
  var frames = {_v: 0};
  var batchCount = {_v: 0};
  var vertexCount = {_v: 0};
  var instanceCount = {_v: 0};
  var tmp = _this__u8e3s4.rbg().ib7_1;
  tmp.q38(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
  var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.rbg().jb6_1).b9w_1;
  tmp_0.q38(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
  var tmp_1 = _this__u8e3s4.rbg().jb6_1.a9n_1.i9o_1;
  tmp_1.q38(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
  var tmp_2 = _this__u8e3s4.rbg().jb6_1.a9n_1.j9o_1;
  tmp_2.q38(installFpsDebugOverlay$lambda_2(instanceCount));
  var tmp_3 = _this__u8e3s4.rbg();
  tmp_3.uc9(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
}
function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
  return function (it) {
    $batchCount._v = 0;
    $vertexCount._v = 0;
    $instanceCount._v = 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.j9w_1 | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
  return function (it) {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.w9t() | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_2($instanceCount) {
  return function (it) {
    $instanceCount._v = $instanceCount._v + it | 0;
    return Unit_instance;
  };
}
function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, fontSize, matrix, text, x, y) {
  var tmp0_font = $this_addDebugRenderer.vbe();
  var tmp1_colMul = $ctx.z9m_1;
  var tmp2_blendMode = Companion_getInstance_12().r9l_1;
  drawText($ctx, tmp0_font, fontSize, text, x, y, matrix, tmp1_colMul, tmp2_blendMode, false);
}
function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
  return function ($this$addDebugRenderer, ctx) {
    var scale = ctx.w9w();
    var fontSize = 8.0 * scale;
    var currentTime = PerformanceCounter_getInstance().a7t();
    var elapsedTime = FastDuration__minus_impl_evs237(currentTime, $previousTime._v.u35_1);
    var tmp;
    if ($frames._v > 3) {
      var tmp_0;
      if (FastDuration__compareTo_impl_4fhnj7_0(elapsedTime, get_fastMilliseconds(4)) > 0) {
        $longWindow.bca(elapsedTime);
        $shortWindow.bca(elapsedTime);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    var _unary__edvuaz = $frames._v;
    $frames._v = _unary__edvuaz + 1 | 0;
    $previousTime._v = new FastDuration(currentTime);
    var matrix = $this$addDebugRenderer.xb5_1.i9v();
    invoke$drawTextWithShadow($this$addDebugRenderer, ctx, fontSize, matrix, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.zc9(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_getInstance_26().v23() + ')'), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale;
    var overlayHeight = 30 * scale;
    var overlayHeightGap = 5.0;
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    var this_0 = $this$addDebugRenderer.jb6_1;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_1 = get_debugLineRenderContext(this_0);
    var this_2 = this_1.a9w_1;
    if (!(this_2.e9n_1 === this_1)) {
      this_2.e9n_1 = this_1;
      this_2.o9o();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_3 = get_debugLineRenderContext(this_0);
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var mut = currentMatrix$factory(this_3);
      var temp = mut.get();
      try {
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix.<anonymous>' call
        if (!(matrix == null))
          this_3.m9w_1 = matrix;
        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>' call
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var blending = Companion_getInstance_12().r9l_1;
          var doUpdate = !(this_1.l9w_1 === blending);
          var old = this_1.l9w_1;
          try {
            if (doUpdate) {
              this_1.a9w_1.o9o();
              this_1.l9w_1 = blending;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var color = Colors_getInstance().o5d_1;
            var oldColor = this_1.d9w_1;
            this_1.d9w_1 = color;
            try {
              // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              this_1.r9w(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
              this_1.r9w(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
            }finally {
              this_1.d9w_1 = oldColor;
            }
            var inductionVariable = 0;
            if (inductionVariable <= 0)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var color_0 = index === 0 ? Colors_getInstance().y57_1 : Colors_getInstance().z57_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_0 = this_1.d9w_1;
                this_1.d9w_1 = color_0;
                try {
                  // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ratio = $longWindow.g1() / $longWindow.vc9_1;
                  var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                  if ($longWindow.g1() > 0) {
                    var previousX = 0.0;
                    var previousY = 0.0;
                    var minFps = 0.0;
                    var maxFps = 150.0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < totalOverlayLines)
                      do {
                        var n = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'kotlin.run' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'korlibs.korge.view.installFpsDebugOverlay.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        var p0 = convertRange(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.g1(), 1));
                        var p1 = convertRange(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.g1(), 1));
                        var plen = 0;
                        var timeSum = get_fastMilliseconds(0);
                        var inductionVariable_1 = p0;
                        var last = coerceAtMost(p1, $longWindow.g1());
                        if (inductionVariable_1 < last)
                          do {
                            var m = inductionVariable_1;
                            inductionVariable_1 = inductionVariable_1 + 1 | 0;
                            timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.aca(m));
                            plen = plen + 1 | 0;
                          }
                           while (inductionVariable_1 < last);
                        if (plen === 0) {
                          timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.aca(p0));
                          plen = plen + 1 | 0;
                        }
                        var time = FastDuration__div_impl_rlslck_0(timeSum, plen);
                        var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                        var fps_0 = fps;
                        var scaledFreq = convertRange_0(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                        var y = graphTop + overlayHeight - scaledFreq;
                        var x = graphLeft + n * overlayWidth / overlayLines;
                        if (n > 0) {
                          this_1.r9w(previousX, previousY + index, x, y + index);
                        }
                        previousY = y;
                        previousX = x;
                      }
                       while (inductionVariable_0 < totalOverlayLines);
                  }
                }finally {
                  this_1.d9w_1 = oldColor_0;
                }
              }
               while (inductionVariable <= 0);
            break $l$block;
          }finally {
            if (doUpdate) {
              this_1.a9w_1.o9o();
            }
            this_1.l9w_1 = old;
          }
        }
        break $l$block_0;
      }finally {
        mut.set(temp);
      }
    }
    return Unit_instance;
  };
}
function currentMatrix$factory($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.m9w_1;
  }, function (value) {
    $b0.m9w_1 = value;
    return Unit_instance;
  });
}
function *_generator_forceLoadSourceFile__yy5vos($this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.mcc($this, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  try {
    var tmp_0 = readBitmapSlice(currentVfs.cj('' + sourceFile), VOID, VOID, VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    $this.vce(tmp_0);
    $this.tbx(1.0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$0 = get_Bitmaps_white();
      $this.vce(tmp$ret$0);
      $this.tbx(100.0);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_baseForceLoadSourceFile__natc6b(_this__u8e3s4, $this, views, currentVfs, sourceFile, $completion) {
  var tmp = $this.kcc_1.mcc(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function trySetSourceActually($this) {
  var source = $this.uce_1.f29();
  if (!(source == null)) {
    $this.tce_1 = true;
    $this.tch(source);
  }
}
function sourceFile$factory($b0) {
  return getPropertyCallableRef('sourceFile', 0, KMutableProperty0, function () {
    return $b0.gcf();
  }, function (value) {
    return $b0.fcf(value);
  });
}
var Companion_instance_19;
function Companion_getInstance_33() {
  return Companion_instance_19;
}
function clipBorders$factory($b0) {
  return getPropertyCallableRef('clipBorders', 0, KMutableProperty0, function () {
    return $b0.vb6_1;
  }, function (value) {
    $b0.vb6_1 = value;
    return Unit_instance;
  });
}
function virtualSizeDouble$factory($b0) {
  return getPropertyCallableRef('virtualSizeDouble', 0, KMutableProperty0, function () {
    return $b0.eci();
  }, function (value) {
    return $b0.fci(value);
  });
}
function clip$factory() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.p74();
  }, function (receiver, value) {
    return receiver.bci(value);
  });
}
function clip$factory_0() {
  return getPropertyCallableRef('clip', 1, KMutableProperty1, function (receiver) {
    return receiver.p74();
  }, function (receiver, value) {
    return receiver.bci(value);
  });
}
function unscaledSize$factory() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.nbt();
  }, function (receiver, value) {
    return receiver.cci(value);
  });
}
function unscaledSize$factory_0() {
  return getPropertyCallableRef('unscaledSize', 1, KMutableProperty1, function (receiver) {
    return receiver.nbt();
  }, function (receiver, value) {
    return receiver.cci(value);
  });
}
function get_agProgram(_this__u8e3s4) {
  switch (_this__u8e3s4.c5r()) {
    case 'msdf':
      return MsdfRender_getInstance().gc0_1;
    case 'psdf':
      return MsdfRender_getInstance().jc0_1;
    case 'sdf':
      return MsdfRender_getInstance().jc0_1;
    default:
      return null;
  }
}
var Companion_instance_20;
function Companion_getInstance_34() {
  return Companion_instance_20;
}
function updateRenderColorTransform($this) {
  $this.jb9_1 = $this.ob9_1;
  $this.qb9_1 = true;
  var parent = $this.z3g();
  if (!((parent == null ? null : get_filter(parent)) == null)) {
    $this.ib9_1.j5p($this.hb9_1);
  } else {
    var tmp;
    if (!(parent == null)) {
      tmp = !isInterface($this, ColorReference);
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.ib9_1.k5p($this.hb9_1, parent.rby());
    } else {
      $this.ib9_1.j5p($this.hb9_1);
    }
  }
}
function updateRenderColorTransformIfRequired($this) {
  if ($this.jb9_1 === $this.ob9_1)
    return Unit_instance;
  updateRenderColorTransform($this);
}
function updateRenderBlendMode($this) {
  $this.lb9_1 = $this.nb9_1;
  $this.pb9_1 = true;
  var tmp = $this;
  var tmp_0;
  if ($this.nb8_1.equals(Companion_getInstance_12().i9l_1)) {
    var tmp1_safe_receiver = $this.z3g();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.sby();
    tmp_0 = tmp2_elvis_lhs == null ? Companion_getInstance_12().h9l_1 : tmp2_elvis_lhs;
  } else {
    tmp_0 = $this.nb8_1;
  }
  tmp.kb9_1 = tmp_0;
}
function updateRenderBlendModeIfRequired($this) {
  if ($this.lb9_1 === $this.nb9_1)
    return Unit_instance;
  updateRenderBlendMode($this);
}
function View$bviewAll$delegate$lambda(this$0) {
  return function () {
    return listOf(this$0);
  };
}
function addFastUpdater(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_instance_1.r35() : firstTime;
  if (first)
    updatable(_this__u8e3s4, new FastDuration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.a7v(tmp, addFastUpdater$lambda(updatable, _this__u8e3s4));
}
function addFastUpdater_0(_this__u8e3s4, updatable) {
  return addFastUpdater(_this__u8e3s4, true, VOID, updatable);
}
function addOptFixedUpdater(_this__u8e3s4, time, updatable) {
  var tmp;
  if (time === VOID) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    tmp = time;
  }
  time = tmp;
  var tmp_0;
  // Inline function 'korlibs.time.NIL' call
  Companion_getInstance();
  var tmp$ret$1 = get_DURATION_NIL();
  if (equals(time, tmp$ret$1)) {
    tmp_0 = addUpdater(_this__u8e3s4, updatable);
  } else {
    tmp_0 = addFixedUpdater(_this__u8e3s4, time, VOID, VOID, addOptFixedUpdater$lambda(updatable, time));
  }
  return tmp_0;
}
function addUpdaterWithViews(_this__u8e3s4, updatable) {
  var tmp = Companion_instance_21;
  return _this__u8e3s4.a7v(tmp, addUpdaterWithViews$lambda(updatable, _this__u8e3s4));
}
function hasAncestor(_this__u8e3s4, ancestor) {
  var tmp;
  if (equals(_this__u8e3s4, ancestor)) {
    tmp = true;
  } else {
    var tmp0_safe_receiver = _this__u8e3s4.z3g();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, ancestor);
    tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  return tmp;
}
function descendantsWith(_this__u8e3s4, out, check) {
  var tmp;
  if (out === VOID) {
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp = ArrayList.z();
  } else {
    tmp = out;
  }
  out = tmp;
  if (!(_this__u8e3s4 == null)) {
    if (check(_this__u8e3s4)) {
      // Inline function 'kotlin.collections.plusAssign' call
      out.h(_this__u8e3s4);
    }
    if (_this__u8e3s4.bb8_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp0_safe_receiver = _this__u8e3s4.lbw();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp0_safe_receiver.g1()) {
          // Inline function 'korlibs.korge.view.descendantsWith.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp0_safe_receiver.h1(_unary__edvuaz);
          descendantsWith(child, out, check);
        }
        tmp_0 = Unit_instance;
      }
    }
  }
  return out;
}
function addFixedUpdater(_this__u8e3s4, time, first, limitCallsPerFrame, updatable) {
  first = first === VOID ? true : first;
  limitCallsPerFrame = limitCallsPerFrame === VOID ? 16 : limitCallsPerFrame;
  return addFixedUpdater_0(_this__u8e3s4, get_fast(time), first, limitCallsPerFrame, updatable);
}
function findFirstAscendant(_this__u8e3s4, cond) {
  var current = _this__u8e3s4;
  while (!(current == null)) {
    if (cond(current))
      return current;
    current = current.z3g();
  }
  return null;
}
function get_ancestorCount(_this__u8e3s4) {
  var count = 0;
  var parent = _this__u8e3s4 == null ? null : _this__u8e3s4.z3g();
  while (!(parent == null)) {
    count = count + 1 | 0;
    parent = parent.z3g();
  }
  return count;
}
function addUpdater(_this__u8e3s4, updatable) {
  return addUpdater_0(_this__u8e3s4, true, VOID, updatable);
}
function addFixedUpdater_0(_this__u8e3s4, time, first, limitCallsPerFrame, updatable) {
  first = first === VOID ? true : first;
  limitCallsPerFrame = limitCallsPerFrame === VOID ? 16 : limitCallsPerFrame;
  var accum = {_v: new FastDuration(Companion_instance_1.r35())};
  return addFastUpdater(_this__u8e3s4, first, time, addFixedUpdater$lambda(accum, time, updatable, _this__u8e3s4, limitCallsPerFrame));
}
function addUpdater_0(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_getInstance().mk_1 : firstTime;
  if (first)
    updatable(_this__u8e3s4, new Duration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.a7v(tmp, addUpdater$lambda(updatable, _this__u8e3s4));
}
function addFixedUpdater_1(_this__u8e3s4, timesPerSecond, initial, limitCallsPerFrame, updatable) {
  initial = initial === VOID ? true : initial;
  limitCallsPerFrame = limitCallsPerFrame === VOID ? 16 : limitCallsPerFrame;
  return addFixedUpdater_0(_this__u8e3s4, _Frequency___get_fastDuration__impl__87web0(timesPerSecond), initial, limitCallsPerFrame, updatable);
}
function xy(_this__u8e3s4, x, y) {
  _this__u8e3s4.pbx(x, y);
  return _this__u8e3s4;
}
function addFastUpdater$lambda($updatable, $this_addFastUpdater) {
  return function (it) {
    $updatable($this_addFastUpdater, new FastDuration(FastDuration__times_impl_h6amcp(it.ka7_1, $this_addFastUpdater.obx())));
    return Unit_instance;
  };
}
function addOptFixedUpdater$lambda($updatable, $time) {
  return function ($this$addFixedUpdater) {
    $updatable($this$addFixedUpdater, new Duration($time));
    return Unit_instance;
  };
}
function addUpdaterWithViews$lambda($updatable, $this_addUpdaterWithViews) {
  return function (it) {
    $updatable($this_addUpdaterWithViews, it.mci_1, new Duration(Duration__times_impl_sfuzvp(it.oci(), $this_addUpdaterWithViews.obx())));
    return Unit_instance;
  };
}
function addFixedUpdater$lambda($accum, $time, $updatable, $this_addFixedUpdater, $limitCallsPerFrame) {
  return function ($this$addFastUpdater, dt) {
    $accum._v = new FastDuration(FastDuration__plus_impl_q1enab($accum._v.u35_1, dt.u35_1));
    var calls = 0;
    $l$loop: while (FastDuration__compareTo_impl_4fhnj7_0($accum._v.u35_1, FastDuration__times_impl_h6amcp($time, 0.75)) >= 0) {
      $accum._v = new FastDuration(FastDuration__minus_impl_evs237($accum._v.u35_1, $time));
      $updatable($this_addFixedUpdater);
      calls = calls + 1 | 0;
      if (calls >= $limitCallsPerFrame) {
        $accum._v = new FastDuration(Companion_instance_1.r35());
        break $l$loop;
      }
    }
    return Unit_instance;
  };
}
function addUpdater$lambda($updatable, $this_addUpdater) {
  return function (it) {
    $updatable($this_addUpdater, new Duration(Duration__times_impl_sfuzvp(it.la7(), $this_addUpdater.obx())));
    return Unit_instance;
  };
}
function scale$factory($b0) {
  return getPropertyCallableRef('scale', 0, KMutableProperty0, function () {
    return $b0.ubx();
  }, function (value) {
    return $b0.tbx(value);
  });
}
function bviewAll$factory() {
  return getPropertyCallableRef('bviewAll', 1, KProperty1, function (receiver) {
    return receiver.dbx();
  }, null);
}
function currentMatrix$factory_0($b0) {
  return getPropertyCallableRef('currentMatrix', 0, KMutableProperty0, function () {
    return $b0.m9w_1;
  }, function (value) {
    $b0.m9w_1 = value;
    return Unit_instance;
  });
}
function *_generator_invoke__zhh2q8_15($this, $completion) {
  var tmp = $this.pci_1.dcf(ensureNotNull(get_views($this.qci_1)), VOID, $this.rci_1.xce_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda_0($view, $ctx, this$0) {
  var i = new ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  var tmp = $this.tci_1.uci($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_init__qn9atk($this, $completion) {
  var tmp = $this;
  var tmp_0 = debugBmpFont($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.fb6_1 = tmp_0;
  return Unit_instance;
}
function *_generator_closeSuspend__agjafw($this, $completion) {
  KorgeReload_getInstance().g9l();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.sb6_1;
  var n = 0;
  while (n < this_0.g1()) {
    // Inline function 'korlibs.korge.view.Views.closeSuspend.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var tmp = this_0.h1(_unary__edvuaz).r2z($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  $this.sb6_1.h3();
  cancel($this.kb5_1);
  $this.qb5_1.sa5();
  return Unit_instance;
}
function Views$_init_$lambda_jivasj(it) {
  return Stage.vb4(it);
}
function Views$realSettingsFolder$delegate$lambda(this$0) {
  return function () {
    return !(this$0.sb5_1 == null) ? ensureNotNull(this$0.sb5_1) : StandardPaths_instance.o4b(this$0.vci());
  };
}
function Views$close$slambda_0(this$0) {
  var i = new Views$close$slambda(this$0);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function Views$tempViewsPool$lambda(it) {
  return FastArrayList.u28();
}
function Views$lambda(this$0) {
  return function (it) {
    this$0.jb6_1.s9s();
    return Unit_instance;
  };
}
function Views$lambda_0(this$0) {
  return function (it) {
    this$0.jb6_1.g9x();
    return Unit_instance;
  };
}
var Companion_instance_21;
function Companion_getInstance_35() {
  return Companion_instance_21;
}
var Companion_instance_22;
function Companion_getInstance_36() {
  return Companion_instance_22;
}
function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
  // Inline function 'kotlin.also' call
  var this_0 = views.bb6_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_0.ka7_1 = delta;
  _this__u8e3s4.l7v(this_0);
  // Inline function 'kotlin.also' call
  var this_1 = views.cb6_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.updateSingleViewWithViewsAll.<anonymous>' call
  this_1.nci_1 = delta;
  _this__u8e3s4.l7v(this_1);
}
function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
  scaleMode = scaleMode === VOID ? Companion_getInstance_15().n3s() : scaleMode;
  anchor = anchor === VOID ? Companion_getInstance_16().e3i() : anchor;
  virtualSize = virtualSize === VOID ? Ref_0() : virtualSize;
  targetSize = targetSize === VOID ? Ref_0() : targetSize;
  var reqVirtualSize_0 = toInt(reqVirtualSize);
  var actualSize_0 = toInt(actualSize);
  virtualSize.j43(reqVirtualSize_0);
  targetSize.j43(scaleMode.q3s(virtualSize.w1(), actualSize_0));
  var ratioX = targetSize.w1().v3s_1 / reqVirtualSize_0.v3s_1;
  var ratioY = targetSize.w1().w3s_1 / reqVirtualSize_0.w3s_1;
  var actualVirtualWidth = toIntRound(actualSize_0.v3s_1 / ratioX);
  var actualVirtualHeight = toIntRound(actualSize_0.w3s_1 / ratioY);
  _this__u8e3s4.l9v(Companion_getInstance_21().z3l_1.z3m(ratioX, ratioY).f3n(toIntRound((actualVirtualWidth - reqVirtualSize_0.v3s_1 | 0) * anchor.b3i_1), toIntRound((actualVirtualHeight - reqVirtualSize_0.w3s_1 | 0) * anchor.c3i_1)));
  _this__u8e3s4.h9v(_this__u8e3s4.m9v().h3n());
  _this__u8e3s4.n9v(_this__u8e3s4.m9v().i3n());
  _this__u8e3s4.j9v(_this__u8e3s4.i9v().i3n());
  var tl = _this__u8e3s4.v9v(Vector2D.k3l(0, 0));
  var br = _this__u8e3s4.v9v(Vector2D.y3k(actualSize_0.v3s_1, actualSize_0.w3s_1));
  _this__u8e3s4.o9v(Companion_getInstance_19().o3q(tl.r3i_1, tl.s3i_1, br.r3i_1, br.s3i_1));
}
function *_generator_views__wf4006($completion) {
  // Inline function 'korlibs.inject.Injector.get' call
  var tmp = injector($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.n7s(getKClass(Views));
}
function views($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_views__wf4006.bind(VOID), $completion);
}
function quality$factory($b0) {
  return getPropertyCallableRef('quality', 0, KMutableProperty0, function () {
    return $b0.u9w();
  }, function (value) {
    return $b0.ma5(value);
  });
}
function continuousRenderMode$factory($b0) {
  return getPropertyCallableRef('continuousRenderMode', 0, KMutableProperty0, function () {
    return $b0.wa5();
  }, function (value) {
    return $b0.va5(value);
  });
}
function debugExtraFontScale$factory($b0) {
  return getPropertyCallableRef('debugExtraFontScale', 0, KMutableProperty0, function () {
    return $b0.y9m_1;
  }, function (value) {
    $b0.y9m_1 = value;
    return Unit_instance;
  });
}
function debugExtraFontColor$factory($b0) {
  return getPropertyCallableRef('debugExtraFontColor', 0, KMutableProperty0, function () {
    return new RGBA($b0.z9m_1);
  }, function (value) {
    $b0.z9m_1 = value.o5p_1;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory($b0) {
  return getPropertyCallableRef('updatedSinceFrame', 0, KMutableProperty0, function () {
    return $b0.ja3_1;
  }, function (value) {
    $b0.ja3_1 = value;
    return Unit_instance;
  });
}
function forceRenderEveryFrame$factory() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.obd();
  }, function (receiver, value) {
    return receiver.ubd(value);
  });
}
function forceRenderEveryFrame$factory_0() {
  return getPropertyCallableRef('forceRenderEveryFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.obd();
  }, function (receiver, value) {
    return receiver.ubd(value);
  });
}
function debugFontExtraScale$factory() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.acj();
  }, function (receiver, value) {
    return receiver.kbd(value);
  });
}
function debugFontExtraScale$factory_0() {
  return getPropertyCallableRef('debugFontExtraScale', 1, KMutableProperty1, function (receiver) {
    return receiver.acj();
  }, function (receiver, value) {
    return receiver.kbd(value);
  });
}
function debugFontColor$factory() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.bcj());
  }, function (receiver, value) {
    return receiver.lbd(value.o5p_1);
  });
}
function debugFontColor$factory_0() {
  return getPropertyCallableRef('debugFontColor', 1, KMutableProperty1, function (receiver) {
    return new RGBA(receiver.bcj());
  }, function (receiver, value) {
    return receiver.lbd(value.o5p_1);
  });
}
function virtualSize$factory($b0) {
  return getPropertyCallableRef('virtualSize', 0, KMutableProperty0, function () {
    return $b0.fb7_1;
  }, function (value) {
    $b0.fb7_1 = value;
    return Unit_instance;
  });
}
function targetSize$factory($b0) {
  return getPropertyCallableRef('targetSize', 0, KMutableProperty0, function () {
    return $b0.hb7_1;
  }, function (value) {
    $b0.hb7_1 = value;
    return Unit_instance;
  });
}
function updatedSinceFrame$factory_0() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.jcj();
  }, function (receiver, value) {
    return receiver.pcj(value);
  });
}
function updatedSinceFrame$factory_1() {
  return getPropertyCallableRef('updatedSinceFrame', 1, KMutableProperty1, function (receiver) {
    return receiver.jcj();
  }, function (receiver, value) {
    return receiver.pcj(value);
  });
}
function alignRightToLeftOf(_this__u8e3s4, other, padding) {
  return alignRightToLeftOf_0(_this__u8e3s4, other, padding);
}
function alignRightToLeftOf_0(_this__u8e3s4, other, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignX(_this__u8e3s4, other, 0.0, false, padding);
}
function alignX(_this__u8e3s4, other, ratio, inside, padding) {
  padding = padding === VOID ? 0.0 : padding;
  return alignXY(_this__u8e3s4, other, ratio, inside, true, padding);
}
function alignXY(_this__u8e3s4, other, ratio, inside, doX, padding) {
  padding = padding === VOID ? 0.0 : padding;
  var bounds = other.rbz(_this__u8e3s4.z3g());
  var localBounds = _this__u8e3s4.sbe();
  var ratioM1_1 = ratio * 2 - 1;
  var rratioM1_1 = inside ? ratioM1_1 : -ratioM1_1;
  var iratio = inside ? ratio : 1.0 - ratio;
  if (doX) {
    _this__u8e3s4.qbx(bounds.b3j_1 + bounds.d3j_1 * ratio - localBounds.i3j() - _this__u8e3s4.hby() * iratio - padding * rratioM1_1);
  } else {
    _this__u8e3s4.rbx(bounds.c3j_1 + bounds.e3j_1 * ratio - localBounds.d3q() - _this__u8e3s4.iby() * iratio - padding * rratioM1_1);
  }
  return _this__u8e3s4;
}
function _get_computedDirection__2w15cx($this) {
  var tmp0_elvis_lhs = $this.ecm_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp1_safe_receiver = $this.dcm_1;
    tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.z6m_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp2_elvis_lhs = tmp;
  return tmp2_elvis_lhs == null ? Direction_FORWARD_getInstance() : tmp2_elvis_lhs;
}
function setFrame($this, frameIndex) {
  var tmp;
  var tmp2_safe_receiver = $this.dcm_1;
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.y6m_1;
  var tmp_0;
  if (tmp3_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_0 = !tmp3_safe_receiver.j1();
  }
  if (tmp_0 === true) {
    var tmp0_safe_receiver = $this.dcm_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y6m_1;
    tmp = tmp1_safe_receiver == null ? null : getCyclicOrNull(tmp1_safe_receiver, frameIndex);
  } else {
    tmp = null;
  }
  var frame = tmp;
  if (!(frame == null)) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = frame.s6l_1;
    var n = 0;
    while (n < this_0.g1()) {
      // Inline function 'korlibs.korge.view.animation.ImageAnimationView.setFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.h1(_unary__edvuaz);
      var image = $this.ocm().h1(it.w6l_1.m6l_1);
      if (it.w6l_1.o6l_1.p3_1 === 0) {
        (isInterface(image, SmoothedBmpSlice) ? image : THROW_CCE()).vce(it.f6m_1);
      } else {
        if (!(image instanceof TileMap))
          THROW_CCE();
        var tilemap = it.b6m_1;
        if (tilemap == null) {
          image.pco_1 = TileMapData.n6y(1, 1);
          image.mcp(Companion_getInstance_3().i6j_1);
        } else {
          image.pco_1 = tilemap;
          var tmp1_elvis_lhs = tilemap.j6y_1;
          image.mcp(tmp1_elvis_lhs == null ? Companion_getInstance_3().i6j_1 : tmp1_elvis_lhs);
        }
      }
      // Inline function 'korlibs.korge.view.xy' call
      var x = it.x6l_1;
      var y = it.y6l_1;
      xy(image, numberToDouble(x), numberToDouble(y));
    }
    $this.icm_1 = get_fast(frame.h6p());
    var tmp_1 = $this;
    var tmp_2;
    switch (_get_computedDirection__2w15cx($this).p3_1) {
      case 2:
        tmp_2 = 1;
        break;
      case 3:
        tmp_2 = -1;
        break;
      case 4:
        var tmp_3;
        var containsUpper = $this.zcl_1;
        var containsArg = frameIndex + $this.kcm_1 | 0;
        if (!(0 <= containsArg ? containsArg < containsUpper : false)) {
          tmp_3 = -$this.kcm_1 | 0;
        } else {
          tmp_3 = $this.kcm_1;
        }

        tmp_2 = tmp_3;
        break;
      case 0:
        tmp_2 = frameIndex < ($this.zcl_1 - 1 | 0) ? 1 : 0;
        break;
      case 1:
        tmp_2 = frameIndex === 0 ? 0 : -1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp_1.kcm_1 = tmp_2;
    $this.jcm_1 = umod(frameIndex + $this.kcm_1 | 0, $this.zcl_1);
  } else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = $this.ocm();
    var n_0 = 0;
    while (n_0 < this_1.g1()) {
      // Inline function 'korlibs.korge.view.animation.ImageAnimationView.setFrame.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it_0 = this_1.h1(_unary__edvuaz_0);
      if (isInterface(it_0, SmoothedBmpSlice)) {
        // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
        var tmp$ret$2 = get_Bitmaps_transparent();
        it_0.vce(tmp$ret$2);
      }
    }
  }
}
function setFirstFrame($this) {
  if (_get_computedDirection__2w15cx($this).equals(Direction_REVERSE_getInstance()) || _get_computedDirection__2w15cx($this).equals(Direction_ONCE_REVERSE_getInstance())) {
    setFrame($this, $this.zcl_1 - 1 | 0);
  } else {
    setFrame($this, 0);
  }
}
function didSetAnimation($this) {
  var tmp = $this;
  var tmp0_safe_receiver = $this.dcm_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y6m_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.g1();
  tmp.zcl_1 = tmp2_elvis_lhs == null ? 1 : tmp2_elvis_lhs;
  var _iterator__ex2g4s = $this.ocm().b1();
  while (_iterator__ex2g4s.c1()) {
    var layer = _iterator__ex2g4s.d1();
    if (layer instanceof TileMap) {
      var tmp3_safe_receiver = $this.ccm_1;
      if (tmp3_safe_receiver == null)
        null;
      else
        tmp3_safe_receiver(layer);
    } else {
      var tmp4_safe_receiver = $this.bcm_1;
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver(isInterface(layer, SmoothedBmpSlice) ? layer : THROW_CCE());
      }
    }
  }
  $this.gcm_1.h3();
  $this.fcm_1.tbw();
  $this.kcm_1 = 1;
  var animation = $this.dcm_1;
  if (!(animation == null)) {
    var _iterator__ex2g4s_0 = animation.b6n_1.b1();
    while (_iterator__ex2g4s_0.c1()) {
      var layer_0 = _iterator__ex2g4s_0.d1();
      var tmp_0;
      switch (layer_0.o6l_1.p3_1) {
        case 0:
          // Inline function 'kotlin.also' call

          var this_0 = $this.ycl_1();
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.korge.view.animation.ImageAnimationView.didSetAnimation.<anonymous>' call

          this_0.sch($this.mcm_1);
          var tmp_1 = this_0;
          tmp_0 = tmp_1 instanceof View ? tmp_1 : THROW_CCE();
          break;
        case 2:
          tmp_0 = $this.ncp();
          break;
        case 1:
          throw NotImplementedError.je();
        default:
          noWhenBranchMatchedException();
          break;
      }
      var image = tmp_0;
      $this.gcm_1.h(image);
      // Inline function 'korlibs.datastructure.set' call
      var this_1 = $this.hcm_1;
      var tmp6_elvis_lhs = layer_0.n6l_1;
      var key = tmp6_elvis_lhs == null ? 'default' : tmp6_elvis_lhs;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.js.asDynamic' call
      this_1.set(key, image);
      $this.fcm_1.ubw(image instanceof View ? image : THROW_CCE());
    }
  }
  setFirstFrame($this);
}
function ImageAnimationView$lambda($this$addFastUpdater, it) {
  if ($this$addFastUpdater.ncm_1) {
    $this$addFastUpdater.icm_1 = FastDuration__minus_impl_evs237($this$addFastUpdater.icm_1, it.u35_1);
    var tmp = $this$addFastUpdater.icm_1;
    // Inline function 'korlibs.time.milliseconds' call
    var tmp$ret$0 = toDuration(0.0, DurationUnit_MILLISECONDS_getInstance());
    if (FastDuration__compareTo_impl_4fhnj7(tmp, tmp$ret$0) <= 0) {
      setFrame($this$addFastUpdater, $this$addFastUpdater.jcm_1);
      if ($this$addFastUpdater.kcm_1 === 0) {
        $this$addFastUpdater.ncm_1 = false;
        var tmp0_safe_receiver = $this$addFastUpdater.acm_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
      }
    }
  }
  return Unit_instance;
}
function updatedDataAnimation($this) {
  var tmp = $this.jcs();
  var tmp_0;
  if (!($this.ics_1 == null)) {
    var tmp0_safe_receiver = $this.hcs_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t6n_1;
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      var key = $this.ics_1;
      tmp_1 = (isInterface(tmp1_safe_receiver, KtMap) ? tmp1_safe_receiver : THROW_CCE()).e3(key);
    }
    tmp_0 = tmp_1;
  } else {
    var tmp2_safe_receiver = $this.hcs_1;
    tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.s6n_1;
  }
  tmp.qcp(tmp_0);
}
function ImageDataView$createAnimationView$lambda() {
  // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
  var tmp$ret$0 = get_Bitmaps_transparent();
  return Image.acf(tmp$ret$0);
}
function anchorPixel$factory($b0) {
  return getPropertyCallableRef('anchorPixel', 0, KMutableProperty0, function () {
    return $b0.scp();
  }, function (value) {
    return $b0.rcp(value);
  });
}
function anchor$factory($b0) {
  return getPropertyCallableRef('anchor', 0, KMutableProperty0, function () {
    return $b0.uch();
  }, function (value) {
    return $b0.tcp(value);
  });
}
var renderToTextureResultPool$delegate;
var Companion_instance_23;
function Companion_getInstance_37() {
  if (Companion_instance_23 === VOID)
    new Companion_9();
  return Companion_instance_23;
}
function expandedBorderRectangle(_this__u8e3s4, inp) {
  _init_properties_Filter_kt__xu8pbc();
  return inp.k3r(getBorder(_this__u8e3s4, toIntCeil(inp.d3j_1), toIntCeil(inp.e3j_1)));
}
function getBorder(_this__u8e3s4, texWidth, texHeight) {
  _init_properties_Filter_kt__xu8pbc();
  return _this__u8e3s4.pcs(texWidth, texHeight);
}
function renderToTextureResultPool$delegate$lambda() {
  _init_properties_Filter_kt__xu8pbc();
  var tmp = renderToTextureResultPool$delegate$lambda$lambda;
  return Pool.c42(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
}
function renderToTextureResultPool$delegate$lambda$lambda(it) {
  _init_properties_Filter_kt__xu8pbc();
  it.k2i();
  return Unit_instance;
}
function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
  _init_properties_Filter_kt__xu8pbc();
  return new RenderToTextureResult();
}
var properties_initialized_Filter_kt_lkm0w6;
function _init_properties_Filter_kt__xu8pbc() {
  if (!properties_initialized_Filter_kt_lkm0w6) {
    properties_initialized_Filter_kt_lkm0w6 = true;
    renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
  }
}
var Companion_instance_24;
function Companion_getInstance_38() {
  if (Companion_instance_24 === VOID)
    new Companion_10();
  return Companion_instance_24;
}
function set_filterScale(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var this_0 = filterScale$delegate;
  var property = filterScale$factory();
  var value = this_0.i28_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.g28_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_filterScale(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = filterScale$delegate;
    var property = filterScale$factory_0();
    var tmp0_elvis_lhs = this_0.g28_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.h28_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.g28_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var filterScale$delegate;
function renderFiltered(_this__u8e3s4, ctx, filter, first) {
  first = first === VOID ? true : first;
  _init_properties_ViewFilter_kt__pd9xp9();
  var bounds = _this__u8e3s4.sbe(VOID, false);
  if (bounds.d3j_1 <= 0.0 || bounds.e3j_1 <= 0.0)
    return Unit_instance;
  var tmp = Companion_getInstance_37();
  // Inline function 'kotlin.math.min' call
  var a = get_filterScale(_this__u8e3s4);
  var b = filter.ocs();
  var tmp$ret$0 = Math.min(a, b);
  var tryFilterScale = tmp.ncs(tmp$ret$0);
  var texWidthNoBorder = coerceAtLeast(numberToInt(bounds.d3j_1 * tryFilterScale), 1);
  var texHeightNoBorder = coerceAtLeast(numberToInt(bounds.e3j_1 * tryFilterScale), 1);
  var realFilterScale = clamp_0(texWidthNoBorder / bounds.d3j_1, 0.03125, 1.0);
  var tmp_0;
  switch (false) {
    case true:
      tmp_0 = clamp_1(toIntCeil(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
      break;
    case false:
      tmp_0 = 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var edgeSize = tmp_0;
  var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
  var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
  var addx = -bounds.b3j_1 + edgeSize;
  var addy = -bounds.c3j_1 + edgeSize;
  // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
  ctx.o9o();
  // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
  var rb = ctx.i9x(texWidth, texHeight, false, true, 1);
  try {
    // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>' call
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.k9x(rb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer.<anonymous>' call
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.a9n_1;
      var this_1 = this_0.j9n_1;
      if (!(this_1.e9n_1 === this_0)) {
        this_1.e9n_1 = this_0;
        this_1.o9o();
      }
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var scissor = AGScissor.q8d(0, 0, rb.o83_1, rb.p83_1);
        var temp = this_0.h9o_1;
        this_0.o9u();
        this_0.h9o_1 = scissor;
        try {
          if (true) {
            ctx.c9x(Colors_getInstance().d58_1);
          }
          // Inline function 'korlibs.korge.render.RenderContext.renderToTexture.<anonymous>.<anonymous>' call
          // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
          var mat = _this__u8e3s4.qby().d3n(addx, addy).y3m(realFilterScale);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          var this_2 = ctx.a9n_1.j9n_1;
          this_2.o9o();
          var temp4 = this_2.p9m_1;
          var temp2d = this_2.q9m_1;
          this_2.q9m_1 = mat;
          this_2.p9m_1 = toMatrix4(mat);
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var this_3 = this_2.d8a(ProjViewUB_getInstance());
            var _unary__edvuaz = this_3.s8b();
            this_3.e8y(_unary__edvuaz + 1 | 0);
            this_3.f8y(this_3.s8b() + 1 | 0);
            var blockSize = this_3.w89_1;
            var index0 = imul(this_3.s8b() - 1 | 0, blockSize);
            var index1 = imul(this_3.s8b(), blockSize);
            var texBlockSize = this_3.t89_1.g8i().g1();
            var texIndex0 = imul(this_3.s8b() - 1 | 0, texBlockSize);
            var texIndex1 = imul(this_3.s8b(), texBlockSize);
            if (this_3.s8b() > 0) {
              arraycopy(this_3.y89_1, index0, this_3.y89_1, index1, blockSize);
            } else {
              arrayfill(this_3.y89_1, 0, 0, blockSize);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp.<anonymous>' call
            var $this$push = this_3.t89_1;
            this_3.z89_1.i8y($this$push.f8i(), this_2.p9m_1);
            if (true && this_3.s8b() >= 1) {
              var equals = arrayequal(this_3.y89_1, index0, this_3.y89_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = this_3.s8b();
                this_3.e8y(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          var tmp_1;
          try {
            var tmp_2;
            if (first) {
              _this__u8e3s4.yby(ctx);
              tmp_2 = Unit_instance;
            } else {
              _this__u8e3s4.zby(ctx);
              tmp_2 = Unit_instance;
            }
            tmp_1 = tmp_2;
          }finally {
            this_2.o9o();
            this_2.p9m_1 = temp4;
            this_2.q9m_1 = temp2d;
            this_2.d8a(ProjViewUB_getInstance()).g8y();
          }
          break $l$block_0;
        }finally {
          this_0.o9u();
          this_0.h9o_1 = temp;
        }
      }
    }finally {
      ctx.l9x();
    }
    // Inline function 'korlibs.korge.view.filter.renderFiltered.<anonymous>' call
    var texture = Texture_0(rb).z4s(0, 0, texWidth, texHeight);
    var mat_0 = _this__u8e3s4.ube().f3n(-addx, -addy).a3n(1.0 / realFilterScale);
    filter.qcs(ctx, mat_0, texture, texWidth, texHeight, _this__u8e3s4.tby(), _this__u8e3s4.nb8_1, realFilterScale);
    ctx.o9o();
  }finally {
    ctx.j9x(rb);
  }
}
function get_filter(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.tb9_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_safe_receiver.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull.<anonymous>' call
        if (element instanceof ViewRenderPhaseFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.dct_1;
}
function filterScale$delegate$lambda($this$extraPropertyThis, it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return Companion_getInstance_37().ncs(it);
}
function filterScale$delegate$lambda_0($this$extraPropertyThis) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return 1.0;
}
function filterScale$factory() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
function filterScale$factory_0() {
  return getPropertyCallableRef('filterScale', 1, KMutableProperty1, function (receiver) {
    return get_filterScale(receiver);
  }, function (receiver, value) {
    return set_filterScale(receiver, value);
  });
}
var properties_initialized_ViewFilter_kt_mku9up;
function _init_properties_ViewFilter_kt__pd9xp9() {
  if (!properties_initialized_ViewFilter_kt_mku9up) {
    properties_initialized_ViewFilter_kt_mku9up = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var transform = filterScale$delegate$lambda;
    var default_0 = filterScale$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.i28_1 = transform;
    filterScale$delegate = this_0;
  }
}
function transformIndex($this, flipX, flipY, rotate) {
  return insert(insert(insert(0, flipX, 0), flipY, 1), rotate, 2);
}
function computeIndices($this, flipX, flipY, rotate, indices) {
  indices[0] = 0;
  indices[1] = 1;
  indices[2] = 2;
  indices[3] = 3;
  if (rotate) {
    swap(indices, $this, 1, 3);
  }
  if (flipY) {
    swap(indices, $this, 0, 3);
    swap(indices, $this, 1, 2);
  }
  if (flipX) {
    swap(indices, $this, 0, 1);
    swap(indices, $this, 3, 2);
  }
  return indices;
}
function computeIndices$default($this, flipX, flipY, rotate, indices, $super) {
  indices = indices === VOID ? new Int32Array(4) : indices;
  return computeIndices($this, flipX, flipY, rotate, indices);
}
function swap(_this__u8e3s4, $this, a, b) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.tiles.Companion.swap.<anonymous>' call
  var t = _this__u8e3s4[a];
  _this__u8e3s4[a] = _this__u8e3s4[b];
  _this__u8e3s4[b] = t;
  return _this__u8e3s4;
}
var Companion_instance_25;
function Companion_getInstance_39() {
  if (Companion_instance_25 === VOID)
    new Companion_11();
  return Companion_instance_25;
}
function computeVertexIfRequired($this, ctx) {
  $this.dcp_1 = new Rectangle(ctx.q9v(), ctx.r9v(), ctx.s9v(), ctx.t9v());
  if (!$this.dcp_1.equals($this.ccp_1)) {
    $this.mb9_1 = true;
    $this.ccp_1 = $this.dcp_1;
  }
  if (!$this.mb9_1 && $this.xco_1 === $this.pco_1.o43() && $this.yco_1 === $this.wco_1)
    return Unit_instance;
  $this.xco_1 = $this.pco_1.o43();
  $this.yco_1 = $this.wco_1;
  $this.mb9_1 = false;
  var m = $this.ube();
  var renderTilesCounter = ctx.f9m_1.la0('renderedTiles');
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var p = Companion_getInstance_18().t3i_1;
    if (m.g3j()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.y3k(m.r3m(p.r3i_1, p.s3i_1), m.u3m(p.r3i_1, p.s3i_1));
  }
  var _destruct__k2r9zo = tmp$ret$0;
  var posX = _destruct__k2r9zo.em();
  var posY = _destruct__k2r9zo.fm();
  var dUX = m.s3m($this.sco_1, 0.0) - posX;
  var dUY = m.t3m($this.sco_1, 0.0) - posY;
  var dVX = m.s3m(0.0, $this.tco_1) - posX;
  var dVY = m.t3m(0.0, $this.tco_1) - posY;
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>' call
  var width = $this.rco_1.v3s_1;
  // Inline function 'kotlin.math.min' call
  var a = m.r3m(width, 0.0) - posX;
  var b = m.u3m(0.0, width) - posY;
  var nextTileX = Math.min(a, b);
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>' call
  var height = $this.rco_1.w3s_1;
  // Inline function 'kotlin.math.min' call
  var a_0 = m.r3m(height, 0.0) - posX;
  var b_0 = m.u3m(0.0, height) - posY;
  var nextTileY = Math.min(a_0, b_0);
  var colMul = $this.tby();
  var pp0 = $this.vbg(Vector2D.y3k($this.dcp_1.i3j(), $this.dcp_1.d3q()));
  var pp1 = $this.vbg(Vector2D.y3k($this.dcp_1.j3j(), $this.dcp_1.c3q()));
  var pp2 = $this.vbg(Vector2D.y3k($this.dcp_1.j3j(), $this.dcp_1.d3q()));
  var pp3 = $this.vbg(Vector2D.y3k($this.dcp_1.i3j(), $this.dcp_1.c3q()));
  var mapTileWidth = $this.rco_1.v3s_1;
  var mapTileHeight = $this.rco_1.w3s_1;
  var mx0 = toIntCeil(pp0.r3i_1 / mapTileWidth);
  var mx1 = toIntCeil(pp1.r3i_1 / mapTileWidth);
  var mx2 = toIntCeil(pp2.r3i_1 / mapTileWidth);
  var mx3 = toIntCeil(pp3.r3i_1 / mapTileWidth);
  var my0 = toIntCeil(pp0.s3i_1 / mapTileHeight);
  var my1 = toIntCeil(pp1.s3i_1 / mapTileHeight);
  var my2 = toIntCeil(pp2.s3i_1 / mapTileHeight);
  var my3 = toIntCeil(pp3.s3i_1 / mapTileHeight);
  var ymin = min(my0, my1, my2, my3);
  var ymax = max(my0, my1, my2, my3);
  var xmin = min(mx0, mx1, mx2, mx3);
  var xmax = max(mx0, mx1, mx2, mx3);
  var doRepeatX = !$this.uco_1.equals(TileMapRepeat_NONE_getInstance());
  var doRepeatY = !$this.vco_1.equals(TileMapRepeat_NONE_getInstance());
  var doRepeatAny = doRepeatX || doRepeatY;
  var ymin2 = ((doRepeatAny ? ymin : clamp_1(ymin, $this.pco_1.q43(), $this.pco_1.t43())) - 1 | 0) - $this.gcp_1 | 0;
  var ymax2 = ((doRepeatAny ? ymax : clamp_1(ymax, $this.pco_1.q43(), $this.pco_1.t43())) + 1 | 0) + $this.gcp_1 | 0;
  var xmin2 = ((doRepeatAny ? xmin : clamp_1(xmin, $this.pco_1.p43(), $this.pco_1.s43())) - 1 | 0) - $this.gcp_1 | 0;
  var xmax2 = ((doRepeatAny ? xmax : clamp_1(xmax, $this.pco_1.p43(), $this.pco_1.s43())) + 1 | 0) + $this.gcp_1 | 0;
  var yheight = ymax2 - ymin2 | 0;
  var xwidth = xmax2 - xmin2 | 0;
  var ntiles = imul(imul(xwidth, yheight), $this.pco_1.r43());
  var allocTiles = get_nextPowerOfTwo(ntiles);
  var MAX_TILES = 16368;
  // Inline function 'kotlin.math.min' call
  var allocTilesClamped = Math.min(allocTiles, MAX_TILES);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.acp_1;
  var n = 0;
  while (n < this_0.g1()) {
    // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.h1(_unary__edvuaz);
    $this.bcp_1.g42(it);
  }
  $this.zco_1.h3();
  $this.acp_1.h3();
  var iterationCount = 0;
  var count = 0;
  var nblocks = 0;
  // Inline function 'korlibs.korge.render.Companion.quadIndices' call
  Companion_getInstance_14();
  var quadIndexData = TEXTURED_ARRAY_quadIndices(allocTilesClamped);
  var scaleOffsetX = 1.0 / $this.sco_1 * $this.pco_1.m6y_1;
  var scaleOffsetY = 1.0 / $this.tco_1 * $this.pco_1.m6y_1;
  var inductionVariable = ymin2;
  if (inductionVariable < ymax2)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = xmin2;
      if (inductionVariable_0 < xmax2)
        $l$loop_0: do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          iterationCount = iterationCount + 1 | 0;
          var rx = $this.uco_1.v6y_1(x, $this.pco_1.f3u());
          var ry = $this.vco_1.v6y_1(y, $this.pco_1.g3u());
          if (rx < $this.pco_1.p43() || rx >= $this.pco_1.s43())
            continue $l$loop_0;
          if (ry < $this.pco_1.q43() || ry >= $this.pco_1.t43())
            continue $l$loop_0;
          var inductionVariable_1 = 0;
          var last = $this.pco_1.u43(rx, ry);
          if (inductionVariable_1 < last)
            $l$loop_2: do {
              var level = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var cell = $this.pco_1.s6y(rx, ry, level);
              if (_Tile___get_isInvalid__impl__yfg9ed(cell))
                continue $l$loop_2;
              var cellData = _Tile___get_tile__impl__nfq1aw(cell);
              var flipX = _Tile___get_flipX__impl__jobqpf(cell);
              var flipY = _Tile___get_flipY__impl__95aqcs(cell);
              var rotate = _Tile___get_rotate__impl__5kjdv9(cell);
              var offsetX = _Tile___get_offsetX__impl__qwhdsd(cell);
              var offsetY = _Tile___get_offsetY__impl__1x539u(cell);
              var rationalOffsetX = offsetX * scaleOffsetX;
              var rationalOffsetY = offsetY * scaleOffsetY;
              var tmp0_elvis_lhs = getOrNull($this.icp_1, cellData);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_2;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var tex = tmp;
              count = count + 1 | 0;
              var tmp$ret$9;
              $l$block_1: {
                // Inline function 'korlibs.datastructure.FastIdentityCacheMap.getOrPut' call
                var this_1 = $this.zco_1;
                var key = tex.r4s();
                if (key === this_1.h3z_1) {
                  tmp$ret$9 = ensureNotNull(this_1.i3z_1);
                  break $l$block_1;
                }
                if (key === this_1.j3z_1) {
                  tmp$ret$9 = ensureNotNull(this_1.k3z_1);
                  break $l$block_1;
                }
                var tmp$ret$10;
                $l$block_2: {
                  // Inline function 'korlibs.datastructure.getOrPut' call
                  var this_2 = this_1.l3z_1;
                  var res = get(this_2, key);
                  if (!(res == null)) {
                    tmp$ret$10 = res;
                    break $l$block_2;
                  }
                  // Inline function 'korlibs.datastructure.FastIdentityCacheMap.getOrPut.<anonymous>' call
                  // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>' call
                  // Inline function 'kotlin.also' call
                  var this_3 = $this.bcp_1.f42();
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.korge.view.tiles.TileMap.computeVertexIfRequired.<anonymous>.<anonymous>' call
                  this_3.ect_1 = tex.r4s();
                  this_3.gct_1.h3();
                  this_3.hct(new ShrinkableTexturedVertexArray(new TexturedVertexArray(imul(allocTilesClamped, 4), quadIndexData)));
                  // Inline function 'kotlin.collections.plusAssign' call
                  $this.acp_1.h(this_3);
                  nblocks = nblocks + 1 | 0;
                  var out = this_3;
                  set(this_2, key, out);
                  tmp$ret$10 = out;
                }
                var value = tmp$ret$10;
                this_1.j3z_1 = this_1.h3z_1;
                this_1.k3z_1 = this_1.i3z_1;
                this_1.h3z_1 = key;
                this_1.i3z_1 = value;
                tmp$ret$9 = value;
              }
              var info = tmp$ret$9;
              // Inline function 'kotlin.run' call
              // Inline function 'kotlin.contracts.contract' call
              var px = x + rationalOffsetX;
              var py = y + rationalOffsetY;
              var p0X = posX + nextTileX * px + dVX * py;
              var p0Y = posY + dUY * px + nextTileY * py;
              var p1X = p0X + dUX;
              var p1Y = p0Y + dUY;
              var p2X = p0X + dUX + dVX;
              var p2Y = p0Y + dUY + dVY;
              var p3X = p0X + dVX;
              var p3Y = p0Y + dVY;
              $this.ecp_1[0] = tex.c4t();
              $this.ecp_1[1] = tex.e4t();
              $this.ecp_1[2] = tex.g4t();
              $this.ecp_1[3] = tex.i4t();
              $this.fcp_1[0] = tex.d4t();
              $this.fcp_1[1] = tex.f4t();
              $this.fcp_1[2] = tex.h4t();
              $this.fcp_1[3] = tex.j4t();
              var indices = Companion_getInstance_39().ict_1[transformIndex(Companion_getInstance_39(), flipX, flipY, rotate)];
              info.fct_1.u9z(p0X, p0Y, $this.ecp_1[indices[0]], $this.fcp_1[indices[0]], colMul);
              info.fct_1.u9z(p1X, p1Y, $this.ecp_1[indices[1]], $this.fcp_1[indices[1]], colMul);
              info.fct_1.u9z(p2X, p2Y, $this.ecp_1[indices[2]], $this.fcp_1[indices[2]], colMul);
              info.fct_1.u9z(p3X, p3Y, $this.ecp_1[indices[3]], $this.fcp_1[indices[3]], colMul);
              var _receiver__tnumb7 = info.fct_1;
              _receiver__tnumb7.t9z_1 = _receiver__tnumb7.t9z_1 + 6 | 0;
              if (info.fct_1.t9z_1 >= (MAX_TILES - 1 | 0)) {
                info.hct(new ShrinkableTexturedVertexArray(new TexturedVertexArray(imul(allocTilesClamped, 4), quadIndexData)));
                nblocks = nblocks + 1 | 0;
              }
            }
             while (inductionVariable_1 < last);
        }
         while (inductionVariable_0 < xmax2);
    }
     while (inductionVariable < ymax2);
  renderTilesCounter.da0(count);
  $this.hcp_1 = iterationCount;
}
function updatedTileSet($this) {
  var tmp = $this;
  var tmp_0 = 0;
  var tmp_1 = $this.lcp_1.t6z().length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = fillArrayVal(Array(tmp_1), null);
  while (tmp_0 < tmp_1) {
    var tmp_3 = tmp_0;
    tmp_2[tmp_3] = $this.lcp_1.t6z()[tmp_3];
    tmp_0 = tmp_0 + 1 | 0;
  }
  tmp.icp_1 = tmp_2;
  var tmp_4 = $this;
  var tmp_5 = 0;
  var tmp_6 = $this.lcp_1.t6z().length;
  var tmp_7 = new Int32Array(tmp_6);
  while (tmp_5 < tmp_6) {
    tmp_7[tmp_5] = 0;
    tmp_5 = tmp_5 + 1 | 0;
  }
  tmp_4.jcp_1 = tmp_7;
  var tmp_8 = $this;
  var tmp_9 = 0;
  var tmp_10 = $this.lcp_1.t6z().length;
  var tmp_11 = new Float64Array(tmp_10);
  while (tmp_9 < tmp_10) {
    tmp_11[tmp_9] = 0.0;
    tmp_9 = tmp_9 + 1 | 0;
  }
  tmp_8.kcp_1 = tmp_11;
  $this.rco_1 = $this.lcp_1.s6z();
  $this.sco_1 = $this.lcp_1.m6z_1;
  $this.tco_1 = $this.lcp_1.n6z_1;
}
function TileMap$infosPool$lambda(it) {
  it.u1w();
  return Unit_instance;
}
function TileMap$infosPool$lambda_0(it) {
  // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
  var tmp$ret$0 = get_Bitmaps_transparent();
  return new Info(get_bmp(tmp$ret$0), new ShrinkableTexturedVertexArray(Companion_getInstance_14().m9z_1));
}
function TileMap$lambda($tileset) {
  return function ($this$addFastUpdater, dt) {
    var this_0 = $tileset.z4l();
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.view.tiles.TileMap.<anonymous>.<anonymous>' call
      var tileIndex = n;
      var info = this_0[n];
      var tmp;
      if (!(info == null)) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp = !info.b6z_1.j1();
      } else {
        tmp = false;
      }
      if (tmp) {
        var aindex = $this$addFastUpdater.jcp_1[tileIndex];
        var currentFrame = info.b6z_1.h1(aindex);
        var _array__4zh2yp = $this$addFastUpdater.kcp_1;
        _array__4zh2yp[tileIndex] = _array__4zh2yp[tileIndex] + _FastDuration___get_milliseconds__impl__ffr17u(dt.u35_1);
        // Inline function 'korlibs.time.milliseconds' call
        var this_1 = $this$addFastUpdater.kcp_1[tileIndex];
        var tmp$ret$1 = toDuration(this_1, DurationUnit_MILLISECONDS_getInstance());
        if (Duration__compareTo_impl_pchp0f(tmp$ret$1, currentFrame.h6p()) >= 0) {
          var nextIndex = (aindex + 1 | 0) % info.b6z_1.g1() | 0;
          var _array__4zh2yp_0 = $this$addFastUpdater.kcp_1;
          _array__4zh2yp_0[tileIndex] = _array__4zh2yp_0[tileIndex] - get_milliseconds(currentFrame.h6p());
          $this$addFastUpdater.jcp_1[tileIndex] = nextIndex;
          $this$addFastUpdater.icp_1[tileIndex] = $tileset.t6z()[info.b6z_1.h1(nextIndex).kct_1];
          $this$addFastUpdater.wco_1 = $this$addFastUpdater.wco_1 + 1 | 0;
        }
      }
      n = n + 1 | 0;
    }
    return Unit_instance;
  };
}
function beforeStartingKorge(config) {
}
function completeViews(views) {
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForLambda(Korge$_init_$slambda_ys8r4w, VOID, VOID, [1]);
initMetadataForLambda(Korge$start$slambda, VOID, VOID, [1]);
initMetadataForClass(Korge, 'Korge', Korge, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KorgeDisplayMode, 'KorgeDisplayMode');
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$invoke$slambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KorgeRunner$invoke$slambda, VOID, VOID, [1]);
initMetadataForLambda(KorgeRunner$prepareViewsBase$lambda$slambda, VOID, VOID, [0]);
initMetadataForObject(KorgeRunner, 'KorgeRunner', VOID, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda, VOID, VOID, [1]);
initMetadataForLambda(Korge$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(KeysEvents$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(KeysEvents$lambda$slambda_1, VOID, VOID, [0]);
initMetadataForClass(KeysEvents, 'KeysEvents', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(MouseEventsUpdate, 'MouseEventsUpdate');
initMetadataForClass(MouseEvents, 'MouseEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SceneCancellationException, 'SceneCancellationException');
initMetadataForClass(Scene, 'Scene', VOID, VOID, [InjectorDependency, CoroutineScope], [0]);
initMetadataForClass(EmptyScene, 'EmptyScene', EmptyScene, VOID, VOID, [0]);
initMetadataForClass(VisitEntry, 'VisitEntry');
initMetadataForCompanion(Companion_2);
initMetadataForLambda(SceneContainer$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_0, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_1, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_2, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_3, VOID, VOID, [0]);
initMetadataForLambda(SceneContainer$_changeTo$slambda_4, VOID, VOID, [0]);
initMetadataForClass(BaseView, 'BaseView', BaseView.mc4);
initMetadataForClass(View, 'View');
initMetadataForClass(Container, 'Container', Container.bbk);
initMetadataForClass(CachedContainer, 'CachedContainer', CachedContainer.nc4);
initMetadataForClass(FixedSizeCachedContainer, 'FixedSizeCachedContainer', FixedSizeCachedContainer.lc4);
initMetadataForClass(UIView, 'UIView', UIView.jbt);
initMetadataForClass(SceneContainer, 'SceneContainer', VOID, VOID, [UIView, CoroutineScope], [2, 4, 6, 3]);
initMetadataForInterface(TransitionProcess, 'TransitionProcess');
initMetadataForClass(TransitionView, 'TransitionView', TransitionView.kbt);
protoOf(Transition$1).wbz = start;
protoOf(Transition$1).xbz = end;
initMetadataForClass(Transition$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1$create$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1);
initMetadataForObject(MsdfRender, 'MsdfRender');
initMetadataForClass(TweenComponent, 'TweenComponent');
initMetadataForLambda(tween$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_3);
initMetadataForClass(CacheTexture, 'CacheTexture', VOID, VOID, [AutoCloseable]);
initMetadataForObject(ZIndexComparator, 'ZIndexComparator', VOID, VOID, [Comparator]);
initMetadataForClass(ContainerCollection$iterator$1);
initMetadataForClass(ContainerCollection, 'ContainerCollection', VOID, VOID, [MutableIterable, Collection, KtList]);
initMetadataForClass(DummyView, 'DummyView', DummyView.rc9);
initMetadataForCompanion(Companion_4);
initMetadataForClass(FixedSizeContainer, 'FixedSizeContainer', FixedSizeContainer.tc9);
initMetadataForClass(SContainer, 'SContainer', SContainer.pbm);
initMetadataForClass(TimeSlidingWindow, 'TimeSlidingWindow');
initMetadataForClass(RectBase, 'RectBase', RectBase.aci);
initMetadataForClass(BaseImage, 'BaseImage');
initMetadataForInterface(ViewFileRef, 'ViewFileRef', VOID, VOID, VOID, [3]);
initMetadataForInterface(SmoothedBmpSlice, 'SmoothedBmpSlice');
protoOf(Image).dcf = forceLoadSourceFile$default;
initMetadataForClass(Image, 'Image', VOID, VOID, [BaseImage, ViewFileRef, SmoothedBmpSlice], [3]);
initMetadataForCompanion(Companion_5);
initMetadataForClass(Stage, 'Stage', VOID, VOID, [FixedSizeContainer, CoroutineScope, BoundsProvider]);
initMetadataForInterface(ColorReference, 'ColorReference');
initMetadataForCompanion(Companion_6);
initMetadataForInterface(ViewRenderPhase, 'ViewRenderPhase');
initMetadataForLambda(ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda, VOID, VOID, [0]);
protoOf(Mixin_0).dcf = forceLoadSourceFile$default;
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0, VOID, [ViewFileRef], [3]);
initMetadataForLambda(Views$close$slambda, VOID, VOID, [0]);
initMetadataForClass(Views, 'Views', VOID, VOID, [BaseEventListener, CoroutineScope, BoundsProvider, AutoCloseable, DeviceDimensionsProvider], [0]);
initMetadataForCompanion(Companion_7);
initMetadataForClass(ViewsUpdateEvent, 'ViewsUpdateEvent');
initMetadataForCompanion(Companion_8);
initMetadataForClass(ViewsResizedEvent, 'ViewsResizedEvent');
initMetadataForClass(ImageAnimationView, 'ImageAnimationView');
initMetadataForClass(ImageDataView, 'ImageDataView', ImageDataView.kcs);
initMetadataForCompanion(Companion_9);
initMetadataForInterface(Filter, 'Filter');
initMetadataForClass(RenderToTextureResult, 'RenderToTextureResult', RenderToTextureResult, VOID, [DisposableHandle]);
protoOf(IdentityFilter).ocs = get_recommendedFilterScale;
protoOf(IdentityFilter).pcs = computeBorder;
initMetadataForClass(IdentityFilter, 'IdentityFilter', VOID, VOID, [Filter]);
initMetadataForCompanion(Companion_10);
initMetadataForClass(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForClass(Info, 'Info');
initMetadataForCompanion(Companion_11);
initMetadataForClass(TileMap, 'TileMap', TileMap.pcp);
//endregion
//region block: init
KorgeRunner_instance = new KorgeRunner();
Companion_instance_15 = new Companion_1();
ZIndexComparator_instance = new ZIndexComparator();
Companion_instance_18 = new Companion_4();
Companion_instance_19 = new Companion_5();
Companion_instance_20 = new Companion_6();
Companion_instance_21 = new Companion_7();
Companion_instance_22 = new Companion_8();
//endregion
//region block: exports
export {
  views as views116j359zi8nvf,
  Korge_0 as Korge3fi4cwjkh8up9,
  Companion_getInstance_30 as Companion_getInstance2b4rje0hs8ulh,
  get_keys as get_keysmipauarvwdlb,
  get_mouse as get_mouse1jstwhfaumelj,
  drawText_0 as drawText3hdhgn63dhvlg,
  get_AlphaTransition as get_AlphaTransition23l7sd982osvm,
  SceneContainer as SceneContainer99ijjqni12hp,
  Scene as Scenezu810y12qpqp,
  withEasing as withEasingtnol1eyyo9sf,
  alignRightToLeftOf as alignRightToLeftOfl5ccxmwoj565,
  ImageDataView as ImageDataView3md3142sq0hvk,
  Container as Container7486fjmip554,
  FixedSizeContainer as FixedSizeContainersre0rworj71w,
  Stage as Stage1ggtrzujnnkl0,
  View as View11ybmmoof9vue,
  addFixedUpdater_1 as addFixedUpdaterkdt88bj87xku,
  addTo as addTo25e29vq105prw,
  addUpdater as addUpdater1la23qj9g2d42,
  findFirstAscendant as findFirstAscendante8nli1jx4t64,
};
//endregion
